function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C1.57669434 2.84225098 2.15338867 2.68450195 2.74755859 2.52197266 C6.33912918 1.68967503 9.95256416 1.58450137 13.625 1.375 C14.40101563 1.3234375 15.17703125 1.271875 15.9765625 1.21875 C21.75528921 0.8776446 21.75528921 0.8776446 24 2 C24 1.34 24 0.68 24 0 C24.7425 0.185625 25.485 0.37125 26.25 0.5625 C29.07739369 1.01231263 30.29414959 0.68015222 33 0 C34.58773306 -0.08428482 36.17859182 -0.11779948 37.76855469 -0.11352539 C39.17956451 -0.11341209 39.17956451 -0.11341209 40.61907959 -0.11329651 C41.62650208 -0.10813522 42.63392456 -0.10297394 43.671875 -0.09765625 C44.70942932 -0.0962413 45.74698364 -0.09482635 46.815979 -0.09336853 C50.12734876 -0.08777447 53.43865071 -0.07522303 56.75 -0.0625 C58.99609277 -0.05748423 61.24218661 -0.05292146 63.48828125 -0.04882812 C68.9922106 -0.03780699 74.49610046 -0.02107474 80 0 C80 1.32 80 2.64 80 4 C79.29101562 4.26554687 78.58203125 4.53109375 77.8515625 4.8046875 C68.41604821 8.75984828 60.14132212 14.90570571 52 21 C50.14706767 22.33504816 48.29290106 23.66838492 46.4375 25 C36.75256295 31.92029751 36.75256295 31.92029751 28.125 40.0625 C27.42375 40.701875 26.7225 41.34125 26 42 C23.6875 41.8125 23.6875 41.8125 22 41 C21.67 39.68 21.34 38.36 21 37 C20.401875 36.87625 19.80375 36.7525 19.1875 36.625 C17 36 17 36 14 34 C4.32261646 39.42094099 -4.29125228 45.26991822 -12.54052734 52.69189453 C-13.89324444 53.90431645 -15.26804332 55.09197822 -16.64453125 56.27734375 C-26.22451757 64.62022947 -34.32814563 73.74585236 -41.6875 84.0625 C-42.21714355 84.80113281 -42.74678711 85.53976562 -43.29248047 86.30078125 C-43.7773291 86.996875 -44.26217773 87.69296875 -44.76171875 88.41015625 C-45.19444092 89.03027588 -45.62716309 89.65039551 -46.07299805 90.28930664 C-47.23821635 92.11531974 -47.23821635 92.11531974 -47 95 C-48.485 95.495 -48.485 95.495 -50 96 C-51.04812535 98.19372234 -51.04812535 98.19372234 -52 101 C-52.56248016 102.22741448 -53.13907464 103.44841936 -53.7265625 104.6640625 C-54.190625 105.63472656 -54.190625 105.63472656 -54.6640625 106.625 C-55.30920436 107.96773427 -55.95769153 109.30886593 -56.609375 110.6484375 C-58.01994952 113.61182936 -59 115.67542825 -59 119 C-59.66 119 -60.32 119 -61 119 C-65.33324893 134.04306743 -69.39471315 149.40317887 -71 165 C-71.1340625 166.15371094 -71.268125 167.30742187 -71.40625 168.49609375 C-75.05753123 208.36974442 -62.9768999 249.60655463 -38.8359375 281.41015625 C-37 284 -37 284 -37 286 C-36.34 286 -35.68 286 -35 286 C-34.236875 287.051875 -33.47375 288.10375 -32.6875 289.1875 C-18.16891277 309.0976985 4.22060011 324.24416817 27 333 C26.40099158 336.54991306 25.44788874 339.54811143 23.9375 342.8125 C23.57527344 343.60269531 23.21304688 344.39289063 22.83984375 345.20703125 C22.56269531 345.79871094 22.28554688 346.39039063 22 347 C22.66 347 23.32 347 24 347 C24 347.66 24 348.32 24 349 C26.31 348.67 28.62 348.34 31 348 C31.33 348.66 31.66 349.32 32 350 C28.06154857 354.85256114 24.12364432 359.70197805 20.05859375 364.44921875 C19.57044189 365.02003174 19.08229004 365.59084473 18.5793457 366.17895508 C17.62922138 367.28698155 16.67605746 368.39241076 15.71948242 369.49487305 C13.13479416 372.51105082 10.93384236 375.52932927 9 379 C9.95261719 378.91621094 10.90523437 378.83242188 11.88671875 378.74609375 C13.14097656 378.64425781 14.39523437 378.54242187 15.6875 378.4375 C16.92886719 378.33308594 18.17023438 378.22867187 19.44921875 378.12109375 C22.55835533 378.01506159 25.00810972 378.22771475 28 379 C28 381 28 381 25.9375 383.1875 C24.43234757 384.65025377 22.90803525 386.0836639 21.35546875 387.49609375 C16.18262213 392.36534215 12.62032848 397.91476702 9 404 C12.52750871 405.17583624 15.30423052 405.12589715 19.02894592 405.12698364 C19.74880328 405.12854363 20.46866064 405.13010362 21.21033186 405.13171089 C23.62860453 405.13570767 26.04681472 405.13253635 28.46508789 405.12939453 C30.19625383 405.13074914 31.92741949 405.13252942 33.65858459 405.13470459 C38.36500987 405.13927142 43.07141328 405.13749252 47.77783895 405.1343255 C52.69632989 405.13179846 57.61481892 405.13414037 62.53330994 405.13571167 C70.79279925 405.13753218 79.05227962 405.13512997 87.31176758 405.13037109 C96.87129623 405.1249269 106.43080357 405.12669275 115.99033171 405.1321975 C124.1882343 405.13672985 132.38613047 405.13737863 140.58403391 405.13475883 C145.48461058 405.13319696 150.38517722 405.13299988 155.28575325 405.13629532 C159.89118261 405.13917585 164.49658436 405.13719496 169.10201073 405.13140106 C170.79597045 405.13007452 172.48993248 405.13046579 174.1838913 405.13266373 C176.48863854 405.13537933 178.79329625 405.13198906 181.09803772 405.12698364 C182.3901822 405.12660662 183.68232668 405.12622959 185.01362705 405.12584114 C187.9267703 405.20709848 187.9267703 405.20709848 190 404 C190 404.66 190 405.32 190 406 C190.66 405.67 191.32 405.34 192 405 C195.60208864 404.9408888 199.18966726 404.97928908 202.79101562 405.0390625 C206.12765021 405.07354968 208.81000229 405.06333257 212 404 C211.566875 403.443125 211.13375 402.88625 210.6875 402.3125 C209 400 209 400 207.73828125 397.76953125 C205.60242443 394.36655937 203.11652483 391.41488827 200.5 388.375 C199.77103516 387.51648438 199.77103516 387.51648438 199.02734375 386.640625 C196.77275617 383.99901012 194.51597151 381.39697286 192 379 C193.10859375 379.01160156 194.2171875 379.02320313 195.359375 379.03515625 C196.82291498 379.04453792 198.28645678 379.05363771 199.75 379.0625 C200.47960937 379.07087891 201.20921875 379.07925781 201.9609375 379.08789062 C205.48670558 379.10391684 208.61034916 378.95292713 212 378 C210.5489926 376.16086305 209.08898341 374.3288247 207.625 372.5 C206.81289063 371.4790625 206.00078125 370.458125 205.1640625 369.40625 C204.44992187 368.6121875 203.73578125 367.818125 203 367 C202.34 367 201.68 367 201 367 C200.64808594 365.92105469 200.64808594 365.92105469 200.2890625 364.8203125 C198.33535096 360.54582845 195.13094651 357.65956278 191.8984375 354.3046875 C190 352 190 352 190 349 C193.3 348.67 196.6 348.34 200 348 C199.37720331 346.41579871 198.75166599 344.83267469 198.125 343.25 C197.77695312 342.36828125 197.42890625 341.4865625 197.0703125 340.578125 C196.1353291 338.3259752 195.12219206 336.16350541 194 334 C196.15283808 331.84716192 197.09031088 331.55318536 199.9375 330.75 C233.65142449 319.88841667 260.50763691 286.96625553 276.2578125 256.7421875 C282.84260533 243.60937984 287.06145249 229.73095054 290.3125 215.4375 C290.47202148 214.73633057 290.63154297 214.03516113 290.79589844 213.31274414 C293.01677937 202.93760225 293.24254196 192.44935093 293.5625 181.875 C293.60581131 180.52342758 293.64942902 179.17186494 293.69335938 177.8203125 C293.79857434 174.54695806 293.90071479 171.27353875 294 168 C293.34 167.67 292.68 167.34 292 167 C291.60129138 163.37537614 291.4906422 159.76792661 291.34375 156.125 C291.2303125 155.09375 291.116875 154.0625 291 153 C290.34 152.67 289.68 152.34 289 152 C289.0825 150.989375 289.165 149.97875 289.25 148.9375 C289.26598492 144.50168439 288.25432762 140.3864313 287.125 136.125 C286.86444824 135.12521118 286.86444824 135.12521118 286.59863281 134.10522461 C285.76695679 131.09866198 285.24122266 129.24122266 283 127 C281 125 281 125 280 122 C280.1755542 121.35256836 280.3511084 120.70513672 280.53198242 120.03808594 C281.3617604 116.42463442 278.98740187 113.3733872 277.3125 110.25 C276.60026042 108.88020833 275.88802083 107.51041667 275.17578125 106.140625 C274.81564941 105.46451172 274.45551758 104.78839844 274.08447266 104.09179688 C273.33984265 102.65550919 272.62742889 101.20219877 271.94287109 99.73632812 C271.60465332 99.01380859 271.26643555 98.29128906 270.91796875 97.546875 C270.62043701 96.89041992 270.32290527 96.23396484 270.01635742 95.55761719 C269.00606105 93.65663219 269.00606105 93.65663219 266 93 C265.91234375 92.2884375 265.8246875 91.576875 265.734375 90.84375 C264.0998147 84.51417606 258.86274478 78.61437878 254.1875 74.125 C252 72 252 72 250.73828125 69.7578125 C248.55123808 66.28803166 245.91008295 63.61790783 243 60.75 C242.46632813 60.20859375 241.93265625 59.6671875 241.3828125 59.109375 C238.95302003 56.69167105 237.29461654 55.09820551 234 54 C234 53.34 234 52.68 234 52 C232.56906875 50.61817326 232.56906875 50.61817326 230.67578125 49.25 C229.97646484 48.7240625 229.27714844 48.198125 228.55664062 47.65625 C227.81607422 47.1096875 227.07550781 46.563125 226.3125 46 C225.59126953 45.4534375 224.87003906 44.906875 224.12695312 44.34375 C220.51993813 41.65578266 217.28560129 39.48783139 213 38 C212.525625 37.505 212.05125 37.01 211.5625 36.5 C208.97610342 34.01705928 205.56104676 33 202 33 C200.43727811 37.39253773 200.43727811 37.39253773 200 42 C198.68 42.33 197.36 42.66 196 43 C195.59910156 42.50371094 195.19820312 42.00742187 194.78515625 41.49609375 C184.46880958 29.16794251 169.9528846 21.07987628 156.5 12.5625 C155.85409912 12.14959717 155.20819824 11.73669434 154.54272461 11.3112793 C151.4981656 9.40306145 148.57052215 7.77094574 145.21875 6.46484375 C141.88234987 4.94645777 140.99401722 3.92993094 139 1 C149.84582345 -0.17420915 160.4944632 0.07091635 171.375 0.4375 C173.92611402 0.51705607 176.47728002 0.59466394 179.0284729 0.67164612 C180.60126712 0.71978281 182.1740072 0.76973771 183.74667358 0.82188416 C191.98979109 1.36853435 191.98979109 1.36853435 200 0 C200 0.66 200 1.32 200 2 C202.79173055 2.02690104 205.58320348 2.04679053 208.375 2.0625 C209.56609375 2.07506836 209.56609375 2.07506836 210.78125 2.08789062 C215.02392222 2.23040151 215.02392222 2.23040151 219 1 C218.50168276 4.68754757 217.89932357 6.60490662 215 9 C215.68532976 12.10729106 215.68532976 12.10729106 218.08203125 13.32421875 C219.43361328 13.99904297 219.43361328 13.99904297 220.8125 14.6875 C236.23092455 22.77520074 249.93353408 33.51161993 262.45800781 45.52978516 C263.87971881 46.88531771 265.32556686 48.21541412 266.7734375 49.54296875 C285.73080197 67.47185451 299.67442979 91.63322145 308.9921875 115.83984375 C309.80222768 118.16006062 309.80222768 118.16006062 312 119 C312.25658067 120.85807172 312.50167737 122.71838929 312.69140625 124.58447266 C313.25910047 129.02811711 314.42557699 133.34376128 315.5 137.6875 C315.94868673 139.52455167 316.39662804 141.3617856 316.84375 143.19921875 C317.04162109 144.00190186 317.23949219 144.80458496 317.44335938 145.6315918 C317.83649986 147.30433559 318.18810515 148.98710162 318.50976562 150.67504883 C318.89978926 153.01045538 318.89978926 153.01045538 320 155 C320.15175549 156.59262066 320.24900325 158.19064856 320.31640625 159.7890625 C320.35830078 160.73007812 320.40019531 161.67109375 320.44335938 162.640625 C320.50233398 164.11789062 320.50233398 164.11789062 320.5625 165.625 C320.60568359 166.61757813 320.64886719 167.61015625 320.69335938 168.6328125 C320.79960947 171.08837033 320.90032455 173.54416651 321 176 C325.95 176 330.9 176 336 176 C336.29021493 160.26390156 333.65801668 144.70298952 330 129.4375 C329.62657471 127.87805664 329.62657471 127.87805664 329.24560547 126.28710938 C327.90532202 120.93299738 326.34812189 115.99557943 324 111 C323.649375 110.21625 323.29875 109.4325 322.9375 108.625 C322.09342817 106.81702356 322.09342817 106.81702356 320 106 C320.99 106 321.98 106 323 106 C322.01 105.34 321.02 104.68 320 104 C319.8125 101.375 319.8125 101.375 320 99 C319.34 98.67 318.68 98.34 318 98 C317.236875 98.680625 316.47375 99.36125 315.6875 100.0625 C314.800625 100.701875 313.91375 101.34125 313 102 C312.01 101.67 311.02 101.34 310 101 C310 99.35 310 97.7 310 96 C309.34 95.67 308.68 95.34 308 95 C307.58978112 92.73297095 307.30144148 90.4437641 307.0625 88.15234375 C306.89834636 86.68444986 306.73156451 85.2168481 306.5625 83.74951172 C306.47355469 82.97339539 306.38460938 82.19727905 306.29296875 81.39764404 C305.50160668 74.92116984 304.4300064 68.48102464 303.39550781 62.03979492 C302.99227373 59.51410587 302.60170779 56.98662819 302.2109375 54.45898438 C301.95389669 52.84883495 301.69611375 51.23880378 301.4375 49.62890625 C301.322854 48.87493057 301.20820801 48.1209549 301.09008789 47.34413147 C300.79455384 45.55025394 300.40606096 43.7721319 300 42 C299.34 41.67 298.68 41.34 298 41 C298.185625 40.319375 298.37125 39.63875 298.5625 38.9375 C299.08523943 35.42767809 298.61378577 32.47811937 298 29 C298.99 28.67 299.98 28.34 301 28 C301.40734375 28.73605469 301.8146875 29.47210938 302.234375 30.23046875 C304.01323386 33.02075842 305.86452294 35.0312833 308.25 37.3125 C311.08615857 40.08026246 313.80841098 42.85584818 316.375 45.875 C319.26214819 49.24557765 322.34247378 52.38503521 325.5 55.5 C328.59492241 58.55337286 331.61934317 61.62323732 334.4375 64.9375 C339.27571924 70.61766426 344.68897018 75.7674583 350 81 C347.63707344 83.52588702 346.33537489 84.88820837 343 86 C341.56934524 87.70821006 341.56934524 87.70821006 341 90 C341.56360845 92.54709021 341.56360845 92.54709021 342.81640625 95.19140625 C343.24880615 96.20912109 343.68120605 97.22683594 344.12670898 98.27539062 C344.83742554 99.90250977 344.83742554 99.90250977 345.5625 101.5625 C352.32532364 117.74018933 356.25505429 133.73280773 359 151 C359.17917969 152.00289062 359.35835937 153.00578125 359.54296875 154.0390625 C368.21633994 210.23064676 350.03517566 269.03436192 318 315 C310.68725087 324.89513909 302.48624392 334.10373258 294 343 C292.69482422 344.38445312 292.69482422 344.38445312 291.36328125 345.796875 C273.00026038 364.77646445 247.1686972 383.61043427 222 392 C223.55872329 397.42271628 226.19629781 401.74773075 229.25390625 406.40820312 C232 410.69834592 232 410.69834592 232 414 C231.10925781 414.1753125 230.21851563 414.350625 229.30078125 414.53125 C214.13456462 418.03266956 201.08678594 426.29637913 187.74584961 433.99438477 C183.21847415 436.60216822 178.67017903 439.17342601 174.125 441.75 C173.20138672 442.27585693 172.27777344 442.80171387 171.32617188 443.34350586 C163.81707237 447.59738698 156.18509099 451.58481064 148.51367188 455.53637695 C139.29898744 460.30758856 130.31580903 465.45147549 121.34082031 470.65576172 C117.58416991 472.81305387 113.79423769 474.90970343 110 477 C109.22253418 476.51168701 108.44506836 476.02337402 107.64404297 475.52026367 C99.6085317 470.51827465 91.43896824 465.83992925 83.125 461.3125 C80.58608943 459.92527171 78.04852252 458.53560817 75.51171875 457.14453125 C74.88159378 456.79919342 74.25146881 456.45385559 73.60224915 456.09805298 C69.42323649 453.80100856 65.27687473 451.45425081 61.14453125 449.07421875 C60.09313965 448.46989014 59.04174805 447.86556152 57.95849609 447.24291992 C55.9872636 446.1056459 54.01993172 444.9615761 52.05712891 443.80981445 C51.1810498 443.30538818 50.3049707 442.80096191 49.40234375 442.28125 C48.64429443 441.83845703 47.88624512 441.39566406 47.10522461 440.93945312 C44.77542213 439.72832423 44.77542213 439.72832423 41 440 C40.67 439.01 40.34 438.02 40 437 C37.82163937 435.72608761 35.71508066 434.62560475 33.4375 433.5625 C32.79925293 433.25393066 32.16100586 432.94536133 31.50341797 432.62744141 C29.67300743 431.74316938 27.8366428 430.87125367 26 430 C21.87318564 428.01301531 17.91323595 425.98677664 14.0625 423.5 C7.2665776 419.19103942 1.05694624 416.58595973 -7 416 C-7 415.34 -7 414.68 -7 414 C-8.65 414.33 -10.3 414.66 -12 415 C-11.37923266 411.70402104 -10.19348804 409.58987247 -8.25 406.875 C-4.98943287 402.14166463 -2.44906784 397.19072343 0 392 C-2.64 391.67 -5.28 391.34 -8 391 C-8 390.01 -8 389.02 -8 388 C-9.64935547 387.14728516 -9.64935547 387.14728516 -11.33203125 386.27734375 C-19.02959828 382.26770384 -26.5649238 378.21512909 -33.80078125 373.41015625 C-35.95212361 371.97349738 -35.95212361 371.97349738 -38.1875 370.91796875 C-40 370 -40 370 -41.6875 368.25 C-45.53610712 364.50540929 -50.19233836 361.40383082 -55 359 C-55.90273093 357.9822715 -56.77342404 356.93590189 -57.625 355.875 C-59.78978796 353.30009634 -61.99482071 351.04639898 -64.5625 348.875 C-95.28561408 322.5492782 -122.12683167 281.91587536 -129.47265625 241.74121094 C-129.64667969 241.16661133 -129.82070313 240.59201172 -130 240 C-130.66 239.67 -131.32 239.34 -132 239 C-132 236.69 -132 234.38 -132 232 C-132.66 231.67 -133.32 231.34 -134 231 C-133.67 230.01 -133.34 229.02 -133 228 C-133.99 228.33 -134.98 228.66 -136 229 C-136 228.34 -136 227.68 -136 227 C-135.34 227 -134.68 227 -134 227 C-134 225.68 -134 224.36 -134 223 C-134.66 222.67 -135.32 222.34 -136 222 C-136.34375 219.8671875 -136.34375 219.8671875 -136.5 216.875 C-136.76673902 212.45683193 -137.07583616 208.05812498 -137.50390625 203.65234375 C-141.37196508 163.66543733 -136.32268062 124.62433551 -119 88 C-119.62648438 87.8659375 -120.25296875 87.731875 -120.8984375 87.59375 C-123.37795711 86.89321658 -124.2842551 85.87172171 -126 84 C-126.66 83.67 -127.32 83.34 -128 83 C-127.53292113 78.65413572 -124.93340749 76.66673739 -121.875 73.75 C-117.97424432 69.97479166 -114.28333016 66.12227932 -110.76953125 61.984375 C-107.91793313 58.78655636 -104.81495477 55.84605015 -101.72265625 52.8828125 C-99.7749896 51.17939784 -99.7749896 51.17939784 -100 49 C-99.01 49 -98.02 49 -97 49 C-97 48.34 -97 47.68 -97 47 C-96.34 47 -95.68 47 -95 47 C-94.79503906 46.46632813 -94.59007812 45.93265625 -94.37890625 45.3828125 C-92.42167354 42.00062566 -89.7403035 39.56962512 -86.9375 36.875 C-82.9955106 33.30446634 -82.9955106 33.30446634 -80 29 C-79.01 29.33 -78.02 29.66 -77 30 C-77.15557373 30.90314941 -77.31114746 31.80629883 -77.47143555 32.73681641 C-78.21094183 37.03273732 -78.94940192 41.32883696 -79.6875 45.625 C-79.82216675 46.40832703 -79.9568335 47.19165405 -80.09558105 47.99871826 C-81.56633225 56.55801872 -83.02779988 65.11855501 -84.44140625 73.6875 C-84.55340866 74.36541595 -84.66541107 75.04333191 -84.7808075 75.74179077 C-85.30746929 78.93228421 -85.83106165 82.12323738 -86.3503418 85.31494141 C-87.38383465 91.59712989 -88.54610622 97.8011256 -90 104 C-90.66 104 -91.32 104 -92 104 C-92 103.01 -92 102.02 -92 101 C-92.66 101 -93.32 101 -94 101 C-94 100.34 -94 99.68 -94 99 C-95.32 98.67 -96.64 98.34 -98 98 C-108.23802294 123.41331729 -112.25886993 148.9273095 -115 176 C-109.72 176 -104.44 176 -99 176 C-98.896875 173.586875 -98.79375 171.17375 -98.6875 168.6875 C-97.73500963 151.52094986 -94.25513837 135.35041489 -89 119 C-88.76941895 118.28215332 -88.53883789 117.56430664 -88.30126953 116.82470703 C-77.40938895 83.7852116 -55.04972255 54.50558882 -28 33 C-27.03320312 32.20464844 -26.06640625 31.40929687 -25.0703125 30.58984375 C-15.99769154 23.30635288 -6.16546788 17.62578521 4 12 C2.88145414 8.27385847 2.88145414 8.27385847 0 6 C0 4.02 0 2.04 0 0 Z M282 121 C283 123 283 123 283 123 Z M-115 189 C-114.71564502 192.00085254 -114.42273122 195.00046906 -114.125 198 C-114.04636719 198.83917969 -113.96773438 199.67835938 -113.88671875 200.54296875 C-113.35028977 205.86599475 -112.4211444 210.84088756 -111 216 C-106.05 216 -101.1 216 -96 216 C-94.05951587 212.11903174 -95.68630357 207.18294363 -96.25 203 C-96.37246094 201.97648438 -96.49492187 200.95296875 -96.62109375 199.8984375 C-96.75128906 198.92132812 -96.88148438 197.94421875 -97.015625 196.9375 C-97.13196289 196.03902344 -97.24830078 195.14054688 -97.36816406 194.21484375 C-97.84545432 191.63506006 -97.84545432 191.63506006 -101 190 C-101 189.67 -101 189.34 -101 189 C-102.95764383 188.80543295 -104.91615321 188.61955753 -106.875 188.4375 C-107.96554687 188.33308594 -109.05609375 188.22867188 -110.1796875 188.12109375 C-112.95152023 187.77360596 -112.95152023 187.77360596 -115 189 Z M-100 189 C-99.34 189.66 -98.68 190.32 -98 191 C-98 190.34 -98 189.68 -98 189 C-98.66 189 -99.32 189 -100 189 Z M320 189 C319.34 197.91 318.68 206.82 318 216 C323.28 216 328.56 216 334 216 C336.13558445 207.03054531 336.59548143 198.17618442 337 189 C336.00097656 189 335.00195312 189 333.97265625 189 C329.31510417 189 324.65755208 189 320 189 Z M-104 227 C-104 227.66 -104 228.32 -104 229 C-104.99 229 -105.98 229 -107 229 C-106.4115657 234.1621736 -105.25402402 238.85097013 -103.5 243.75 C-103.24589355 244.46792725 -102.99178711 245.18585449 -102.72998047 245.92553711 C-99.44847758 254.89812561 -95.22680427 263.44306957 -91 272 C-90.34 272 -89.68 272 -89 272 C-88.95875 272.804375 -88.9175 273.60875 -88.875 274.4375 C-87.83927974 278.65436108 -85.97148922 281.35196841 -83.47265625 284.8515625 C-82 287 -82 287 -81.08203125 288.90625 C-65.29131629 319.46156848 -28.95788053 348.83386926 2 363 C3.3242287 363.36784131 4.65613912 363.71202981 6 364 C6.83905565 362.87926138 7.67107831 361.75325453 8.5 360.625 C8.9640625 359.99851562 9.428125 359.37203125 9.90625 358.7265625 C11.17838101 357.05905387 11.17838101 357.05905387 11 355 C9.33710938 354.18595703 9.33710938 354.18595703 7.640625 353.35546875 C6.17697731 352.63302726 4.7134415 351.91035908 3.25 351.1875 C2.52039063 350.83107422 1.79078125 350.47464844 1.0390625 350.10742188 C-1.93671938 348.63305721 -4.6732175 347.24728005 -7.328125 345.23828125 C-9.05504418 343.70240868 -9.05504418 343.70240868 -12 344 C-12 343.34 -12 342.68 -12 342 C-14.09491059 340.40315893 -16.19591819 338.91135475 -18.375 337.4375 C-23.85730816 333.63230431 -28.9024318 329.62477205 -33.78515625 325.05859375 C-35.73942554 323.24219178 -37.74774385 321.5620045 -39.8125 319.875 C-49.82266349 311.12372117 -58.02872178 300.25100777 -65 289 C-65.44472656 288.30777344 -65.88945312 287.61554688 -66.34765625 286.90234375 C-70.08574551 281.04880848 -73.52361249 275.01104469 -77 269 C-77.33 269.66 -77.66 270.32 -78 271 C-78 269.68 -78 268.36 -78 267 C-78.60141449 265.06070792 -78.60141449 265.06070792 -79.49609375 263.14453125 C-79.96305664 262.08782227 -79.96305664 262.08782227 -80.43945312 261.00976562 C-80.76880859 260.28466797 -81.09816406 259.55957031 -81.4375 258.8125 C-81.76298828 258.07580078 -82.08847656 257.33910156 -82.42382812 256.58007812 C-83.82100677 253.04170193 -83.82100677 253.04170193 -86 250 C-86.34617051 248.33595227 -86.67631613 246.66856754 -87 245 C-87.59402747 242.74162528 -88.22075655 240.49167136 -88.875 238.25 C-89.20242188 237.10015625 -89.52984375 235.9503125 -89.8671875 234.765625 C-90.42792969 233.39664063 -90.42792969 233.39664063 -91 232 C-91.99 231.67 -92.98 231.34 -94 231 C-94.33 229.68 -94.66 228.36 -95 227 C-97.97 227 -100.94 227 -104 227 Z M316 227 C314.42750456 231.11665225 312.90325037 235.23134719 311.52734375 239.41796875 C303.30909539 264.27080673 291.32076709 287.19439713 274 307 C273.28585937 307.82242188 272.57171875 308.64484375 271.8359375 309.4921875 C269.59199546 312.0291529 267.30736336 314.52068408 265 317 C264.34902344 317.71671875 263.69804688 318.4334375 263.02734375 319.171875 C248.19520471 334.83278482 229.03032003 346.21830889 210 356 C212.37629089 360.14670039 212.37629089 360.14670039 216 363 C216.66 363.66 217.32 364.32 218 365 C229.73010408 358.79882217 240.69839412 352.04064008 251.38452148 344.16992188 C252.89615644 343.07520301 254.44706118 342.03529255 256 341 C256 340.34 256 339.68 256 339 C256.55558594 338.75121094 257.11117187 338.50242187 257.68359375 338.24609375 C266.75964239 333.36369996 275.20046232 324.69386759 282 317 C282 316.34 282 315.68 282 315 C282.99 314.67 283.98 314.34 285 314 C288.26291418 310.56034463 291.10591678 306.75214412 294 303 C294.45004395 302.41814941 294.90008789 301.83629883 295.36376953 301.23681641 C302.0363369 292.54396345 307.86638279 283.69829583 313 274 C313.48847412 273.09459473 313.48847412 273.09459473 313.98681641 272.17089844 C318.36062749 264.02038359 322.05342197 255.69571324 325.375 247.0625 C325.70886719 246.19874756 326.04273438 245.33499512 326.38671875 244.44506836 C328.41824205 239.01983524 329.96865528 233.70639633 331 228 C329.86298403 226.63467451 329.86298403 226.63467451 326.83984375 226.90234375 C325.55207031 226.91394531 324.26429688 226.92554688 322.9375 226.9375 C321.64714844 226.94652344 320.35679687 226.95554687 319.02734375 226.96484375 C318.02832031 226.97644531 317.02929688 226.98804688 316 227 Z M-93 228 C-92 230 -92 230 -92 230 Z M40 417 C40 417.66 40 418.32 40 419 C40.66 418.67 41.32 418.34 42 418 C41.34 417.67 40.68 417.34 40 417 Z M43 418 C42.67 418.66 42.34 419.32 42 420 C44.0780065 421.17713663 46.16151783 422.34171974 48.25 423.5 C48.83652344 423.83386719 49.42304688 424.16773438 50.02734375 424.51171875 C53.38582107 426.36076806 55.06645784 427 59 427 C59 427.66 59 428.32 59 429 C59.63687744 429.32572998 60.27375488 429.65145996 60.92993164 429.98706055 C73.98707226 436.68084461 86.92480671 443.48064561 99.56079102 450.94799805 C105.88317775 454.88968007 105.88317775 454.88968007 113 456 C116.75784929 454.53670368 120.22757749 452.64175257 123.75 450.6875 C124.76481445 450.14077637 125.77962891 449.59405273 126.82519531 449.03076172 C129.89348803 447.37145751 132.9481293 445.68928482 136 444 C136.87527344 443.51901855 137.75054688 443.03803711 138.65234375 442.54248047 C143.16677576 440.06150411 147.66655425 437.55553397 152.15771484 435.03271484 C162.00882056 429.51056044 172.01222818 424.26904727 182 419 C182 418.67 182 418.34 182 418 C136.13 418 90.26 418 43 418 Z ",
  fill: "#F9F8F8",
  transform: "translate(400,344)"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C2.9590625 1.7215625 2.9590625 1.7215625 3.9375 1.4375 C8.07334611 0.84666484 11.8851173 1.41728241 16 2 C16.6171875 3.83984375 16.6171875 3.83984375 17 6 C15.125 8.5625 15.125 8.5625 13 11 C12.67 11.99 12.34 12.98 12 14 C12.99 14.495 12.99 14.495 14 15 C14.495 15.495 14.495 15.495 15 16 C15.33 15.01 15.66 14.02 16 13 C16 13.66 16 14.32 16 15 C16.99 15 17.98 15 19 15 C19 14.34 19 13.68 19 13 C19.66 13 20.32 13 21 13 C21 12.34 21 11.68 21 11 C21.99 11.33 22.98 11.66 24 12 C24.19491452 13.45736087 24.38069358 14.91594593 24.5625 16.375 C24.66691406 17.18710938 24.77132812 17.99921875 24.87890625 18.8359375 C25 21 25 21 24 23 C24.66 23 25.32 23 26 23 C26 24.98 26 26.96 26 29 C24.25 29.6875 24.25 29.6875 22 30 C19.56665433 28.5399926 18.27382218 27.54764436 17 25 C13.87802522 26.3089572 13.87802522 26.3089572 12 29 C12.66 29 13.32 29 14 29 C15.01351664 30.65848177 16.01120795 32.32665961 17 34 C17.99 34.928125 17.99 34.928125 19 35.875 C22.37070491 39.45637396 23.80478156 43.3406433 24.375 48.1875 C23.9566149 51.32538824 23.12350253 52.69953892 21 55 C21.66 55.33 22.32 55.66 23 56 C23 57.32 23 58.64 23 60 C23.66 60 24.32 60 25 60 C24.814375 60.7425 24.62875 61.485 24.4375 62.25 C23.81538234 64.87768296 23.81538234 64.87768296 24.5625 66.875 C25.24366225 70.18350237 24.02924404 72.85172412 23 76 C25.97065509 75.65772428 25.97065509 75.65772428 29 75 C29.33 74.34 29.66 73.68 30 73 C34.29581527 71.73238238 37.50944298 71 42 71 C42.33 70.34 42.66 69.68 43 69 C44.76245117 68.32983398 44.76245117 68.32983398 47.04296875 67.74609375 C48.28336914 67.42415039 48.28336914 67.42415039 49.54882812 67.09570312 C50.8549707 66.76989258 50.8549707 66.76989258 52.1875 66.4375 C53.03892578 66.21642578 53.89035156 65.99535156 54.76757812 65.76757812 C62.69187271 63.73900774 70.28288624 62.78873131 78.4296875 62.39453125 C82.34315481 62.24938994 82.34315481 62.24938994 86 61 C86.84498047 61.68642578 86.84498047 61.68642578 87.70703125 62.38671875 C90.02046095 64.01439586 92.03076703 64.87558451 94.6875 65.8125 C106.41592406 70.39364655 115.57119869 78.47473929 120.97265625 89.96875 C122.7873472 95.32312328 123.58899562 100.85879159 124.421875 106.4375 C124.79069073 109.82985208 124.79069073 109.82985208 126 112 C125.01 112 124.02 112 123 112 C122.95875 113.155 122.9175 114.31 122.875 115.5 C121.56540877 127.10443337 115.53422731 138.38176085 110.515625 148.79296875 C109.23609836 151.50042073 108.07342093 154.20594846 107 157 C106.34 157 105.68 157 105 157 C100.21629362 167.75820663 99.67633213 180.92085906 98.25 192.5 C98.11021729 193.61665039 97.97043457 194.73330078 97.82641602 195.88378906 C97.70322998 196.92245117 97.58004395 197.96111328 97.453125 199.03125 C97.34129883 199.96517578 97.22947266 200.89910156 97.11425781 201.86132812 C97.07655273 202.56708984 97.03884766 203.27285156 97 204 C97.33 204.33 97.66 204.66 98 205 C98.04080783 206.99958364 98.04254356 209.00045254 98 211 C97.071875 210.835 96.14375 210.67 95.1875 210.5 C90.14266379 209.76299718 85.08564289 209.91723185 80 210 C80 209.67 80 209.34 80 209 C56.39051382 207.1976469 32.88101801 206.65250567 9.20776367 206.68432617 C5.4459235 206.68896419 1.68440622 206.6819854 -2.07739258 206.66381836 C-40.74876951 206.08226436 -40.74876951 206.08226436 -79 211 C-81.13031092 202.39602581 -81.58440013 193.8150919 -82 185 C-82.99 185 -83.98 185 -85 185 C-84.79375 184.113125 -84.5875 183.22625 -84.375 182.3125 C-83.06373945 172.0477885 -86.24491647 163.82919202 -91.17700195 155.10571289 C-94.80261392 148.62093133 -97.72611324 141.92543365 -100.5625 135.0625 C-101.00400391 134.00119873 -101.44550781 132.93989746 -101.90039062 131.84643555 C-105 124.28035805 -105 124.28035805 -105 122 C-105.99 121.67 -106.98 121.34 -108 121 C-107.505 120.505 -107.505 120.505 -107 120 C-107.99 119.34 -108.98 118.68 -110 118 C-109.01 117.505 -109.01 117.505 -108 117 C-108.03480469 116.05640625 -108.06960938 115.1128125 -108.10546875 114.140625 C-108.40397207 99.98303891 -106.19949284 88.36697817 -96.6875 77.3125 C-95.800625 76.549375 -94.91375 75.78625 -94 75 C-93.36449219 74.43539062 -92.72898437 73.87078125 -92.07421875 73.2890625 C-83.97431283 66.46960352 -75.47515506 63.68689541 -65 63 C-65 62.34 -65 61.68 -65 61 C-62.36 61.33 -59.72 61.66 -57 62 C-57 62.66 -57 63.32 -57 64 C-53.04 64 -49.08 64 -45 64 C-45 64.66 -45 65.32 -45 66 C-36.51017403 67.55810358 -36.51017403 67.55810358 -28 69 C-28 69.66 -28 70.32 -28 71 C-27.18208984 71.18175781 -27.18208984 71.18175781 -26.34765625 71.3671875 C-20.8984375 72.578125 -15.44921875 73.7890625 -10 75 C-9.67 71.7 -9.34 68.4 -9 65 C-9.66 65 -10.32 65 -11 65 C-10.34 63.68 -9.68 62.36 -9 61 C-9.66 61 -10.32 61 -11 61 C-10.67 60.01 -10.34 59.02 -10 58 C-10 58.66 -10 59.32 -10 60 C-9.34 60 -8.68 60 -8 60 C-7.67 58.35 -7.34 56.7 -7 55 C-5.68 55 -4.36 55 -3 55 C-4.65 54.67 -6.3 54.34 -8 54 C-9.34413416 47.40152323 -8.77292637 42.19506963 -6 36 C-3.6722683 33.22438497 -1.40759852 32.19726435 2 31 C2 30.34 2 29.68 2 29 C2.66 29 3.32 29 4 29 C3.505 27.02 3.505 27.02 3 25 C2.30132812 25.3609375 1.60265625 25.721875 0.8828125 26.09375 C-0.02726562 26.5578125 -0.93734375 27.021875 -1.875 27.5 C-2.77992188 27.9640625 -3.68484375 28.428125 -4.6171875 28.90625 C-7 30 -7 30 -9 30 C-9.87460154 26.50159382 -9.85970794 24.43883174 -9 21 C-8.93451508 19.41788427 -8.91421619 17.83329919 -8.9375 16.25 C-8.958125 14.8475 -8.97875 13.445 -9 12 C-5.37 12.33 -1.74 12.66 2 13 C0.97388039 10.43470097 -0.06213152 7.86952381 -1.25 5.375 C-1.4975 4.59125 -1.745 3.8075 -2 3 C-1.34 2.01 -0.68 1.02 0 0 Z M0 14 C1 16 1 16 1 16 Z M5 54 C9 55 9 55 9 55 Z M-89.79296875 84.88671875 C-97.18595152 94.17814648 -98.07948846 103.52333323 -97 115 C-96.01507841 118.55595067 -94.74791497 121.7538722 -93 125 C-90.23862716 124.43855905 -89.175283 124.175283 -87.125 122.125 C-83.39585852 118.39585852 -79.15134554 116.74450103 -74 116 C-72.04028257 116.14951523 -70.08187641 116.31701935 -68.125 116.5 C-63.54892474 116.5746117 -63.54892474 116.5746117 -59.83984375 114.140625 C-58.11405837 111.81934884 -56.55479927 109.43782386 -55 107 C-48.08505405 100.43966666 -40.00695913 97.67883095 -30.609375 97.7734375 C-24.95272564 98.2645837 -18.91523989 99.51874298 -13.83203125 102.1015625 C-11.8911555 103.22015427 -11.8911555 103.22015427 -9 103 C-8.77857745 101.04310341 -8.5732432 99.08438048 -8.375 97.125 C-8.20097656 95.48917969 -8.20097656 95.48917969 -8.0234375 93.8203125 C-8.01570313 92.88960937 -8.00796875 91.95890625 -8 91 C-8.99 90.01 -8.99 90.01 -10 89 C-10.99 88.01 -10.99 88.01 -12 87 C-17.03787145 84.47527362 -21.41003031 83.65062689 -27 84 C-27 83.34 -27 82.68 -27 82 C-27.62648438 81.87882812 -28.25296875 81.75765625 -28.8984375 81.6328125 C-29.71570313 81.46523437 -30.53296875 81.29765625 -31.375 81.125 C-32.18710937 80.96257812 -32.99921875 80.80015625 -33.8359375 80.6328125 C-36 80 -36 80 -38 78 C-55.54218572 72.00678443 -75.93402024 70.30311933 -89.79296875 84.88671875 Z M60.4375 75.5 C59.72295654 75.66943115 59.00841309 75.8388623 58.2722168 76.01342773 C46.26612446 79.02803839 33.9475971 83.17217468 23 89 C23 93.29 23 97.58 23 102 C27.30665086 103.09688314 27.30665086 103.09688314 30.8125 101.1875 C38.18460383 97.7439515 46.58923236 95.81025347 54.5625 97.9609375 C57.47636489 99.17271304 60.23671838 100.47948899 63 102 C63.66 102.33 64.32 102.66 65 103 C66.48069381 104.22343041 67.93573483 105.47809124 69.375 106.75 C70.59703125 107.82507813 70.59703125 107.82507813 71.84375 108.921875 C74 111 74 111 75.875 114 C78.57167096 116.53804326 79.56576666 116.21516763 83.1875 116.125 C84.15429688 116.08117187 85.12109375 116.03734375 86.1171875 115.9921875 C93.10243011 116.0111177 98.40780615 119.06004524 104 123 C105.65525034 123.69452756 107.32063134 124.36601015 109 125 C113.39174488 113.94221378 115.09649676 103.95579213 110.44921875 92.671875 C105.12770641 82.86078487 97.38407764 77.46135921 87 74 C85.50139149 73.93212824 83.99997593 73.91500036 82.5 73.9375 C81.33984375 73.95103516 81.33984375 73.95103516 80.15625 73.96484375 C79.4446875 73.97644531 78.733125 73.98804688 78 74 C75.92814973 74 73.85612613 73.9666428 71.78515625 73.90625 C67.84930298 74.00373243 64.24656572 74.58654283 60.4375 75.5 Z ",
  fill: "#F7F7F7",
  transform: "translate(502,131)"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C1.47405477 1.73106944 2.65762287 3.47330899 3.8359375 5.4140625 C4.5578125 6.1978125 5.2796875 6.9815625 6.0234375 7.7890625 C12.02589376 16.48227502 11.48080903 26.94155107 11.74414062 37.109375 C12.13580723 45.25956098 13.6112289 50.14166639 18.8359375 56.4140625 C19.39539063 57.21714844 19.95484375 58.02023437 20.53125 58.84765625 C21.23894531 59.83958984 21.23894531 59.83958984 21.9609375 60.8515625 C41.96535923 89.38465511 48.38404206 110.32438203 47.63583374 145.03482056 C47.60307414 146.55588804 47.5736885 148.07703268 47.54800415 149.59823608 C47.30084787 162.9164763 45.39359697 175.38084645 40.6484375 187.9140625 C40.34655518 188.71739014 40.04467285 189.52071777 39.73364258 190.34838867 C31.81140153 210.74800707 17.48709165 228.37481987 2.68359375 244.22265625 C0.99057016 246.23066098 -0.1215428 248.01790466 -1.1640625 250.4140625 C-0.1740625 250.7440625 0.8159375 251.0740625 1.8359375 251.4140625 C1.8359375 252.0740625 1.8359375 252.7340625 1.8359375 253.4140625 C3.10418196 255.42187548 4.42512011 257.39662077 5.7734375 259.3515625 C9.728876 265.09287799 9.728876 265.09287799 10.8359375 268.4140625 C11.4959375 268.4140625 12.1559375 268.4140625 12.8359375 268.4140625 C13.1659375 269.4040625 13.4959375 270.3940625 13.8359375 271.4140625 C10.8659375 272.0740625 7.8959375 272.7340625 4.8359375 273.4140625 C10.09519233 279.95393967 15.44712324 286.28926094 21.18359375 292.41796875 C22.8359375 294.4140625 22.8359375 294.4140625 22.8359375 296.4140625 C15.31869073 297.54164952 15.31869073 297.54164952 12.95239258 296.91625977 C10.77156129 296.39878717 9.06155861 296.36477995 6.83203125 296.5 C6.09146484 296.54382813 5.35089844 296.58765625 4.58789062 296.6328125 C3.44223633 296.71015625 3.44223633 296.71015625 2.2734375 296.7890625 C1.50580078 296.83289063 0.73816406 296.87671875 -0.05273438 296.921875 C-3.27904278 297.12439828 -6.08408062 297.38740187 -9.1640625 298.4140625 C-9.7621875 298.2490625 -10.3603125 298.0840625 -10.9765625 297.9140625 C-13.89667166 297.24660898 -16.25836247 297.81971477 -19.1640625 298.4140625 C-19.1640625 298.0840625 -19.1640625 297.7540625 -19.1640625 297.4140625 C-20.83018155 297.3713415 -22.49789135 297.37342418 -24.1640625 297.4140625 C-24.4940625 297.7440625 -24.8240625 298.0740625 -25.1640625 298.4140625 C-27.83465101 298.55521411 -30.48838488 298.45653357 -33.1640625 298.4140625 C-33.1640625 298.0840625 -33.1640625 297.7540625 -33.1640625 297.4140625 C-31.8440625 297.0840625 -30.5240625 296.7540625 -29.1640625 296.4140625 C-32.4640625 296.7440625 -35.7640625 297.0740625 -39.1640625 297.4140625 C-39.1640625 297.7440625 -39.1640625 298.0740625 -39.1640625 298.4140625 C-41.4740625 298.4140625 -43.7840625 298.4140625 -46.1640625 298.4140625 C-44.8440625 298.0840625 -43.5240625 297.7540625 -42.1640625 297.4140625 C-45.26947176 296.20324399 -45.26947176 296.20324399 -49.1640625 296.4140625 C-49.1640625 297.0740625 -49.1640625 297.7340625 -49.1640625 298.4140625 C-50.4221875 298.2696875 -51.6803125 298.1253125 -52.9765625 297.9765625 C-61.0566592 297.08724368 -69.0271262 296.2605354 -77.1640625 296.4140625 C-77.4940625 297.0740625 -77.8240625 297.7340625 -78.1640625 298.4140625 C-82.58998102 298.58429014 -85.26102116 298.36558317 -89.1640625 296.4140625 C-91.68798149 296.66882056 -91.68798149 296.66882056 -94.1640625 297.4140625 C-94.9271875 297.5996875 -95.6903125 297.7853125 -96.4765625 297.9765625 C-97.0334375 298.1209375 -97.5903125 298.2653125 -98.1640625 298.4140625 C-98.1640625 297.7540625 -98.1640625 297.0940625 -98.1640625 296.4140625 C-98.93192078 296.41850372 -99.69977905 296.42294495 -100.49090576 296.42752075 C-107.72999524 296.46760779 -114.96903083 296.49805212 -122.20820236 296.51768684 C-125.9298654 296.52812061 -129.65143666 296.54227232 -133.37304688 296.56494141 C-136.96513012 296.5866844 -140.55712513 296.59863419 -144.1492691 296.60381699 C-145.51919188 296.60751014 -146.88910988 296.61472195 -148.25899506 296.62552261 C-150.17880029 296.64005599 -152.09869446 296.64087958 -154.01855469 296.64111328 C-155.11109558 296.6455545 -156.20363647 296.64999573 -157.32928467 296.65457153 C-160.13789241 296.41628283 -161.78047795 295.86820663 -164.1640625 294.4140625 C-162.88343765 292.7065627 -161.54638693 291.04032654 -160.1640625 289.4140625 C-159.5040625 289.4140625 -158.8440625 289.4140625 -158.1640625 289.4140625 C-157.92945313 288.85976563 -157.69484375 288.30546875 -157.453125 287.734375 C-155.29534481 283.85037066 -152.09181139 280.87668513 -149.0625 277.65625 C-146.94866896 275.64932371 -146.94866896 275.64932371 -147.1640625 273.4140625 C-149.4740625 273.0840625 -151.7840625 272.7540625 -154.1640625 272.4140625 C-153.62033699 268.18736609 -151.05160774 265.37948513 -148.4765625 262.1640625 C-147.80306763 261.29962524 -147.80306763 261.29962524 -147.1159668 260.41772461 C-145.15961548 257.90854491 -143.17956521 255.43251669 -141.1328125 252.99609375 C-137.813492 249.04974998 -137.813492 249.04974998 -137.1640625 244.0390625 C-138.00083346 241.3045876 -138.00083346 241.3045876 -140.1640625 239.4140625 C-141.1640625 236.4140625 -141.1640625 236.4140625 -141.1640625 234.4140625 C-141.8240625 234.4140625 -142.4840625 234.4140625 -143.1640625 234.4140625 C-143.59976563 233.53105469 -144.03546875 232.64804687 -144.484375 231.73828125 C-148.21745866 224.20352986 -152.07383713 216.76298391 -156.1640625 209.4140625 C-156.65390625 208.52976562 -157.14375 207.64546875 -157.6484375 206.734375 C-158.81754322 204.6260439 -159.98931418 202.51925307 -161.1640625 200.4140625 C-161.8240625 200.4140625 -162.4840625 200.4140625 -163.1640625 200.4140625 C-163.8240625 198.4340625 -164.4840625 196.4540625 -165.1640625 194.4140625 C-164.5040625 194.4140625 -163.8440625 194.4140625 -163.1640625 194.4140625 C-163.81761719 192.86525391 -163.81761719 192.86525391 -164.484375 191.28515625 C-168.09977376 182.48914939 -171.0926107 173.68742242 -173.4765625 164.4765625 C-173.71842285 163.54320068 -173.9602832 162.60983887 -174.20947266 161.64819336 C-175.62468269 156.00779847 -176.76661583 150.36271398 -177.72338867 144.62670898 C-178.06869599 142.38488272 -178.06869599 142.38488272 -179.1640625 140.4140625 C-179.36946598 138.27159012 -179.52995505 136.12467648 -179.6640625 133.9765625 C-179.88036552 130.51957672 -180.06755154 127.70359539 -181.1640625 124.4140625 C-181.29188036 121.74011286 -181.20798121 119.09310393 -181.1640625 116.4140625 C-180.5040625 116.4140625 -179.8440625 116.4140625 -179.1640625 116.4140625 C-179.1228125 115.4446875 -179.0815625 114.4753125 -179.0390625 113.4765625 C-178.14385665 107.1717556 -173.82693867 101.87091349 -169.3515625 97.5390625 C-166.33308253 94.60682482 -166.17936728 92.88406742 -166.04296875 88.6953125 C-166.09470405 84.71623283 -166.54366176 80.85601808 -167.1015625 76.9140625 C-171.5631999 42.95604453 -171.5631999 42.95604453 -163.50390625 32.0234375 C-163.06175781 31.49234375 -162.61960937 30.96125 -162.1640625 30.4140625 C-161.4215625 29.4859375 -160.6790625 28.5578125 -159.9140625 27.6015625 C-153.28167635 22.32580079 -145.41965316 21.49283779 -137.1640625 22.4140625 C-134.06082883 23.19548458 -131.11860098 24.18847617 -128.1640625 25.4140625 C-127.5453125 24.52654297 -127.5453125 24.52654297 -126.9140625 23.62109375 C-122.21777546 17.19514742 -117.25741908 11.94280763 -109.1640625 10.4140625 C-100.28175426 9.49019686 -93.94493758 11.1253912 -86.1640625 15.4140625 C-85.89851563 14.66253906 -85.63296875 13.91101563 -85.359375 13.13671875 C-82.3013225 6.17115472 -76.00833613 2.18152966 -69.1640625 -0.5859375 C-60.13157667 -3.59676611 -51.58928774 -1.23287544 -43.1640625 2.4140625 C-41.90916016 3.05988281 -41.90916016 3.05988281 -40.62890625 3.71875 C-38.1493846 4.70566574 -38.1493846 4.70566574 -35.8828125 3.3671875 C-35.150625 2.80515625 -34.4184375 2.243125 -33.6640625 1.6640625 C-24.36977251 -5.33938136 -9.9142071 -7.26564636 0 0 Z M-30.6015625 10.4140625 C-33.18734081 13.72385874 -34.39292438 16.47052924 -34.61328125 20.671875 C-34.65646484 21.46207031 -34.69964844 22.25226563 -34.74414062 23.06640625 C-34.77958984 23.88238281 -34.81503906 24.69835937 -34.8515625 25.5390625 C-34.89861328 26.36277344 -34.94566406 27.18648438 -34.99414062 28.03515625 C-35.35404572 32.35415625 -35.35404572 32.35415625 -34.1640625 36.4140625 C-34.48169969 38.08379167 -34.81800753 39.74999073 -35.1640625 41.4140625 C-36.10249791 60.14807223 -36.6505092 79.30797375 -28.1640625 96.4140625 C-27.77508789 97.22278809 -27.38611328 98.03151367 -26.98535156 98.86474609 C-25.63187189 101.66478861 -24.24660736 104.44701408 -22.8515625 107.2265625 C-22.41400635 108.12262207 -21.9764502 109.01868164 -21.52563477 109.94189453 C-18.414375 115.97309044 -14.85273287 120.59058214 -9.1640625 124.4140625 C-8.5040625 124.4140625 -7.8440625 124.4140625 -7.1640625 124.4140625 C-7.13718099 122.76831684 -7.11772127 121.12244837 -7.1015625 119.4765625 C-7.08996094 118.56003906 -7.07835937 117.64351563 -7.06640625 116.69921875 C-6.90457201 114.44812923 -6.90457201 114.44812923 -8.1640625 113.4140625 C-8.44695431 111.15990872 -8.6117744 108.90565594 -8.78515625 106.640625 C-9.05607075 104.13486172 -9.05607075 104.13486172 -11.1640625 101.4140625 C-11.4321875 100.57617188 -11.7003125 99.73828125 -11.9765625 98.875 C-13.95488975 93.10921729 -16.82065558 87.74122957 -19.53125 82.2890625 C-23.8587864 73.40352918 -26.62987685 65.33499975 -24.1640625 55.4140625 C-21.33680142 49.81479625 -17.99383112 46.78656137 -12.1640625 44.4140625 C-8.515625 43.90234375 -8.515625 43.90234375 -4.7890625 43.7265625 C-3.54382813 43.66082031 -2.29859375 43.59507812 -1.015625 43.52734375 C-0.07460938 43.48996094 0.86640625 43.45257813 1.8359375 43.4140625 C1.92438766 40.26841204 1.97680585 37.12308875 2.0234375 33.9765625 C2.04857422 33.09806641 2.07371094 32.21957031 2.09960938 31.31445312 C2.18563014 23.54391033 0.76964121 15.67607106 -4.1640625 9.4140625 C-6.62111012 8.18116049 -6.62111012 8.18116049 -9.1640625 7.4140625 C-10.1540625 6.7540625 -11.1440625 6.0940625 -12.1640625 5.4140625 C-19.4061848 3.38626826 -24.97147853 5.79450642 -30.6015625 10.4140625 Z M-73.26953125 12.32421875 C-77.26135847 16.8592637 -79.28505859 19.50979646 -79.30932617 25.62304688 C-79.31570602 26.71178101 -79.32208588 27.80051514 -79.32865906 28.92224121 C-79.32977188 30.10547974 -79.3308847 31.28871826 -79.33203125 32.5078125 C-79.33535965 33.72424438 -79.33868805 34.94067627 -79.34211731 36.19396973 C-79.34719043 38.77644471 -79.34952552 41.35892628 -79.34936523 43.94140625 C-79.35153808 47.86990408 -79.3696521 51.79811491 -79.38867188 55.7265625 C-79.39160854 58.23697821 -79.39359151 60.74739525 -79.39453125 63.2578125 C-79.40171677 64.42485718 -79.40890228 65.59190186 -79.41630554 66.79431152 C-79.37108517 83.16719578 -74.20095186 96.17817967 -66.2890625 110.2890625 C-65.7955127 111.18085205 -65.30196289 112.0726416 -64.79345703 112.99145508 C-60.30343264 120.79882375 -55.20996801 127.91864029 -46.1640625 130.4140625 C-40.87817407 130.79968781 -37.25378718 129.89584051 -33.1640625 126.4765625 C-30.14666312 123.63378114 -29.24407353 122.16083214 -28.7890625 117.9140625 C-28.82949003 112.37549103 -31.51641038 108.13169719 -34.1640625 103.4140625 C-36.52952773 99.01429717 -38.19024629 94.30331875 -39.953125 89.63867188 C-41.20537979 85.82620011 -41.20537979 85.82620011 -44.1640625 83.4140625 C-43.8340625 83.0840625 -43.5040625 82.7540625 -43.1640625 82.4140625 C-43.06541134 81.03406313 -43.03327227 79.64914451 -43.03125 78.265625 C-43.02996094 77.42515625 -43.02867187 76.5846875 -43.02734375 75.71875 C-43.03314453 74.39230469 -43.03314453 74.39230469 -43.0390625 73.0390625 C-43.03519531 72.1625 -43.03132813 71.2859375 -43.02734375 70.3828125 C-43.02863281 69.53976562 -43.02992188 68.69671875 -43.03125 67.828125 C-43.03294189 66.66724365 -43.03294189 66.66724365 -43.03466797 65.48291016 C-43.08771103 63.21579676 -43.08771103 63.21579676 -44.1640625 60.4140625 C-44.25825058 58.51874952 -44.29477434 56.62030698 -44.296875 54.72265625 C-44.29880859 53.05879883 -44.29880859 53.05879883 -44.30078125 51.36132812 C-44.29691406 50.20310547 -44.29304688 49.04488281 -44.2890625 47.8515625 C-44.29486328 46.10842773 -44.29486328 46.10842773 -44.30078125 44.33007812 C-44.29949219 43.22212891 -44.29820312 42.11417969 -44.296875 40.97265625 C-44.29574707 39.95486084 -44.29461914 38.93706543 -44.29345703 37.88842773 C-44.1640625 35.4140625 -44.1640625 35.4140625 -43.1640625 33.4140625 C-43.4115625 31.9290625 -43.4115625 31.9290625 -43.6640625 30.4140625 C-44.1640625 27.4140625 -44.1640625 27.4140625 -43.1640625 25.4140625 C-43.1640625 19.00309796 -44.76761312 15.67959471 -49.19140625 11.046875 C-56.09800211 5.33012833 -66.8233844 6.47604471 -73.26953125 12.32421875 Z M-116.9765625 25.4140625 C-119.61577206 29.03354989 -120.28787139 31.42853937 -120.30932617 35.78686523 C-120.31570602 36.66886093 -120.32208588 37.55085663 -120.32865906 38.45957947 C-120.32977188 39.41264481 -120.3308847 40.36571014 -120.33203125 41.34765625 C-120.33535965 42.33596939 -120.33868805 43.32428253 -120.34211731 44.34254456 C-120.34718477 46.43986547 -120.34952569 48.53719446 -120.34936523 50.63452148 C-120.35153269 53.80792027 -120.3696373 56.98096049 -120.38867188 60.15429688 C-120.42878877 73.64903368 -120.21530027 86.01892845 -114.6640625 98.5390625 C-114.14718872 99.73341919 -114.14718872 99.73341919 -113.61987305 100.9519043 C-111.00316086 106.85358599 -108.08712561 112.57109968 -104.9765625 118.2265625 C-104.57308594 118.96084473 -104.16960937 119.69512695 -103.75390625 120.45166016 C-99.80417223 127.41371174 -96.2089184 133.00060573 -88.1640625 135.4140625 C-80.95054315 136.33493731 -75.54149814 135.01208992 -69.7265625 130.5390625 C-67.99722019 128.5142252 -67.99722019 128.5142252 -67.7265625 125.9765625 C-68.25832591 122.86194824 -69.40098414 121.02603044 -71.1640625 118.4140625 C-72.96587163 115.45909552 -74.61750201 112.50718348 -76.1640625 109.4140625 C-78.72736342 104.60755552 -78.72736342 104.60755552 -82.1640625 100.4140625 C-82.55039213 99.09510901 -82.87125119 97.75687687 -83.1640625 96.4140625 C-84.18057471 93.01298207 -85.19857967 89.61247818 -86.2265625 86.21484375 C-88.19754137 78.22416692 -88.26279921 70.41969456 -88.1640625 62.2265625 C-88.13621557 53.91263582 -88.13185809 45.60050851 -88.3515625 37.2890625 C-88.35736328 36.38389893 -88.36316406 35.47873535 -88.36914062 34.54614258 C-88.57659168 28.46264026 -89.69746546 25.61479067 -94.1640625 21.4140625 C-102.30149162 17.43576382 -110.93149088 18.47086596 -116.9765625 25.4140625 Z M-154.5390625 36.2890625 C-157.82625775 40.58770245 -158.41880724 44.45462658 -158.4296875 49.7890625 C-158.43226563 51.02269531 -158.43484375 52.25632812 -158.4375 53.52734375 C-158.42976563 54.80996094 -158.42203125 56.09257812 -158.4140625 57.4140625 C-158.42179687 58.66574219 -158.42953125 59.91742188 -158.4375 61.20703125 C-158.4204132 69.45141458 -157.68440907 77.31306928 -156.1640625 85.4140625 C-156.00220459 86.28595215 -155.84034668 87.1578418 -155.67358398 88.05615234 C-154.92984955 91.49792867 -153.71070016 94.74959292 -152.4765625 98.0390625 C-152.08162598 99.09432129 -152.08162598 99.09432129 -151.67871094 100.17089844 C-149.35018228 106.22838759 -146.42000824 111.80442104 -143.1640625 117.4140625 C-142.83535156 118.07921875 -142.50664062 118.744375 -142.16796875 119.4296875 C-138.84676336 125.99456041 -134.89852338 132.04683206 -128.1640625 135.4140625 C-122.76885206 135.90018929 -117.85506953 136.22704665 -112.9140625 133.8515625 C-110.46280938 130.43731708 -110.73810013 128.58598805 -111.1640625 124.4140625 C-112.43648698 121.29860151 -114.10200754 118.44632954 -115.7890625 115.5390625 C-122.95498401 102.61324764 -127.9640667 89.73523715 -128.69921875 74.8671875 C-128.74219589 74.05538025 -128.78517303 73.243573 -128.82945251 72.40716553 C-128.96524767 69.82629663 -129.09594213 67.24519794 -129.2265625 64.6640625 C-129.31803 62.91274318 -129.40982331 61.16144085 -129.50195312 59.41015625 C-129.851075 52.73504567 -130.1640625 46.09896608 -130.1640625 39.4140625 C-130.8240625 39.4140625 -131.4840625 39.4140625 -132.1640625 39.4140625 C-132.1640625 38.0940625 -132.1640625 36.7740625 -132.1640625 35.4140625 C-134.86630985 32.37403424 -138.02533234 31.71172626 -142.0078125 31.34765625 C-146.85314894 31.49687857 -150.77974882 33.32118328 -154.5390625 36.2890625 Z M-14.1640625 55.4140625 C-17.18228758 59.94140012 -16.83049158 64.10728093 -16.1640625 69.4140625 C-14.86504127 73.35071414 -13.08670265 76.93555541 -11.1640625 80.6015625 C-10.44863281 82.02952148 -10.44863281 82.02952148 -9.71875 83.48632812 C-8.55298531 85.80619987 -7.36836745 88.11403222 -6.1640625 90.4140625 C-5.5040625 90.4140625 -4.8440625 90.4140625 -4.1640625 90.4140625 C-4.1640625 91.0740625 -4.1640625 91.7340625 -4.1640625 92.4140625 C2.15965402 90.15144833 7.3623257 86.22788635 12.8359375 82.4140625 C13.89941406 81.70830078 13.89941406 81.70830078 14.984375 80.98828125 C16.8534272 79.72588278 16.8534272 79.72588278 18.8359375 77.4140625 C18.62730887 72.44174693 16.89160709 69.60739902 13.8984375 65.7265625 C13.18816406 64.79457031 12.47789062 63.86257813 11.74609375 62.90234375 C11.11574219 62.08121094 10.48539063 61.26007813 9.8359375 60.4140625 C9.1759375 59.4240625 8.5159375 58.4340625 7.8359375 57.4140625 C6.8459375 57.0840625 5.8559375 56.7540625 4.8359375 56.4140625 C4.4646875 55.7540625 4.0934375 55.0940625 3.7109375 54.4140625 C1.10713252 51.63667052 -1.09377858 51.50883002 -4.80859375 51.2421875 C-8.78913581 51.53264165 -10.96228044 53.06173283 -14.1640625 55.4140625 Z M15.6484375 88.0390625 C14.97804443 88.4932959 14.30765137 88.9475293 13.61694336 89.41552734 C8.91939755 92.61702858 4.3288039 95.92979876 -0.1640625 99.4140625 C0.1659375 101.7240625 0.4959375 104.0340625 0.8359375 106.4140625 C1.4959375 106.4140625 2.1559375 106.4140625 2.8359375 106.4140625 C2.8359375 107.7340625 2.8359375 109.0540625 2.8359375 110.4140625 C13.3959375 110.4140625 23.9559375 110.4140625 34.8359375 110.4140625 C35.77039796 104.80729976 35.82409537 103.32598195 33.8359375 98.4140625 C32.8459375 98.4140625 31.8559375 98.4140625 30.8359375 98.4140625 C31.1040625 97.7540625 31.3721875 97.0940625 31.6484375 96.4140625 C31.9363163 91.80800165 29.38246851 89.08787953 26.8359375 85.4140625 C26.5059375 84.7540625 26.1759375 84.0940625 25.8359375 83.4140625 C21.58691796 83.4140625 19.03029848 85.71162677 15.6484375 88.0390625 Z M-162.1640625 103.4140625 C-162.8240625 104.7340625 -163.4840625 106.0540625 -164.1640625 107.4140625 C-164.8240625 107.4140625 -165.4840625 107.4140625 -166.1640625 107.4140625 C-168.87751531 112.84096812 -169.61808325 117.00820117 -169.4765625 123.0390625 C-169.4667334 123.8223291 -169.4569043 124.6055957 -169.44677734 125.41259766 C-169.23122175 137.85962049 -169.23122175 137.85962049 -165.1640625 149.4140625 C-164.18824219 149.4140625 -163.21242188 149.4140625 -162.20703125 149.4140625 C-155.19270833 149.4140625 -148.17838542 149.4140625 -141.1640625 149.4140625 C-140.8340625 148.7540625 -140.5040625 148.0940625 -140.1640625 147.4140625 C-138.8440625 148.4040625 -137.5240625 149.3940625 -136.1640625 150.4140625 C-135.5040625 150.0840625 -134.8440625 149.7540625 -134.1640625 149.4140625 C-132.65431307 149.33033758 -131.14094468 149.3067622 -129.62890625 149.31640625 C-128.73751953 149.31962891 -127.84613281 149.32285156 -126.92773438 149.32617188 C-125.5287793 149.33874023 -125.5287793 149.33874023 -124.1015625 149.3515625 C-122.69680664 149.35833008 -122.69680664 149.35833008 -121.26367188 149.36523438 C-118.89707856 149.37723014 -116.53060227 149.39447942 -114.1640625 149.4140625 C-113.8340625 149.4140625 -113.5040625 149.4140625 -113.1640625 149.4140625 C-84.49739583 149.4140625 -55.83072917 149.4140625 -27.1640625 149.4140625 C-27.8240625 148.7540625 -28.4840625 148.0940625 -29.1640625 147.4140625 C-28.1740625 147.7440625 -27.1840625 148.0740625 -26.1640625 148.4140625 C-26.1640625 148.7440625 -26.1640625 149.0740625 -26.1640625 149.4140625 C-24.06052755 149.4950831 -21.95610298 149.55326157 -19.8515625 149.6015625 C-18.67980469 149.63636719 -17.50804687 149.67117188 -16.30078125 149.70703125 C-13.20410741 149.69177099 -13.20410741 149.69177099 -11.3203125 148.04296875 C-8.17992361 143.6188398 -7.95449771 139.75796457 -8.1640625 134.4140625 C-8.8240625 134.0840625 -9.4840625 133.7540625 -10.1640625 133.4140625 C-10.7415625 132.9603125 -11.3190625 132.5065625 -11.9140625 132.0390625 C-14.56231497 130.12643571 -17.1575709 128.69342063 -20.1640625 127.4140625 C-23.30602485 128.13919923 -23.30602485 128.13919923 -24.8515625 130.7265625 C-28.95723541 135.4980202 -33.85518773 137.45287818 -40.0390625 138.2890625 C-44.57799633 138.60475342 -48.62905757 137.95464957 -53.03515625 136.88671875 C-55.28871971 136.3056921 -55.28871971 136.3056921 -58.1640625 136.4140625 C-57.6690625 135.4240625 -57.6690625 135.4240625 -57.1640625 134.4140625 C-58.88883161 133.45904092 -58.88883161 133.45904092 -61.1640625 133.4140625 C-62.85403573 135.05709203 -64.51622644 136.72877562 -66.1640625 138.4140625 C-73.39337985 142.73747778 -80.69741521 144.76426446 -89.1640625 144.4140625 C-92.81281305 143.19781232 -95.91994388 141.46017022 -99.1640625 139.4140625 C-100.1953125 138.8159375 -101.2265625 138.2178125 -102.2890625 137.6015625 C-102.9078125 137.2096875 -103.5265625 136.8178125 -104.1640625 136.4140625 C-104.67195313 136.82398438 -105.17984375 137.23390625 -105.703125 137.65625 C-106.39148438 138.19507813 -107.07984375 138.73390625 -107.7890625 139.2890625 C-108.46195313 139.82273437 -109.13484375 140.35640625 -109.828125 140.90625 C-116.6100436 145.28387639 -123.48703097 144.97158751 -131.1640625 143.4140625 C-141.23171711 139.03879606 -147.15283054 130.0588904 -152 120.63671875 C-152.97772401 118.5009551 -152.97772401 118.5009551 -154.1640625 117.4140625 C-154.83473702 115.82012176 -155.47604022 114.21375767 -156.1015625 112.6015625 C-157.3245719 109.45335958 -158.6058745 106.41165286 -160.1640625 103.4140625 C-160.8240625 103.4140625 -161.4840625 103.4140625 -162.1640625 103.4140625 Z M3.8359375 116.4140625 C3.64167877 119.20541102 3.45524233 121.99689937 3.2734375 124.7890625 C3.21736328 125.583125 3.16128906 126.3771875 3.10351562 127.1953125 C2.68240946 131.42997135 2.68240946 131.42997135 3.8359375 135.4140625 C8.37491455 135.43871642 12.91385293 135.45690039 17.45288086 135.46899414 C18.99813516 135.4740339 20.54338466 135.4808657 22.08862305 135.48950195 C24.30518779 135.50158326 26.52168968 135.50729423 28.73828125 135.51171875 C29.78048073 135.51946068 29.78048073 135.51946068 30.84373474 135.52735901 C32.5082308 135.52755527 34.17259249 135.47595379 35.8359375 135.4140625 C37.02935502 134.44073989 37.02935502 134.44073989 36.94946289 132.64819336 C36.94422607 131.89932861 36.93898926 131.15046387 36.93359375 130.37890625 C36.93037109 129.57001953 36.92714844 128.76113281 36.92382812 127.92773438 C36.91544922 127.07759766 36.90707031 126.22746094 36.8984375 125.3515625 C36.89392578 124.49755859 36.88941406 123.64355469 36.88476562 122.76367188 C36.87294123 120.64710587 36.85500519 118.53057565 36.8359375 116.4140625 C36.06403076 116.4140625 35.29212402 116.4140625 34.49682617 116.4140625 C24.27652995 116.4140625 14.05623372 116.4140625 3.8359375 116.4140625 Z M1.8359375 142.4140625 C-0.1440625 146.0440625 -2.1240625 149.6740625 -4.1640625 153.4140625 C4.33185072 162.07769905 4.33185072 162.07769905 13.3984375 170.12890625 C14.8359375 171.4140625 14.8359375 171.4140625 17.2734375 174.3515625 C20.41565899 178.10690038 23.82595254 181.57855012 27.8359375 184.4140625 C28.8259375 184.4140625 29.8159375 184.4140625 30.8359375 184.4140625 C31.6534882 181.87392341 32.46508936 179.33213019 33.2734375 176.7890625 C33.50353516 176.07621094 33.73363281 175.36335938 33.97070312 174.62890625 C36.39054838 166.98359805 36.97194026 160.0280974 36.8984375 152.0390625 C36.8778125 148.8628125 36.8571875 145.6865625 36.8359375 142.4140625 C25.2859375 142.4140625 13.7359375 142.4140625 1.8359375 142.4140625 Z M-161.1640625 156.4140625 C-162.1540625 157.0740625 -163.1440625 157.7340625 -164.1640625 158.4140625 C-163.35546603 161.2277395 -162.54239247 164.03998319 -161.7265625 166.8515625 C-161.38141602 168.05522461 -161.38141602 168.05522461 -161.02929688 169.28320312 C-160.17700388 173.15459497 -160.17700388 173.15459497 -158.1640625 176.4140625 C-156.77120781 176.52680372 -155.37275813 176.57139106 -153.97544861 176.58815002 C-153.07163956 176.60108597 -152.16783051 176.61402191 -151.2366333 176.62734985 C-150.23678406 176.63632294 -149.23693481 176.64529602 -148.20678711 176.65454102 C-147.15944901 176.66753738 -146.1121109 176.68053375 -145.03303528 176.69392395 C-134.01262986 176.82128329 -122.99143587 176.87752562 -111.97045898 176.92895508 C-106.75094727 176.95559557 -101.5323616 177.00417272 -96.31323242 177.07250977 C-90.00309316 177.15492261 -83.69382889 177.19721443 -77.38318062 177.21201897 C-74.9875852 177.22419722 -72.59201533 177.25006655 -70.19672966 177.29046822 C-55.52000845 177.52541004 -44.55124458 176.64847106 -32.1640625 168.4140625 C-31.58851561 168.03196688 -31.01296871 167.64987125 -30.419981 167.25619698 C-24.07676821 163.07871834 -24.07676821 163.07871834 -19.1640625 157.4140625 C-20.778155 155.79997 -22.52882658 156.28671932 -24.75976562 156.28466797 C-25.73747925 156.28151581 -26.71519287 156.27836365 -27.72253418 156.27511597 C-28.78605103 156.2771402 -29.84956787 156.27916443 -30.9453125 156.28125 C-32.02913208 156.28029327 -33.11295166 156.27933655 -34.22961426 156.27835083 C-36.5262864 156.27766885 -38.82296045 156.27952439 -41.11962891 156.28369141 C-44.64880678 156.28903938 -48.17785737 156.283747 -51.70703125 156.27734375 C-53.93229195 156.27800453 -56.15755257 156.27928568 -58.3828125 156.28125 C-59.44632935 156.27922577 -60.50984619 156.27720154 -61.60559082 156.27511597 C-63.07216125 156.27984421 -63.07216125 156.27984421 -64.56835938 156.28466797 C-65.86622375 156.28586136 -65.86622375 156.28586136 -67.19030762 156.28707886 C-69.16618832 156.19610523 -69.16618832 156.19610523 -70.1640625 157.4140625 C-70.1640625 157.0840625 -70.1640625 156.7540625 -70.1640625 156.4140625 C-71.20046875 156.4140625 -72.236875 156.4140625 -73.3046875 156.4140625 C-79.92447917 156.4140625 -86.54427083 156.4140625 -93.1640625 156.4140625 C-93.4940625 156.7440625 -93.8240625 157.0740625 -94.1640625 157.4140625 C-94.1640625 157.0840625 -94.1640625 156.7540625 -94.1640625 156.4140625 C-95.80375 156.6615625 -95.80375 156.6615625 -97.4765625 156.9140625 C-101.1640625 157.4140625 -101.1640625 157.4140625 -104.1640625 157.4140625 C-105.71770508 157.42191772 -105.71770508 157.42191772 -107.30273438 157.42993164 C-110.69190079 157.44699845 -114.08102219 157.45945894 -117.47021484 157.46899414 C-118.93278722 157.47403974 -120.39535452 157.48087571 -121.85791016 157.48950195 C-123.97039012 157.50162625 -126.08280411 157.50730171 -128.1953125 157.51171875 C-129.45923828 157.51695557 -130.72316406 157.52219238 -132.02539062 157.52758789 C-135.1640625 157.4140625 -135.1640625 157.4140625 -138.1640625 156.4140625 C-141.1393946 156.1900561 -144.1186352 156.22892055 -147.1015625 156.2265625 C-148.31875977 156.20819336 -148.31875977 156.20819336 -149.56054688 156.18945312 C-150.73907227 156.18655273 -150.73907227 156.18655273 -151.94140625 156.18359375 C-153.01249634 156.17743042 -153.01249634 156.17743042 -154.10522461 156.17114258 C-156.47542382 156.45079967 -158.10113517 157.24291391 -160.1640625 158.4140625 C-160.4940625 157.7540625 -160.8240625 157.0940625 -161.1640625 156.4140625 Z M-13.8515625 163.9140625 C-14.6146875 164.7390625 -15.3778125 165.5640625 -16.1640625 166.4140625 C-14.51347989 170.50592597 -11.59230554 173.39278786 -8.6015625 176.5390625 C-7.50991401 177.70395624 -6.41877247 178.86932524 -5.328125 180.03515625 C-4.78961914 180.60862793 -4.25111328 181.18209961 -3.69628906 181.77294922 C-1.59466653 184.02392223 0.46717287 186.30915441 2.5234375 188.6015625 C3.23242188 189.38917969 3.94140625 190.17679688 4.671875 190.98828125 C6.20846259 192.71070163 7.73333698 194.44360333 9.25 196.18359375 C10.43722656 197.53517578 10.43722656 197.53517578 11.6484375 198.9140625 C12.35613281 199.72875 13.06382812 200.5434375 13.79296875 201.3828125 C15.74244391 203.3211052 17.31571062 204.37199116 19.8359375 205.4140625 C20.70785697 204.02924922 21.55784134 202.63061004 22.3984375 201.2265625 C23.11193359 200.06060547 23.11193359 200.06060547 23.83984375 198.87109375 C25.06476265 195.84962714 24.92863401 194.46263586 23.8359375 191.4140625 C22.4606992 189.77218497 22.4606992 189.77218497 20.5859375 188.4140625 C16.58277065 185.13088969 12.9619262 181.59963072 9.3359375 177.9140625 C1.54201387 169.24156066 1.54201387 169.24156066 -8.1640625 163.4140625 C-8.1640625 162.7540625 -8.1640625 162.0940625 -8.1640625 161.4140625 C-11.40972108 161.07351053 -11.40972108 161.07351053 -13.8515625 163.9140625 Z M-29.2265625 174.9140625 C-30.32677734 175.61015625 -30.32677734 175.61015625 -31.44921875 176.3203125 C-32.01511719 176.68125 -32.58101562 177.0421875 -33.1640625 177.4140625 C-31.91727773 181.98560666 -29.39696311 184.36766377 -26.08203125 187.5390625 C-23.58219888 189.98289048 -21.32910063 192.60055418 -19.046875 195.24609375 C-16.9483093 197.66249201 -14.8096655 200.03935274 -12.6640625 202.4140625 C-6.72875605 208.99429189 -0.91933679 215.67618041 4.8359375 222.4140625 C8.49755328 221.19352391 8.99864224 220.04623946 11.0234375 216.8515625 C11.55324219 216.02527344 12.08304688 215.19898438 12.62890625 214.34765625 C13.02722656 213.70957031 13.42554688 213.07148437 13.8359375 212.4140625 C13.26746094 211.8571875 12.69898438 211.3003125 12.11328125 210.7265625 C7.72825689 206.39278216 3.52868461 201.99132066 -0.484375 197.3125 C-2.6869347 194.82309531 -5.04758886 192.5195522 -7.41796875 190.19140625 C-9.22883893 188.34812676 -10.91727604 186.43583451 -12.6015625 184.4765625 C-16.24370335 180.25630406 -20.05335328 176.18388364 -24.1640625 172.4140625 C-26.06351544 172.4140625 -27.67316125 173.92777599 -29.2265625 174.9140625 Z M-155.1640625 183.4140625 C-154.75757035 184.91685165 -154.33817042 186.41614942 -153.9140625 187.9140625 C-153.68203125 188.749375 -153.45 189.5846875 -153.2109375 190.4453125 C-151.87247892 194.2409413 -149.96396635 197.8142548 -148.1640625 201.4140625 C-122.7540625 201.4140625 -97.3440625 201.4140625 -71.1640625 201.4140625 C-70.1740625 198.7740625 -69.1840625 196.1340625 -68.1640625 193.4140625 C-66.33984375 190.953125 -66.33984375 190.953125 -64.4765625 189.0390625 C-61.84281849 186.6381402 -61.84281849 186.6381402 -61.1640625 183.4140625 C-68.0940625 183.4140625 -75.0240625 183.4140625 -82.1640625 183.4140625 C-81.1740625 184.4040625 -81.1740625 184.4040625 -80.1640625 185.4140625 C-81.01097656 185.24003906 -81.85789062 185.06601562 -82.73046875 184.88671875 C-86.34764425 184.38879129 -89.4683671 184.53203066 -93.1015625 184.8515625 C-100.81141914 185.44815855 -108.43244093 185.51276405 -116.1640625 185.4140625 C-116.1640625 184.7540625 -116.1640625 184.0940625 -116.1640625 183.4140625 C-118.4740625 183.4140625 -120.7840625 183.4140625 -123.1640625 183.4140625 C-122.5040625 184.0740625 -121.8440625 184.7340625 -121.1640625 185.4140625 C-126.94997761 185.51883762 -132.45715616 185.40656795 -138.1640625 184.4140625 C-138.1640625 184.0840625 -138.1640625 183.7540625 -138.1640625 183.4140625 C-140.4740625 183.4140625 -142.7840625 183.4140625 -145.1640625 183.4140625 C-145.1640625 184.0740625 -145.1640625 184.7340625 -145.1640625 185.4140625 C-145.8240625 185.4140625 -146.4840625 185.4140625 -147.1640625 185.4140625 C-147.1640625 184.7540625 -147.1640625 184.0940625 -147.1640625 183.4140625 C-149.8040625 183.4140625 -152.4440625 183.4140625 -155.1640625 183.4140625 Z M-137.1640625 183.4140625 C-137.1640625 183.7440625 -137.1640625 184.0740625 -137.1640625 184.4140625 C-135.5140625 184.4140625 -133.8640625 184.4140625 -132.1640625 184.4140625 C-132.1640625 184.0840625 -132.1640625 183.7540625 -132.1640625 183.4140625 C-133.8140625 183.4140625 -135.4640625 183.4140625 -137.1640625 183.4140625 Z M-130.1640625 183.4140625 C-130.1640625 183.7440625 -130.1640625 184.0740625 -130.1640625 184.4140625 C-128.1840625 184.4140625 -126.2040625 184.4140625 -124.1640625 184.4140625 C-124.1640625 184.0840625 -124.1640625 183.7540625 -124.1640625 183.4140625 C-126.1440625 183.4140625 -128.1240625 183.4140625 -130.1640625 183.4140625 Z M-106.1640625 183.4140625 C-102.1640625 184.4140625 -102.1640625 184.4140625 -102.1640625 184.4140625 Z M-98.1640625 183.4140625 C-98.1640625 183.7440625 -98.1640625 184.0740625 -98.1640625 184.4140625 C-96.1840625 184.4140625 -94.2040625 184.4140625 -92.1640625 184.4140625 C-92.1640625 184.0840625 -92.1640625 183.7540625 -92.1640625 183.4140625 C-94.1440625 183.4140625 -96.1240625 183.4140625 -98.1640625 183.4140625 Z M-91.1640625 183.4140625 C-91.1640625 183.7440625 -91.1640625 184.0740625 -91.1640625 184.4140625 C-89.5140625 184.4140625 -87.8640625 184.4140625 -86.1640625 184.4140625 C-86.1640625 184.0840625 -86.1640625 183.7540625 -86.1640625 183.4140625 C-87.8140625 183.4140625 -89.4640625 183.4140625 -91.1640625 183.4140625 Z M-41.1640625 183.4140625 C-42.1540625 183.9090625 -42.1540625 183.9090625 -43.1640625 184.4140625 C-45.15958032 184.77325571 -47.15955129 185.10902819 -49.1640625 185.4140625 C-49.8240625 187.3940625 -50.4840625 189.3740625 -51.1640625 191.4140625 C-50.63296875 191.94515625 -50.101875 192.47625 -49.5546875 193.0234375 C-47.42447917 195.15364583 -45.29427083 197.28385417 -43.1640625 199.4140625 C-42.45765625 200.07921875 -41.75125 200.744375 -41.0234375 201.4296875 C-39.20025203 203.37544006 -38.31705877 205.04164218 -37.1640625 207.4140625 C-35.68962513 209.09232522 -35.68962513 209.09232522 -33.9765625 210.6640625 C-30.8255984 213.72407094 -27.92161078 216.91290853 -25.0546875 220.23828125 C-22.91442318 222.70135403 -20.72931149 225.12036038 -18.5390625 227.5390625 C-15.32556957 231.0986239 -12.19521549 234.69845561 -9.1640625 238.4140625 C-7.8440625 237.7540625 -6.5240625 237.0940625 -5.1640625 236.4140625 C-5.1640625 235.7540625 -5.1640625 235.0940625 -5.1640625 234.4140625 C-4.5453125 234.1871875 -3.9265625 233.9603125 -3.2890625 233.7265625 C-0.54432675 232.03128454 -0.22942596 230.38460296 0.8359375 227.4140625 C-0.02128906 226.5684375 -0.87851562 225.7228125 -1.76171875 224.8515625 C-12.42941858 214.28535572 -12.42941858 214.28535572 -17.2265625 208.63671875 C-20.51645962 204.86262306 -23.96388597 201.23335045 -27.38208008 197.57568359 C-30.97969212 193.71664612 -34.49516618 189.80573939 -37.89453125 185.76953125 C-39.14197437 184.28048161 -39.14197437 184.28048161 -41.1640625 183.4140625 Z M-163.1640625 195.4140625 C-162.1640625 197.4140625 -162.1640625 197.4140625 -162.1640625 197.4140625 Z M-59.1640625 195.4140625 C-62.62642728 199.43040565 -63.47169301 202.88091074 -63.375 208.1796875 C-62.04940923 222.22113045 -50.98405881 235.19169364 -41.1015625 244.4140625 C-35.17511967 249.30981962 -27.88651276 251.7127208 -20.1640625 251.4140625 C-16.69309393 250.14152394 -16.69309393 250.14152394 -14.1640625 248.4140625 C-13.85463543 245.31436324 -13.86848253 243.84169378 -15.66796875 241.23828125 C-16.68697266 240.18060547 -16.68697266 240.18060547 -17.7265625 239.1015625 C-18.46390625 238.3178125 -19.20125 237.5340625 -19.9609375 236.7265625 C-20.68796875 235.9634375 -21.415 235.2003125 -22.1640625 234.4140625 C-23.2755455 233.14962313 -24.38007316 231.87902581 -25.4765625 230.6015625 C-28.61811383 227.01641249 -31.78485187 223.45458262 -34.9765625 219.9140625 C-35.69743042 219.10231567 -35.69743042 219.10231567 -36.43286133 218.27416992 C-37.63531235 216.94880643 -38.89551034 215.67630346 -40.1640625 214.4140625 C-40.8240625 214.4140625 -41.4840625 214.4140625 -42.1640625 214.4140625 C-42.45796875 213.40279297 -42.45796875 213.40279297 -42.7578125 212.37109375 C-44.7090285 208.26812011 -47.55564418 205.37517876 -50.6640625 202.1015625 C-51.25832031 201.45638672 -51.85257813 200.81121094 -52.46484375 200.14648438 C-54.73467372 197.69757566 -54.73467372 197.69757566 -57.1640625 195.4140625 C-57.8240625 195.4140625 -58.4840625 195.4140625 -59.1640625 195.4140625 Z M-144.1640625 208.4140625 C-141.76714834 214.50172685 -138.61443254 219.95175918 -135.2265625 225.5390625 C-134.70126953 226.41949219 -134.17597656 227.29992187 -133.63476562 228.20703125 C-131.44684156 231.84035693 -131.44684156 231.84035693 -129.1640625 235.4140625 C-128.61485641 236.2746376 -128.06565033 237.13521271 -127.49980164 238.02186584 C-125.33926449 240.69028551 -125.33926449 240.69028551 -122.02557373 241.01533508 C-120.7909137 241.00423203 -119.55625366 240.99312897 -118.28417969 240.98168945 C-117.25917862 240.98278465 -117.25917862 240.98278465 -116.21347046 240.98390198 C-113.96180972 240.98042705 -111.71223531 240.94157669 -109.4609375 240.90234375 C-107.89724864 240.89301513 -106.33354514 240.88589925 -104.76983643 240.88090515 C-100.65949974 240.86183874 -96.55005026 240.81274231 -92.44006348 240.75738525 C-88.24401857 240.7061843 -84.04782993 240.68338938 -79.8515625 240.65820312 C-71.62198925 240.60462207 -63.39313632 240.51931499 -55.1640625 240.4140625 C-55.8240625 240.0840625 -56.4840625 239.7540625 -57.1640625 239.4140625 C-57.85385849 237.75683478 -58.51679538 236.08835862 -59.1640625 234.4140625 C-60.09566404 232.78181355 -61.0753886 231.17607359 -62.1015625 229.6015625 C-62.60558594 228.81136719 -63.10960937 228.02117187 -63.62890625 227.20703125 C-64.13550781 226.61535156 -64.64210938 226.02367187 -65.1640625 225.4140625 C-66.1540625 225.4140625 -67.1440625 225.4140625 -68.1640625 225.4140625 C-68.2671875 224.2796875 -68.3703125 223.1453125 -68.4765625 221.9765625 C-68.87558757 218.69126828 -69.62614564 215.75565041 -70.70703125 212.62890625 C-70.97926514 211.83476318 -71.25149902 211.04062012 -71.53198242 210.22241211 C-71.84486206 209.32727905 -71.84486206 209.32727905 -72.1640625 208.4140625 C-72.97394623 208.4140625 -73.78382996 208.4140625 -74.61825562 208.4140625 C-97.80019124 208.4140625 -120.98212687 208.4140625 -144.1640625 208.4140625 Z M-133.80224609 261.59960938 C-134.24635834 262.31532104 -134.69047058 263.03103271 -135.14804077 263.76843262 C-135.48332794 264.31149048 -135.81861511 264.85454834 -136.1640625 265.4140625 C-125.65140197 265.54688075 -115.13871521 265.6773846 -104.62599277 265.80521393 C-99.74047537 265.86468608 -94.85496891 265.92485221 -89.96948242 265.98681641 C-62.26758642 266.33929204 -62.26758642 266.33929204 -34.56406975 266.50218201 C-33.17413747 266.50586889 -31.78420828 266.51114846 -30.39428902 266.51820374 C-18.0571749 267.1955758 -18.0571749 267.1955758 -6.6015625 263.8515625 C-6.1271875 263.3771875 -5.6528125 262.9028125 -5.1640625 262.4140625 C-6.78746055 260.70522245 -8.45725303 259.03959533 -10.1640625 257.4140625 C-12.28314086 257.37841539 -12.28314086 257.37841539 -14.8515625 257.703125 C-26.99003324 258.93414916 -35.1078811 257.53074472 -45.1640625 250.4140625 C-46.1540625 249.4240625 -46.1540625 249.4240625 -47.1640625 248.4140625 C-49.59658911 247.95243823 -49.59658911 247.95243823 -52.2890625 247.7890625 C-53.19914063 247.71429687 -54.10921875 247.63953125 -55.046875 247.5625 C-55.74554687 247.51351562 -56.44421875 247.46453125 -57.1640625 247.4140625 C-57.4940625 248.0740625 -57.8240625 248.7340625 -58.1640625 249.4140625 C-59.28901123 249.40882568 -60.41395996 249.40358887 -61.57299805 249.39819336 C-65.75690919 249.38005816 -69.94081687 249.36859936 -74.12475586 249.35913086 C-75.93368108 249.35411012 -77.74260226 249.34729221 -79.55151367 249.33862305 C-82.15544636 249.32645848 -84.75932527 249.32081152 -87.36328125 249.31640625 C-88.57137703 249.30866432 -88.57137703 249.30866432 -89.80387878 249.30076599 C-93.72878851 249.30037613 -97.33106232 249.44321495 -101.1640625 250.4140625 C-101.1640625 249.4240625 -101.1640625 248.4340625 -101.1640625 247.4140625 C-105.1240625 247.4140625 -109.0840625 247.4140625 -113.1640625 247.4140625 C-113.1640625 247.7440625 -113.1640625 248.0740625 -113.1640625 248.4140625 C-111.8440625 248.7440625 -110.5240625 249.0740625 -109.1640625 249.4140625 C-111.1440625 249.4140625 -113.1240625 249.4140625 -115.1640625 249.4140625 C-115.1640625 248.7540625 -115.1640625 248.0940625 -115.1640625 247.4140625 C-124.57487341 245.41176231 -129.37438541 254.4483901 -133.80224609 261.59960938 Z M-93.1640625 247.4140625 C-93.1640625 247.7440625 -93.1640625 248.0740625 -93.1640625 248.4140625 C-90.1940625 248.4140625 -87.2240625 248.4140625 -84.1640625 248.4140625 C-84.1640625 248.0840625 -84.1640625 247.7540625 -84.1640625 247.4140625 C-87.1340625 247.4140625 -90.1040625 247.4140625 -93.1640625 247.4140625 Z M-82.1640625 247.4140625 C-78.1640625 248.4140625 -78.1640625 248.4140625 -78.1640625 248.4140625 Z M-77.1640625 247.4140625 C-77.1640625 247.7440625 -77.1640625 248.0740625 -77.1640625 248.4140625 C-74.8540625 248.4140625 -72.5440625 248.4140625 -70.1640625 248.4140625 C-70.1640625 248.0840625 -70.1640625 247.7540625 -70.1640625 247.4140625 C-72.4740625 247.4140625 -74.7840625 247.4140625 -77.1640625 247.4140625 Z M-134.515625 276.875 C-135.26585937 277.83664062 -136.01609375 278.79828125 -136.7890625 279.7890625 C-137.54445313 280.74554687 -138.29984375 281.70203125 -139.078125 282.6875 C-140.78611706 284.92004393 -142.47748723 287.16529548 -144.1640625 289.4140625 C-95.9840625 289.4140625 -47.8040625 289.4140625 1.8359375 289.4140625 C-0.09507624 285.55203503 -2.35971689 282.50649037 -5.1015625 279.2265625 C-5.54435547 278.68064453 -5.98714844 278.13472656 -6.44335938 277.57226562 C-8.63636157 274.93478013 -9.84707288 273.51972571 -13.1640625 272.4140625 C-14.71356036 272.3207291 -16.26675816 272.28347863 -17.81906128 272.28034973 C-18.77517303 272.27608475 -19.73128479 272.27181976 -20.71636963 272.26742554 C-22.28738434 272.26810532 -22.28738434 272.26810532 -23.89013672 272.26879883 C-25.54660721 272.26376091 -25.54660721 272.26376091 -27.23654175 272.25862122 C-30.89728919 272.24910058 -34.55799094 272.24716753 -38.21875 272.24609375 C-40.75839253 272.24288192 -43.29803487 272.23951791 -45.837677 272.23600769 C-51.16571557 272.23001362 -56.49373705 272.22812532 -61.82177734 272.22875977 C-67.97646049 272.22936036 -74.13105594 272.21881175 -80.28571689 272.2030161 C-86.2097281 272.18835509 -92.13371256 272.18477197 -98.05774307 272.18536949 C-100.57675662 272.184188 -103.0957708 272.17975682 -105.6147728 272.17203712 C-109.13632258 272.16225582 -112.6576459 272.16510808 -116.17919922 272.17114258 C-117.2224939 272.16552307 -118.26578857 272.15990356 -119.34069824 272.15411377 C-120.30244965 272.15830826 -121.26420105 272.16250275 -122.25509644 272.16682434 C-123.08726622 272.16627957 -123.919436 272.16573481 -124.77682304 272.16517353 C-129.02485088 272.6080647 -131.56901322 273.79133651 -134.515625 276.875 Z ",
  fill: "#F3F3F3",
  transform: "translate(581.1640625,373.5859375)"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C1.81455688 0.07069702 1.81455688 0.07069702 3.66577148 0.14282227 C5.62353516 0.21533203 5.62353516 0.21533203 7.62084961 0.28930664 C9.00952598 0.34583683 10.39819781 0.40247892 11.78686523 0.45922852 C13.17942544 0.51243399 14.5720035 0.56517448 15.96459961 0.61743164 C19.38472504 0.74760943 22.80459448 0.88259032 26.22436523 1.02172852 C25.35811523 2.70202148 25.35811523 2.70202148 24.47436523 4.41625977 C23.72404918 5.88875501 22.97406648 7.36142015 22.22436523 8.83422852 C21.65202148 9.94121094 21.65202148 9.94121094 21.06811523 11.07055664 C20.70717773 11.78276367 20.34624023 12.4949707 19.97436523 13.22875977 C19.63920898 13.88336182 19.30405273 14.53796387 18.95874023 15.21240234 C18.0363226 17.15957401 18.0363226 17.15957401 18.22436523 20.02172852 C19.37936523 19.40297852 20.53436523 18.78422852 21.72436523 18.14672852 C25.84296603 16.08375735 29.70283239 14.89430503 34.22436523 14.02172852 C35.22436523 15.02172852 35.22436523 15.02172852 35.33789062 17.52197266 C35.3300354 19.14800415 35.3300354 19.14800415 35.32202148 20.80688477 C35.3171875 22.56162109 35.3171875 22.56162109 35.31225586 24.35180664 C35.2996875 26.19935547 35.2996875 26.19935547 35.28686523 28.08422852 C35.28235352 29.31979492 35.2778418 30.55536133 35.27319336 31.82836914 C35.26136131 34.89286968 35.24487697 37.95727573 35.22436523 41.02172852 C30.46219564 39.1544413 26.86154845 37.22601048 22.91186523 33.89672852 C19.75015416 31.18014485 19.75015416 31.18014485 16.22436523 29.02172852 C17.28246548 36.8706214 18.91083637 42.33511166 25.02514648 47.56079102 C31.83243603 52.15026306 39.29108368 51.96637505 47.22436523 51.02172852 C51.44606914 49.8459058 54.30423282 48.11995108 57.16186523 44.70922852 C58.43486567 41.48928623 58.8874395 38.45837103 59.22436523 35.02172852 C57.90436523 34.69172852 56.58436523 34.36172852 55.22436523 34.02172852 C53.90436523 36.33172852 52.58436523 38.64172852 51.22436523 41.02172852 C47.3879504 39.51456555 45.36445705 37.53759364 43.22436523 34.02172852 C42.6038915 31.20967325 42.57879701 28.83051657 43.22436523 26.02172852 C45.28686523 23.02172852 45.28686523 23.02172852 48.22436523 21.02172852 C52.67162646 20.47557363 55.35317397 20.91247989 59.22436523 23.02172852 C59.10577148 22.44165039 58.98717773 21.86157227 58.86499023 21.26391602 C58.15888487 16.98491749 57.9224256 14.67391814 59.78686523 10.64672852 C62.46427432 7.76336489 64.52067206 6.33345318 68.22436523 5.02172852 C70.47436523 5.14672852 70.47436523 5.14672852 72.22436523 6.02172852 C74.3901373 9.27038662 74.4739199 10.20774199 74.41186523 13.95922852 C74.40219727 15.24120117 74.40219727 15.24120117 74.39233398 16.54907227 C74.23712213 18.83393519 73.86061 20.82795656 73.22436523 23.02172852 C74.21436523 22.36172852 75.20436523 21.70172852 76.22436523 21.02172852 C78.94481655 21.22576236 80.67367258 21.63420406 82.91186523 23.20922852 C84.80348358 25.82146337 85.61188469 27.83682969 86.22436523 31.02172852 C84.97395359 34.90458571 83.70403912 38.65555027 80.22436523 41.02172852 C78.90436523 41.02172852 77.58436523 41.02172852 76.22436523 41.02172852 C75.23436523 38.05172852 75.23436523 38.05172852 74.22436523 35.02172852 C73.23436523 35.02172852 72.24436523 35.02172852 71.22436523 35.02172852 C69.61593734 38.2385843 69.75657988 41.53282941 70.22436523 45.02172852 C72.44573087 49.38218698 74.66003552 52.15450272 79.22436523 54.02172852 C85.93303134 54.81767195 91.29395967 53.21659417 97.22436523 50.02172852 C99.11040028 48.46981623 100.59499714 46.85476762 102.22436523 45.02172852 C102.88436523 45.02172852 103.54436523 45.02172852 104.22436523 45.02172852 C104.43061523 44.29985352 104.63686523 43.57797852 104.84936523 42.83422852 C106.67684686 39.09619791 108.92875329 37.52925934 112.22436523 35.02172852 C111.34936523 40.77172852 111.34936523 40.77172852 110.22436523 43.02172852 C109.56436523 43.02172852 108.90436523 43.02172852 108.22436523 43.02172852 C103.44065885 53.77993514 102.90069736 66.94258757 101.47436523 78.52172852 C101.33458252 79.63837891 101.1947998 80.7550293 101.05078125 81.90551758 C100.92759521 82.94417969 100.80440918 83.9828418 100.67749023 85.05297852 C100.56566406 85.9869043 100.45383789 86.92083008 100.33862305 87.88305664 C100.30091797 88.58881836 100.26321289 89.29458008 100.22436523 90.02172852 C100.55436523 90.35172852 100.88436523 90.68172852 101.22436523 91.02172852 C101.26517306 93.02131215 101.2669088 95.02218106 101.22436523 97.02172852 C100.29624023 96.85672852 99.36811523 96.69172852 98.41186523 96.52172852 C93.36702903 95.7847257 88.31000813 95.93896037 83.22436523 96.02172852 C83.22436523 95.69172852 83.22436523 95.36172852 83.22436523 95.02172852 C59.61487905 93.21937542 36.10538324 92.67423418 12.43212891 92.70605469 C8.67028874 92.71069271 4.90877145 92.70371391 1.14697266 92.68554688 C-37.52440428 92.10399288 -37.52440428 92.10399288 -75.77563477 97.02172852 C-77.90594568 88.41775432 -78.3600349 79.83682041 -78.77563477 71.02172852 C-79.76563477 71.02172852 -80.75563477 71.02172852 -81.77563477 71.02172852 C-81.56938477 70.13485352 -81.36313477 69.24797852 -81.15063477 68.33422852 C-79.89310839 59.47764987 -82.70927053 50.24515988 -85.77563477 42.02172852 C-84.78563477 42.02172852 -83.79563477 42.02172852 -82.77563477 42.02172852 C-81.16235352 43.66625977 -81.16235352 43.66625977 -79.46313477 45.83422852 C-74.93292054 51.16500035 -71.13700442 52.99764504 -64.21313477 53.89672852 C-59.78740393 54.21542924 -57.33084091 53.88883024 -53.77563477 51.02172852 C-53.11563477 51.02172852 -52.45563477 51.02172852 -51.77563477 51.02172852 C-51.48688477 50.44422852 -51.19813477 49.86672852 -50.90063477 49.27172852 C-49.77563477 47.02172852 -49.77563477 47.02172852 -48.65063477 45.14672852 C-47.49279441 42.3348305 -47.57919831 40.03375424 -47.77563477 37.02172852 C-48.10563477 36.36172852 -48.43563477 35.70172852 -48.77563477 35.02172852 C-49.76563477 35.02172852 -50.75563477 35.02172852 -51.77563477 35.02172852 C-52.02313477 35.99110352 -52.27063477 36.96047852 -52.52563477 37.95922852 C-53.77563477 41.02172852 -53.77563477 41.02172852 -55.65063477 42.14672852 C-57.77563477 42.02172852 -57.77563477 42.02172852 -59.90063477 40.39672852 C-62.74302918 36.79636226 -63.64428269 34.07254511 -64.21313477 29.52172852 C-63.77563477 26.02172852 -63.77563477 26.02172852 -61.58813477 23.08422852 C-58.77563477 21.02172852 -58.77563477 21.02172852 -56.15063477 20.64672852 C-53.77563477 21.02172852 -53.77563477 21.02172852 -50.77563477 22.02172852 C-51.27063477 21.03172852 -51.27063477 21.03172852 -51.77563477 20.02172852 C-52.29838093 14.34189035 -52.48999419 9.6646778 -48.77563477 5.02172852 C-43.90732196 5.47459482 -41.29004251 6.60494321 -37.77563477 10.02172852 C-35.91481843 13.04395092 -35.5469479 15.24637495 -35.65063477 18.77172852 C-35.66868164 19.57094727 -35.68672852 20.37016602 -35.70532227 21.19360352 C-35.72852539 21.79688477 -35.75172852 22.40016602 -35.77563477 23.02172852 C-34.78563477 22.36172852 -33.79563477 21.70172852 -32.77563477 21.02172852 C-25.80063477 20.24672852 -25.80063477 20.24672852 -22.21313477 22.95922852 C-20.20199927 27.24382152 -20.49688188 30.51758617 -21.77563477 35.02172852 C-23.58813477 38.08422852 -23.58813477 38.08422852 -25.77563477 40.02172852 C-27.09563477 40.02172852 -28.41563477 40.02172852 -29.77563477 40.02172852 C-30.79429706 38.36640229 -31.79374289 36.69912713 -32.77563477 35.02172852 C-34.8609711 34.14350539 -34.8609711 34.14350539 -36.77563477 34.02172852 C-37.09852629 38.05787254 -37.01193048 40.53968526 -35.21313477 44.20922852 C-32.275845 47.59840901 -29.77004624 49.02452278 -25.77563477 51.02172852 C-24.78563477 51.51672852 -24.78563477 51.51672852 -23.77563477 52.02172852 C-16.01652906 52.74989074 -10.38153286 52.13540142 -3.77563477 48.02172852 C-2.71022461 47.51319336 -2.71022461 47.51319336 -1.62329102 46.99438477 C0.8400834 45.69759781 1.18254219 44.59155869 2.22436523 42.02172852 C2.73999023 40.88735352 3.25561523 39.75297852 3.78686523 38.58422852 C4.96809968 35.65682141 5.75453501 33.12260799 6.22436523 30.02172852 C1.34909271 32.71868779 -3.167784 35.65042769 -7.66235352 38.94750977 C-9.77563477 40.02172852 -9.77563477 40.02172852 -13.77563477 39.02172852 C-13.44563477 30.11172852 -13.11563477 21.20172852 -12.77563477 12.02172852 C-7.33076308 12.92920713 -4.57587295 13.96037035 0.09936523 16.58422852 C1.25178711 17.22489258 2.40420898 17.86555664 3.59155273 18.52563477 C4.46038086 19.0193457 5.32920898 19.51305664 6.22436523 20.02172852 C5.67006836 18.98532227 5.11577148 17.94891602 4.54467773 16.88110352 C3.81287915 15.51132668 3.08110985 14.14153419 2.34936523 12.77172852 C1.98456055 12.08981445 1.61975586 11.40790039 1.24389648 10.70532227 C-0.4695705 7.49646592 -2.17557463 4.28921973 -3.77563477 1.02172852 C-2.77563477 0.02172852 -2.77563477 0.02172852 0 0 Z ",
  fill: "#F9F9F9",
  transform: "translate(498.775634765625,244.978271484375)"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.84167725 0.16226074 1.68335449 0.32452148 2.55053711 0.49169922 C6.14968257 1.0220567 9.55440281 1.12949212 13.19140625 1.1328125 C13.85913559 1.13376923 14.52686493 1.13472595 15.21482849 1.13571167 C16.61742243 1.1363882 18.0200196 1.13457094 19.42260742 1.13037109 C21.55980497 1.12500676 23.6967932 1.13033834 25.83398438 1.13671875 C27.20312546 1.13605804 28.57226642 1.13477703 29.94140625 1.1328125 C31.17576416 1.13168457 32.41012207 1.13055664 33.68188477 1.12939453 C36.59299052 1.0158719 39.16248474 0.59844747 42 0 C43.67036887 0.31425584 45.33665741 0.65045699 47 1 C49.71840075 1.06837024 52.40848183 1.09466278 55.125 1.0625 C56.19814453 1.05573242 56.19814453 1.05573242 57.29296875 1.04882812 C59.19534142 1.0363827 61.09767647 1.01848911 63 1 C63.99 1 64.98 1 66 1 C68 3 68 3 68.24723816 5.77735901 C68.24581314 6.96014938 68.24438812 8.14293976 68.24291992 9.36157227 C68.24481827 10.01374725 68.24671661 10.66592224 68.24867249 11.33786011 C68.25238279 13.49749706 68.24167372 15.6567991 68.23046875 17.81640625 C68.22927709 19.31330831 68.22882376 20.81021113 68.2290802 22.30711365 C68.22751496 25.44526851 68.21922151 28.58330936 68.20581055 31.72143555 C68.18880597 35.75243731 68.18499659 39.78331384 68.18575573 43.81434727 C68.18548438 46.90517888 68.18000915 49.99598289 68.17275429 53.08680534 C68.16956303 54.57362598 68.16759915 56.06044976 68.16686058 57.54727364 C68.16470265 59.62084457 68.1559709 61.69428019 68.14526367 63.76782227 C68.14145187 64.94981705 68.13764008 66.13181183 68.13371277 67.34962463 C68 70 68 70 67 71 C65.19512677 71.15783112 63.38426511 71.2476915 61.57359314 71.3105011 C60.41757127 71.35160853 59.2615494 71.39271597 58.07049656 71.43506908 C56.807074 71.47365693 55.54365145 71.51224478 54.24194336 71.55200195 C52.93513831 71.59404157 51.62833326 71.63608118 50.28192806 71.67939472 C36.56567881 72.10107463 22.85099108 72.16392966 9.12890625 72.16796875 C6.49429813 72.1711945 3.85969017 72.17455948 1.2250824 72.17805481 C-4.22584323 72.18435517 -9.67675677 72.18594606 -15.12768555 72.18530273 C-21.41013012 72.18469509 -27.69249077 72.19541293 -33.97491401 72.2110464 C-40.08265496 72.22569483 -46.19035528 72.22929146 -52.29811287 72.22869301 C-54.87491265 72.22987066 -57.4517131 72.23428033 -60.02850151 72.24202538 C-63.60688338 72.25180236 -67.18504243 72.24895965 -70.76342773 72.24291992 C-71.8183844 72.24853943 -72.87334106 72.25415894 -73.96026611 72.25994873 C-79.04046777 72.23811672 -83.2465612 72.03735942 -88 70 C-88.07427838 66.65747276 -88.06546953 64.1964086 -87 61 C-86.92938558 59.24999811 -86.91577294 57.49738497 -86.9375 55.74609375 C-86.94523437 54.72708984 -86.95296875 53.70808594 -86.9609375 52.65820312 C-86.97382813 51.59537109 -86.98671875 50.53253906 -87 49.4375 C-87.02544312 47.33208191 -87.04649865 45.22660477 -87.0625 43.12109375 C-87.07410156 42.1870874 -87.08570313 41.25308105 -87.09765625 40.29077148 C-87 38 -87 38 -86 36 C-86.66 35.67 -87.32 35.34 -88 35 C-87.83483887 34.3002002 -87.66967773 33.60040039 -87.49951172 32.87939453 C-86.96766639 29.81361553 -86.93535163 27.03878659 -87.0078125 23.9296875 C-87.02457031 22.78628906 -87.04132813 21.64289062 -87.05859375 20.46484375 C-87.10301195 18.06364805 -87.15514658 15.66258318 -87.21484375 13.26171875 C-87.22902344 12.12089844 -87.24320312 10.98007812 -87.2578125 9.8046875 C-87.2798877 8.76296387 -87.30196289 7.72124023 -87.32470703 6.64794922 C-87 4 -87 4 -85.96946716 2.35678101 C-82.91624872 0.25339545 -79.74077496 0.59977221 -76.16381836 0.64355469 C-74.96829094 0.64048813 -74.96829094 0.64048813 -73.74861145 0.63735962 C-71.11212276 0.6343496 -68.47625818 0.65283403 -65.83984375 0.671875 C-64.01046402 0.67493216 -62.18108196 0.67680861 -60.35169983 0.67755127 C-56.51749771 0.68215561 -52.68350548 0.69658736 -48.84936523 0.71875 C-43.92729407 0.74705239 -39.00538817 0.75796336 -34.08324337 0.7624321 C-30.30609983 0.76658285 -26.5289899 0.77639713 -22.75186348 0.78830719 C-20.93652173 0.7940159 -19.12117674 0.79877262 -17.30583 0.80257416 C-14.77275753 0.80942633 -12.23981748 0.82305329 -9.70678711 0.83886719 C-8.95193024 0.83998505 -8.19707336 0.84110291 -7.41934204 0.84225464 C-2.22938822 0.88530589 -2.22938822 0.88530589 0 2 C0 1.34 0 0.68 0 0 Z ",
  fill: "#F9F9F9",
  transform: "translate(520,672)"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C1.81455688 0.07069702 1.81455688 0.07069702 3.66577148 0.14282227 C5.62353516 0.21533203 5.62353516 0.21533203 7.62084961 0.28930664 C9.00952598 0.34583683 10.39819781 0.40247892 11.78686523 0.45922852 C13.17942544 0.51243399 14.5720035 0.56517448 15.96459961 0.61743164 C19.38472504 0.74760943 22.80459448 0.88259032 26.22436523 1.02172852 C25.35811523 2.70202148 25.35811523 2.70202148 24.47436523 4.41625977 C23.72404918 5.88875501 22.97406648 7.36142015 22.22436523 8.83422852 C21.65202148 9.94121094 21.65202148 9.94121094 21.06811523 11.07055664 C20.70717773 11.78276367 20.34624023 12.4949707 19.97436523 13.22875977 C19.63920898 13.88336182 19.30405273 14.53796387 18.95874023 15.21240234 C18.0363226 17.15957401 18.0363226 17.15957401 18.22436523 20.02172852 C19.37936523 19.40297852 20.53436523 18.78422852 21.72436523 18.14672852 C25.84296603 16.08375735 29.70283239 14.89430503 34.22436523 14.02172852 C35.22436523 15.02172852 35.22436523 15.02172852 35.33789062 17.52197266 C35.3300354 19.14800415 35.3300354 19.14800415 35.32202148 20.80688477 C35.3171875 22.56162109 35.3171875 22.56162109 35.31225586 24.35180664 C35.2996875 26.19935547 35.2996875 26.19935547 35.28686523 28.08422852 C35.28235352 29.31979492 35.2778418 30.55536133 35.27319336 31.82836914 C35.26136131 34.89286968 35.24487697 37.95727573 35.22436523 41.02172852 C30.46219564 39.1544413 26.86154845 37.22601048 22.91186523 33.89672852 C19.75015416 31.18014485 19.75015416 31.18014485 16.22436523 29.02172852 C17.28246548 36.8706214 18.91083637 42.33511166 25.02514648 47.56079102 C31.83243603 52.15026306 39.29108368 51.96637505 47.22436523 51.02172852 C51.44606914 49.8459058 54.30423282 48.11995108 57.16186523 44.70922852 C58.43486567 41.48928623 58.8874395 38.45837103 59.22436523 35.02172852 C57.90436523 34.69172852 56.58436523 34.36172852 55.22436523 34.02172852 C53.90436523 36.33172852 52.58436523 38.64172852 51.22436523 41.02172852 C47.3879504 39.51456555 45.36445705 37.53759364 43.22436523 34.02172852 C42.6038915 31.20967325 42.57879701 28.83051657 43.22436523 26.02172852 C45.28686523 23.02172852 45.28686523 23.02172852 48.22436523 21.02172852 C52.67162646 20.47557363 55.35317397 20.91247989 59.22436523 23.02172852 C59.10577148 22.44165039 58.98717773 21.86157227 58.86499023 21.26391602 C58.15888487 16.98491749 57.9224256 14.67391814 59.78686523 10.64672852 C62.46427432 7.76336489 64.52067206 6.33345318 68.22436523 5.02172852 C70.47436523 5.14672852 70.47436523 5.14672852 72.22436523 6.02172852 C74.3901373 9.27038662 74.4739199 10.20774199 74.41186523 13.95922852 C74.40219727 15.24120117 74.40219727 15.24120117 74.39233398 16.54907227 C74.23712213 18.83393519 73.86061 20.82795656 73.22436523 23.02172852 C74.21436523 22.36172852 75.20436523 21.70172852 76.22436523 21.02172852 C78.94481655 21.22576236 80.67367258 21.63420406 82.91186523 23.20922852 C84.80348358 25.82146337 85.61188469 27.83682969 86.22436523 31.02172852 C84.97395359 34.90458571 83.70403912 38.65555027 80.22436523 41.02172852 C78.90436523 41.02172852 77.58436523 41.02172852 76.22436523 41.02172852 C75.23436523 38.05172852 75.23436523 38.05172852 74.22436523 35.02172852 C73.23436523 35.02172852 72.24436523 35.02172852 71.22436523 35.02172852 C69.61593734 38.2385843 69.75657988 41.53282941 70.22436523 45.02172852 C72.44573087 49.38218698 74.66003552 52.15450272 79.22436523 54.02172852 C85.93303134 54.81767195 91.29395967 53.21659417 97.22436523 50.02172852 C99.11040028 48.46981623 100.59499714 46.85476762 102.22436523 45.02172852 C102.88436523 45.02172852 103.54436523 45.02172852 104.22436523 45.02172852 C104.43061523 44.29985352 104.63686523 43.57797852 104.84936523 42.83422852 C106.67684686 39.09619791 108.92875329 37.52925934 112.22436523 35.02172852 C111.34936523 40.77172852 111.34936523 40.77172852 110.22436523 43.02172852 C109.56436523 43.02172852 108.90436523 43.02172852 108.22436523 43.02172852 C105.9849621 47.82044952 105.16827883 52.85028698 104.22436523 58.02172852 C103.89436523 58.02172852 103.56436523 58.02172852 103.22436523 58.02172852 C102.89436523 56.04172852 102.56436523 54.06172852 102.22436523 52.02172852 C101.21116211 52.76229492 101.21116211 52.76229492 100.17749023 53.51782227 C98.83944336 54.47881836 98.83944336 54.47881836 97.47436523 55.45922852 C96.15178711 56.41635742 96.15178711 56.41635742 94.80249023 57.39282227 C89.1736924 60.94919908 82.46944861 60.7811352 76.04077148 59.63110352 C70.80033147 58.03751942 68.01238889 55.00838181 64.66967773 50.76391602 C63.32386189 48.90362598 63.32386189 48.90362598 61.22436523 48.02172852 C61.22436523 48.68172852 61.22436523 49.34172852 61.22436523 50.02172852 C53.05463569 56.28568028 44.65760027 60.37070653 34.22436523 59.02172852 C24.46329363 56.45464354 17.01798218 50.25364332 10.22436523 43.02172852 C9.77448242 43.60180664 9.32459961 44.18188477 8.86108398 44.77954102 C3.16510424 51.69690319 -3.73776566 57.3073286 -12.77563477 59.02172852 C-21.7553394 59.65188323 -29.69918229 58.03644834 -36.77563477 52.27172852 C-37.47688477 51.63750977 -38.17813477 51.00329102 -38.90063477 50.34985352 C-39.51938477 49.91157227 -40.13813477 49.47329102 -40.77563477 49.02172852 C-44.08484752 50.12479943 -44.48587105 50.7112758 -46.46313477 53.39672852 C-50.27705703 57.97155645 -54.15754188 59.57184306 -60.00610352 60.29907227 C-66.83266749 60.59281426 -72.65433696 58.91415058 -78.02563477 54.64672852 C-82.60692592 50.27367787 -85.17496085 47.47897309 -85.77563477 41.02172852 C-82.35098136 42.16327965 -81.66229377 43.1364048 -79.46313477 45.89672852 C-74.92332845 51.17271964 -71.10064387 53.00236656 -64.21313477 53.89672852 C-59.78740393 54.21542924 -57.33084091 53.88883024 -53.77563477 51.02172852 C-53.11563477 51.02172852 -52.45563477 51.02172852 -51.77563477 51.02172852 C-51.48688477 50.44422852 -51.19813477 49.86672852 -50.90063477 49.27172852 C-49.77563477 47.02172852 -49.77563477 47.02172852 -48.65063477 45.14672852 C-47.49279441 42.3348305 -47.57919831 40.03375424 -47.77563477 37.02172852 C-48.10563477 36.36172852 -48.43563477 35.70172852 -48.77563477 35.02172852 C-49.76563477 35.02172852 -50.75563477 35.02172852 -51.77563477 35.02172852 C-52.02313477 35.99110352 -52.27063477 36.96047852 -52.52563477 37.95922852 C-53.77563477 41.02172852 -53.77563477 41.02172852 -55.65063477 42.14672852 C-57.77563477 42.02172852 -57.77563477 42.02172852 -59.90063477 40.39672852 C-62.74302918 36.79636226 -63.64428269 34.07254511 -64.21313477 29.52172852 C-63.77563477 26.02172852 -63.77563477 26.02172852 -61.58813477 23.08422852 C-58.77563477 21.02172852 -58.77563477 21.02172852 -56.15063477 20.64672852 C-53.77563477 21.02172852 -53.77563477 21.02172852 -50.77563477 22.02172852 C-51.27063477 21.03172852 -51.27063477 21.03172852 -51.77563477 20.02172852 C-52.29838093 14.34189035 -52.48999419 9.6646778 -48.77563477 5.02172852 C-43.90732196 5.47459482 -41.29004251 6.60494321 -37.77563477 10.02172852 C-35.91481843 13.04395092 -35.5469479 15.24637495 -35.65063477 18.77172852 C-35.66868164 19.57094727 -35.68672852 20.37016602 -35.70532227 21.19360352 C-35.72852539 21.79688477 -35.75172852 22.40016602 -35.77563477 23.02172852 C-34.78563477 22.36172852 -33.79563477 21.70172852 -32.77563477 21.02172852 C-25.80063477 20.24672852 -25.80063477 20.24672852 -22.21313477 22.95922852 C-20.20199927 27.24382152 -20.49688188 30.51758617 -21.77563477 35.02172852 C-23.58813477 38.08422852 -23.58813477 38.08422852 -25.77563477 40.02172852 C-27.09563477 40.02172852 -28.41563477 40.02172852 -29.77563477 40.02172852 C-30.79429706 38.36640229 -31.79374289 36.69912713 -32.77563477 35.02172852 C-34.8609711 34.14350539 -34.8609711 34.14350539 -36.77563477 34.02172852 C-37.09852629 38.05787254 -37.01193048 40.53968526 -35.21313477 44.20922852 C-32.275845 47.59840901 -29.77004624 49.02452278 -25.77563477 51.02172852 C-24.78563477 51.51672852 -24.78563477 51.51672852 -23.77563477 52.02172852 C-16.01652906 52.74989074 -10.38153286 52.13540142 -3.77563477 48.02172852 C-2.71022461 47.51319336 -2.71022461 47.51319336 -1.62329102 46.99438477 C0.8400834 45.69759781 1.18254219 44.59155869 2.22436523 42.02172852 C2.73999023 40.88735352 3.25561523 39.75297852 3.78686523 38.58422852 C4.96809968 35.65682141 5.75453501 33.12260799 6.22436523 30.02172852 C1.34909271 32.71868779 -3.167784 35.65042769 -7.66235352 38.94750977 C-9.77563477 40.02172852 -9.77563477 40.02172852 -13.77563477 39.02172852 C-13.44563477 30.11172852 -13.11563477 21.20172852 -12.77563477 12.02172852 C-7.33076308 12.92920713 -4.57587295 13.96037035 0.09936523 16.58422852 C1.25178711 17.22489258 2.40420898 17.86555664 3.59155273 18.52563477 C4.46038086 19.0193457 5.32920898 19.51305664 6.22436523 20.02172852 C5.67006836 18.98532227 5.11577148 17.94891602 4.54467773 16.88110352 C3.81287915 15.51132668 3.08110985 14.14153419 2.34936523 12.77172852 C1.98456055 12.08981445 1.61975586 11.40790039 1.24389648 10.70532227 C-0.4695705 7.49646592 -2.17557463 4.28921973 -3.77563477 1.02172852 C-2.77563477 0.02172852 -2.77563477 0.02172852 0 0 Z ",
  fill: "#060606",
  transform: "translate(498.775634765625,244.978271484375)"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C2.639375 1.814375 3.27875 1.62875 3.9375 1.4375 C8.07334611 0.84666484 11.8851173 1.41728241 16 2 C16.6171875 3.83984375 16.6171875 3.83984375 17 6 C15.125 8.5625 15.125 8.5625 13 11 C12.67 11.99 12.34 12.98 12 14 C12.66 14.33 13.32 14.66 14 15 C14.33 15.33 14.66 15.66 15 16 C15.33 15.01 15.66 14.02 16 13 C16 13.66 16 14.32 16 15 C16.99 15 17.98 15 19 15 C19 14.34 19 13.68 19 13 C19.66 13 20.32 13 21 13 C21 12.34 21 11.68 21 11 C22.485 11.495 22.485 11.495 24 12 C24.19491452 13.45736087 24.38069358 14.91594593 24.5625 16.375 C24.71912109 17.59316406 24.71912109 17.59316406 24.87890625 18.8359375 C25 21 25 21 24 23 C24.66 23 25.32 23 26 23 C26 24.98 26 26.96 26 29 C24.25 29.6875 24.25 29.6875 22 30 C19.56665433 28.5399926 18.27382218 27.54764436 17 25 C13.87802522 26.3089572 13.87802522 26.3089572 12 29 C12.66 29 13.32 29 14 29 C15.01351664 30.65848177 16.01120795 32.32665961 17 34 C17.66 34.61875 18.32 35.2375 19 35.875 C22.41102179 39.49921065 23.81998316 43.40985122 24.375 48.3125 C24.189375 49.6428125 24.189375 49.6428125 24 51 C20.63287354 53.24475097 19.49875945 53.2471312 15.5625 53.23046875 C13.97308594 53.22756836 13.97308594 53.22756836 12.3515625 53.22460938 C11.24554687 53.21236328 10.13953125 53.20011719 9 53.1875 C7.89398438 53.18685547 6.78796875 53.18621094 5.6484375 53.18554688 C-2.57847287 53.14050904 -2.57847287 53.14050904 -6 52 C-8.09021862 47.81956277 -7.52078562 42.2881762 -6.50390625 37.8203125 C-5.8125 35.9375 -5.8125 35.9375 -4 33 C-1.3125 32.0625 -1.3125 32.0625 1 32 C1.33 31.01 1.66 30.02 2 29 C2.66 29 3.32 29 4 29 C3.67 27.68 3.34 26.36 3 25 C2.30132812 25.3609375 1.60265625 25.721875 0.8828125 26.09375 C-0.02726562 26.5578125 -0.93734375 27.021875 -1.875 27.5 C-2.77992188 27.9640625 -3.68484375 28.428125 -4.6171875 28.90625 C-7 30 -7 30 -9 30 C-9.87460154 26.50159382 -9.85970794 24.43883174 -9 21 C-8.93451508 19.41788427 -8.91421619 17.83329919 -8.9375 16.25 C-8.958125 14.8475 -8.97875 13.445 -9 12 C-5.37 12.33 -1.74 12.66 2 13 C0.97388039 10.43470097 -0.06213152 7.86952381 -1.25 5.375 C-1.4975 4.59125 -1.745 3.8075 -2 3 C-1.34 2.01 -0.68 1.02 0 0 Z M0 14 C1 16 1 16 1 16 Z ",
  fill: "#F6F6F6",
  transform: "translate(502,131)"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C4.88574114 -0.83449885 9.13389222 -1.04701089 14 0 C17.99631105 3.2724894 20.80533879 7.0172308 23.74609375 11.23388672 C25.63385529 13.89277826 27.72408704 16.37238513 29.8125 18.875 C30.52921875 19.75800781 31.2459375 20.64101563 31.984375 21.55078125 C33.80338731 23.76109272 35.66865274 25.91643476 37.5625 28.0625 C40 31 40 31 40 33 C40.66 33 41.32 33 42 33 C41.95584252 29.06655807 41.88601016 25.13449055 41.79248047 21.2019043 C41.75041351 19.20710869 41.72862136 17.21191918 41.70703125 15.21679688 C41.67480469 13.96318359 41.64257812 12.70957031 41.609375 11.41796875 C41.58842773 10.26063232 41.56748047 9.1032959 41.54589844 7.91088867 C41.28907693 4.88144862 41.28907693 4.88144862 38.96191406 3.22387695 C37.9907666 2.61805786 37.9907666 2.61805786 37 2 C37 1.34 37 0.68 37 0 C41.95 0 46.9 0 52 0 C52 0.66 52 1.32 52 2 C51.02885254 2.49753784 51.02885254 2.49753784 50.03808594 3.00512695 C47.14423479 5.83762069 47.48243748 8.11408109 47.39434814 12.04838562 C47.39250519 13.46882927 47.39250519 13.46882927 47.390625 14.91796875 C47.37408875 15.89034988 47.35755249 16.86273102 47.34051514 17.86457825 C47.29190534 20.97228224 47.27063524 24.07949647 47.25 27.1875 C47.22185121 29.29364461 47.19192532 31.39976627 47.16015625 33.50585938 C47.08614275 38.67053262 47.03664737 43.83493189 47 49 C44.66113281 49.15356445 44.66113281 49.15356445 42 49 C40.00335083 47.09713283 38.42315651 45.34463487 36.75 43.1875 C36.27183838 42.59654541 35.79367676 42.00559082 35.30102539 41.39672852 C34.32158697 40.18419124 33.34833717 38.96662888 32.38134766 37.74414062 C30.43172831 35.28247916 28.43307771 32.86196741 26.4375 30.4375 C25.7259375 29.5609375 25.014375 28.684375 24.28125 27.78125 C22.61020405 25.7439474 20.92554273 23.72563815 19.21875 21.71875 C18.7554126 21.17162354 18.2920752 20.62449707 17.81469727 20.06079102 C16.5036284 18.51544499 15.18749282 16.97440179 13.87109375 15.43359375 C12 13 12 13 12 11 C11.34 11 10.68 11 10 11 C10.04412307 15.64547409 10.1139203 20.289585 10.20751953 24.93432617 C10.23574193 26.51429392 10.25695025 28.09440318 10.27099609 29.67456055 C10.29240965 31.94653845 10.33904534 34.21681271 10.390625 36.48828125 C10.39185364 37.19463211 10.39308228 37.90098297 10.39434814 38.6287384 C10.41771723 40.86942159 10.41771723 40.86942159 11 44 C12.92470013 45.86662238 12.92470013 45.86662238 15 47 C15 47.66 15 48.32 15 49 C10.05 49 5.1 49 0 49 C0.81130371 48.18611816 1.62260742 47.37223633 2.45849609 46.53369141 C5.66457678 42.66476149 5.72858203 39.34278716 5.6640625 34.4609375 C5.66884613 33.65766022 5.67362976 32.85438293 5.67855835 32.02676392 C5.68194574 30.33748402 5.67282471 28.64813752 5.65185547 26.95898438 C5.62499813 24.37482005 5.65167392 21.79497035 5.68359375 19.2109375 C5.68029081 17.5650946 5.67388698 15.91925439 5.6640625 14.2734375 C5.67418365 13.50357513 5.68430481 12.73371277 5.69473267 11.94052124 C5.69494106 9.47939732 5.69494106 9.47939732 5 6 C2.58879651 3.59074033 2.58879651 3.59074033 0 2 C0 1.34 0 0.68 0 0 Z ",
  fill: "#070707",
  transform: "translate(479,683)"
});
var _ref0 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C12.21 0 24.42 0 37 0 C37 3.63 37 7.26 37 11 C36.18273437 10.19175781 35.36546875 9.38351562 34.5234375 8.55078125 C30.73711001 5.39550834 27.40966582 5.22848321 22.625 5.1875 C18.850625 5.0946875 18.850625 5.0946875 15 5 C15 10.28 15 15.56 15 21 C18.96 20.67 22.92 20.34 27 20 C27.33 19.01 27.66 18.02 28 17 C28.66 17 29.32 17 30 17 C30 21.62 30 26.24 30 31 C28.68 30.01 27.36 29.02 26 28 C23.42741334 27.22167356 23.42741334 27.22167356 20.75 26.8125 C19.41195312 26.57466797 19.41195312 26.57466797 18.046875 26.33203125 C17.37140625 26.22246094 16.6959375 26.11289062 16 26 C16.05993267 28.93969737 16.14690423 31.87427059 16.25 34.8125 C16.26417969 35.64587891 16.27835938 36.47925781 16.29296875 37.33789062 C16.32696863 42.19277127 16.32696863 42.19277127 19.046875 45.94921875 C20.01367188 46.46935547 20.01367188 46.46935547 21 47 C21 47.66 21 48.32 21 49 C14.07 49 7.14 49 0 49 C1 46 1 46 3.02709961 44.30444336 C5.77125304 41.09913904 5.59382325 38.16003973 5.56640625 34.12890625 C5.57260483 33.36956284 5.57880341 32.61021942 5.58518982 31.8278656 C5.59228001 30.22501912 5.5891278 28.62209887 5.57641602 27.01928711 C5.56256129 24.57332015 5.59661015 22.13119005 5.63476562 19.68554688 C5.63571703 18.12499907 5.63385687 16.56444649 5.62890625 15.00390625 C5.64879356 13.9130648 5.64879356 13.9130648 5.66908264 12.80018616 C5.59543337 8.76054288 5.17665573 7.20002639 2.46069336 4.12475586 C1.64866455 3.42358643 0.83663574 2.72241699 0 2 C0 1.34 0 0.68 0 0 Z ",
  fill: "#080708",
  transform: "translate(537,683)"
});
var _ref1 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C6.6 0 13.2 0 20 0 C20 0.66 20 1.32 20 2 C19.35095703 2.52537354 18.70191406 3.05074707 18.03320312 3.59204102 C15.14492036 7.01268618 15.42518976 10.25104459 15.46875 14.52734375 C15.4649231 15.3532753 15.46109619 16.17920685 15.45715332 17.03016663 C15.45443547 18.77427389 15.46178787 20.51842201 15.47851562 22.26245117 C15.49990159 24.92524664 15.47872562 27.58533592 15.453125 30.24804688 C15.45576883 31.94531843 15.46089497 33.64258831 15.46875 35.33984375 C15.45660461 36.5291172 15.45660461 36.5291172 15.44421387 37.74241638 C15.45682251 38.48991653 15.46943115 39.23741669 15.48242188 40.00756836 C15.48560425 40.6594664 15.48878662 41.31136444 15.49206543 41.98301697 C16.04405551 44.76418147 16.04405551 44.76418147 20 49 C13.4 49 6.8 49 0 49 C0 48.34 0 47.68 0 47 C0.64904297 46.47083984 1.29808594 45.94167969 1.96679688 45.39648438 C4.8282678 42.02374199 4.57531729 38.88035151 4.53125 34.65625 C4.5350769 33.85014282 4.53890381 33.04403564 4.54284668 32.21350098 C4.5455639 30.51227568 4.5382159 28.81100847 4.52148438 27.10986328 C4.5000699 24.50849104 4.52129019 21.90988028 4.546875 19.30859375 C4.54423169 17.65363975 4.53910663 15.99868746 4.53125 14.34375 C4.53934692 13.56761353 4.54744385 12.79147705 4.55578613 11.99182129 C4.49262148 8.34703901 4.36643065 6.4319024 1.96679688 3.60351562 C1.31775391 3.07435547 0.66871094 2.54519531 0 2 C0 1.34 0 0.68 0 0 Z ",
  fill: "#0A0A0A",
  transform: "translate(451,683)"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C1.8203125 1.38671875 1.8203125 1.38671875 3 3 C2.86528812 5.57948305 2.36218415 6.647322 0.51171875 8.44921875 C-0.09027344 8.85785156 -0.69226563 9.26648438 -1.3125 9.6875 C-1.90675781 10.10386719 -2.50101563 10.52023437 -3.11328125 10.94921875 C-8.69391738 14.0572749 -16.29335139 13.94663994 -22.35546875 12.3984375 C-24.2718334 11.68654219 -26.14003781 10.84840381 -28 10 C-28.804375 9.71125 -29.60875 9.4225 -30.4375 9.125 C-32 8 -32 8 -32.75 5.375 C-32.8325 4.59125 -32.915 3.8075 -33 3 C-23.92678607 -5.77077346 -10.48564251 -6.29559661 0 0 Z ",
  fill: "#060506",
  transform: "translate(525,313)"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C1.91015625 1.37109375 1.91015625 1.37109375 4.47265625 3.87109375 C2.6709311 8.45730321 -0.52500983 10.72690294 -4.71484375 13.12109375 C-10.50453533 14.66501151 -15.6591407 14.83855604 -21.02734375 12.05859375 C-23.52734375 9.87109375 -23.52734375 9.87109375 -25.52734375 6.87109375 C-25.58984375 4.93359375 -25.58984375 4.93359375 -24.52734375 2.87109375 C-18.1307205 -2.61172618 -7.66093277 -3.42196224 0 0 Z ",
  fill: "#050505",
  transform: "translate(477.52734375,312.12890625)"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2.875 1.625 2.875 1.625 4.875 3.625 C4.76685193 6.76129406 3.63279387 7.9064828 1.5625 10.3125 C-2.4822072 13.79282945 -5.62162822 13.97398641 -10.96484375 13.9140625 C-16.08914855 13.22835083 -20.76718944 10.52704285 -24.125 6.625 C-24.25 4.6875 -24.25 4.6875 -23.125 2.625 C-16.5378539 -2.64471688 -7.80680643 -3.18478505 0 0 Z ",
  fill: "#050506",
  transform: "translate(563.125,312.375)"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C1.5 1.375 1.5 1.375 3 3 C3 3.66 3 4.32 3 5 C-2.98102684 7.64544946 -8.93193971 7.26656532 -15.33935547 7.22705078 C-17.1987249 7.22748886 -17.1987249 7.22748886 -19.09565735 7.22793579 C-22.48165421 7.22678395 -25.86740503 7.21677666 -29.25335836 7.20278788 C-32.79675663 7.19025695 -36.34015843 7.18910816 -39.88357544 7.18673706 C-46.58764966 7.18052922 -53.29165839 7.16412786 -59.99570382 7.14403808 C-67.63051313 7.12165739 -75.26532563 7.1106802 -82.9001596 7.10064721 C-98.60014428 7.07976098 -114.30006368 7.04459859 -130 7 C-130 6.01 -130 5.02 -130 4 C-129.00839371 4.01252808 -128.01678741 4.02505615 -126.99513245 4.03796387 C-117.48409111 4.15785275 -107.97302412 4.27550139 -98.46193027 4.39115143 C-93.57641287 4.45062358 -88.69090641 4.51078971 -83.80541992 4.57275391 C-56.10352392 4.92522954 -56.10352392 4.92522954 -28.40000725 5.08811951 C-27.01007497 5.09180639 -25.62014578 5.09708596 -24.23022652 5.10414124 C-11.57047807 5.79259183 -11.57047807 5.79259183 0 2 C0 1.34 0 0.68 0 0 Z ",
  fill: "#C8C9CA",
  transform: "translate(575,634)"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3.0625 0.25 3.0625 0.25 6 1 C7.36952673 3.73905345 7.12621361 5.97087332 7 9 C6.67 9.66 6.34 10.32 6 11 C7.65 11.33 9.3 11.66 11 12 C10.68023004 14.95787213 10.48902419 16.54519647 8.26953125 18.609375 C5.7178803 20.17286509 3.90000982 20.61131114 0.9375 20.9375 C0.08027344 21.04964844 -0.77695312 21.16179687 -1.66015625 21.27734375 C-4 21 -4 21 -5.8125 19.2421875 C-7.65083598 15.77111891 -7.01603231 12.63739568 -6 9 C-4.46791213 5.58277791 -2.66505018 2.66505018 0 0 Z ",
  fill: "#0B0B0B",
  transform: "translate(595,266)"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3.54001194 1.60909634 5.21120293 4.66055439 7.3125 7.8125 C8.44693809 11.02674126 8.41832479 13.55716446 8.0625 16.9375 C6.0625 19.875 6.0625 19.875 4.0625 21.9375 C-0.50204251 21.39410208 -3.9103176 20.14286179 -7.9375 17.9375 C-7.9375 15.9575 -7.9375 13.9775 -7.9375 11.9375 C-6.6175 11.6075 -5.2975 11.2775 -3.9375 10.9375 C-4.2675 10.2775 -4.5975 9.6175 -4.9375 8.9375 C-5.1875 5.4375 -5.1875 5.4375 -4.9375 1.9375 C-1.9375 -0.0625 -1.9375 -0.0625 0 0 Z ",
  fill: "#090909",
  transform: "translate(422.9375,266.0625)"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C48.84 0 97.68 0 148 0 C146 2 146 2 143.82333374 2.20254517 C142.92176544 2.18033905 142.02019714 2.15813293 141.09130859 2.13525391 C140.07040131 2.11508209 139.04949402 2.09491028 137.99765015 2.0741272 C136.89240997 2.04193085 135.7871698 2.0097345 134.6484375 1.9765625 C133.5192691 1.95153656 132.39010071 1.92651062 131.22671509 1.90072632 C127.60917922 1.81835115 123.99217511 1.7218287 120.375 1.625 C117.92710527 1.5667784 115.47918853 1.50947476 113.03125 1.453125 C107.02053701 1.31274631 101.01020102 1.16074137 95 1 C95 1.66 95 2.32 95 3 C93.845 2.835 92.69 2.67 91.5 2.5 C87.29469675 1.97060899 83.23648446 1.92939193 79 2 C77.68 2 76.36 2 75 2 C73.824375 2.185625 72.64875 2.37125 71.4375 2.5625 C68 3 68 3 65 2 C64.0409375 2.495 64.0409375 2.495 63.0625 3 C61 4 61 4 59.27172852 3.56640625 C56.32498177 2.83169884 53.62599384 2.90641093 50.58984375 2.9375 C48.73456055 2.94910156 48.73456055 2.94910156 46.84179688 2.9609375 C44.90916992 2.98027344 44.90916992 2.98027344 42.9375 3 C40.38415662 3.02546976 37.83076413 3.04651615 35.27734375 3.0625 C34.14546631 3.07410156 33.01358887 3.08570313 31.84741211 3.09765625 C29 3 29 3 26 2 C24.63905708 1.90873089 23.27415442 1.86934548 21.91015625 1.8671875 C21.12576172 1.86589844 20.34136719 1.86460937 19.53320312 1.86328125 C18.31020508 1.86908203 18.31020508 1.86908203 17.0625 1.875 C16.25103516 1.87113281 15.43957031 1.86726562 14.60351562 1.86328125 C13.42499023 1.86521484 13.42499023 1.86521484 12.22265625 1.8671875 C11.50859619 1.86831543 10.79453613 1.86944336 10.05883789 1.87060547 C7.98786555 1.93757513 7.98786555 1.93757513 5.98608398 2.50830078 C4 3 4 3 0 3 C0 2.01 0 1.02 0 0 Z ",
  fill: "#CFCFD0",
  transform: "translate(417,529)"
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C31.68 0 63.36 0 96 0 C96 0.66 96 1.32 96 2 C93.78828827 2.71090734 92.39031461 3.09870025 90.10961914 2.52197266 C87.92451414 1.98132291 86.23455839 1.95017541 83.99609375 2.0859375 C83.25552734 2.12976563 82.51496094 2.17359375 81.75195312 2.21875 C80.98818359 2.2703125 80.22441406 2.321875 79.4375 2.375 C78.66986328 2.41882813 77.90222656 2.46265625 77.11132812 2.5078125 C73.88501972 2.71033578 71.07998188 2.97333937 68 4 C67.401875 3.835 66.80375 3.67 66.1875 3.5 C63.26739084 2.83254648 60.90570003 3.40565227 58 4 C58 3.67 58 3.34 58 3 C56.33388095 2.957279 54.66617115 2.95936168 53 3 C52.67 3.33 52.34 3.66 52 4 C49.32941149 4.14115161 46.67567762 4.04247107 44 4 C44 3.67 44 3.34 44 3 C45.32 2.67 46.64 2.34 48 2 C44.7 2.33 41.4 2.66 38 3 C38 3.33 38 3.66 38 4 C35.69 4 33.38 4 31 4 C32.32 3.67 33.64 3.34 35 3 C31.89459074 1.78918149 31.89459074 1.78918149 28 2 C28 2.66 28 3.32 28 4 C26.741875 3.855625 25.48375 3.71125 24.1875 3.5625 C12.62157223 2.26865644 12.62157223 2.26865644 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
  fill: "#D0D1D1",
  transform: "translate(504,668)"
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C32.34 0 64.68 0 98 0 C97.01 0.99 96.02 1.98 95 3 C95 2.34 95 1.68 95 1 C92.74943278 1.11433363 90.49953326 1.24186436 88.25 1.375 C86.99703125 1.44460938 85.7440625 1.51421875 84.453125 1.5859375 C81.12853081 1.76760089 81.12853081 1.76760089 78.984375 3.1015625 C75.91395721 4.49171228 73.27395662 3.53063068 70 3 C67.66356308 3.0823063 65.32871947 3.23067294 63 3.4375 C57.55552947 3.85004213 52.14775759 4.14031423 46.6875 4.1875 C44.83705078 4.20876953 44.83705078 4.20876953 42.94921875 4.23046875 C40 4 40 4 38 2 C37.01 2.66 36.02 3.32 35 4 C27.44524381 4.81785434 17.72065595 4.77461498 11 1 C11 1.66 11 2.32 11 3 C10.34 3 9.68 3 9 3 C9 2.34 9 1.68 9 1 C4.545 1.495 4.545 1.495 0 2 C0 1.34 0 0.68 0 0 Z M19 1 C19 1.33 19 1.66 19 2 C20.65 2 22.3 2 24 2 C24 1.67 24 1.34 24 1 C22.35 1 20.7 1 19 1 Z M26 1 C26 1.33 26 1.66 26 2 C27.98 2 29.96 2 32 2 C32 1.67 32 1.34 32 1 C30.02 1 28.04 1 26 1 Z M50 1 C54 2 54 2 54 2 Z M58 1 C58 1.33 58 1.66 58 2 C59.98 2 61.96 2 64 2 C64 1.67 64 1.34 64 1 C62.02 1 60.04 1 58 1 Z M65 1 C65 1.33 65 1.66 65 2 C66.65 2 68.3 2 70 2 C70 1.67 70 1.34 70 1 C68.35 1 66.7 1 65 1 Z ",
  fill: "#C9C9CA",
  transform: "translate(425,556)"
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C24.42 0 48.84 0 74 0 C74.495 0.99 74.495 0.99 75 2 C74.39671875 1.97679687 73.7934375 1.95359375 73.171875 1.9296875 C72.37265625 1.91164063 71.5734375 1.89359375 70.75 1.875 C69.56664062 1.84019531 69.56664062 1.84019531 68.359375 1.8046875 C65.99456485 1.84459784 65.99456485 1.84459784 64.1161499 2.99801636 C61.78883755 4.09998409 60.33860681 4.24283091 57.78222656 4.22705078 C56.5514035 4.22682419 56.5514035 4.22682419 55.29571533 4.22659302 C53.98144562 4.21110916 53.98144562 4.21110916 52.640625 4.1953125 C51.73624695 4.1924826 50.8318689 4.18965271 49.90008545 4.18673706 C47.01658805 4.17555782 44.13340325 4.15045733 41.25 4.125 C39.29297324 4.11496728 37.33594161 4.10584194 35.37890625 4.09765625 C30.58581738 4.07562585 25.79296166 4.04111144 21 4 C21 3.01 21 2.02 21 1 C20.67 1.66 20.34 2.32 20 3 C12.73312465 4.40071655 6.47475842 4.76439443 0 1 C0 0.67 0 0.34 0 0 Z M29 1 C29 1.33 29 1.66 29 2 C31.97 2 34.94 2 38 2 C38 1.67 38 1.34 38 1 C35.03 1 32.06 1 29 1 Z M40 1 C44 2 44 2 44 2 Z M45 1 C45 1.33 45 1.66 45 2 C47.31 2 49.62 2 52 2 C52 1.67 52 1.34 52 1 C49.69 1 47.38 1 45 1 Z ",
  fill: "#CECECF",
  transform: "translate(459,620)"
});
var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C24.43 2 47.86 2 72 2 C71.01 3.32 70.02 4.64 69 6 C67.68 6 66.36 6 65 6 C65 5.34 65 4.68 65 4 C63.84821259 4.00666183 63.84821259 4.00666183 62.67315674 4.01345825 C55.43406726 4.05354529 48.19503167 4.08398962 40.95586014 4.10362434 C37.2341971 4.11405811 33.51262584 4.12820982 29.79101562 4.15087891 C26.19893238 4.1726219 22.60693737 4.18457169 19.0147934 4.18975449 C17.64487062 4.19344764 16.27495262 4.20065945 14.90506744 4.21146011 C12.98526221 4.22599349 11.06536804 4.22681708 9.14550781 4.22705078 C8.05296692 4.231492 6.96042603 4.23593323 5.83477783 4.24050903 C3.02617009 4.00222033 1.38358455 3.45414413 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
  fill: "#D6D6D7",
  transform: "translate(418,666)"
});
var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.86832899 0.00184359 1.73665798 0.00368717 2.63129997 0.00558662 C3.62691948 0.0028373 4.62253899 0.00008797 5.64832878 -0.00274467 C7.29262367 0.00804115 7.29262367 0.00804115 8.97013664 0.01904488 C10.12135002 0.01875282 11.2725634 0.01846077 12.45866203 0.01815987 C16.27880603 0.01955759 20.09875702 0.03513974 23.91886711 0.05078316 C26.56159674 0.05451171 29.20432775 0.05735942 31.84705925 0.0593586 C38.10148595 0.06558071 44.35584294 0.08200137 50.61023891 0.10205758 C57.72984981 0.12439387 64.84946399 0.13540428 71.96910119 0.14544845 C86.616455 0.166367 101.26375383 0.20155715 115.91105461 0.24609566 C115.91105461 1.23609566 115.91105461 2.22609566 115.91105461 3.24609566 C114.92105461 2.75109566 114.92105461 2.75109566 113.91105461 2.24609566 C112.33985242 2.15354512 110.76473401 2.12417031 109.19080925 2.12584114 C108.19518974 2.12446648 107.19957024 2.12309181 106.17378044 2.12167549 C105.07758385 2.12527077 103.98138725 2.12886604 102.85197258 2.13257027 C101.7007592 2.13242424 100.54954582 2.13227821 99.36344719 2.13212776 C95.54335992 2.13282661 91.7233209 2.14061776 87.90324211 2.14843941 C85.26051167 2.15030368 82.61778088 2.15172754 79.97504997 2.15272713 C73.72064838 2.15583817 67.46626422 2.16404852 61.21187031 2.17407662 C54.09225202 2.18524478 46.9726329 2.19074998 39.85300803 2.19577205 C25.20568122 2.20623131 10.55836816 2.22382638 -4.08894539 2.24609566 C-2.08894539 0.24609566 -2.08894539 0.24609566 0 0 Z ",
  fill: "#D1D1D2",
  transform: "translate(454.08894538879395,644.7539043426514)"
});
var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 2 2 2 2.3125 5.9375 C2.23330121 8.49981382 2.11578846 9.78772116 0.875 12.0625 C-2.05926655 13.52963327 -3.94311864 12.97560044 -7 12 C-8.89979123 9.66843803 -9.00876349 7.92843151 -9.375 4.9375 C-9 2 -9 2 -7.3125 0.0625 C-4.38550346 -1.28233625 -3.01415011 -1.03115662 0 0 Z ",
  fill: "#090809",
  transform: "translate(442,315)"
});
var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C1.25 7.625 1.25 7.625 -1 11 C-4.03866799 11.41137202 -6.92159703 11.13193156 -10 11 C-10.33 8.03 -10.66 5.06 -11 2 C-6.97107804 -0.96244261 -4.82799816 -1.2350693 0 0 Z ",
  fill: "#ECECED",
  transform: "translate(634,208)"
});
var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.33 0 0.66 0 1 0 C1.33 3.3 1.66 6.6 2 10 C11.24 10 20.48 10 30 10 C29.67 10.99 29.34 11.98 29 13 C29.66 13.33 30.32 13.66 31 14 C31 15.32 31 16.64 31 18 C31.66 18 32.32 18 33 18 C32.7215625 19.11375 32.7215625 19.11375 32.4375 20.25 C31.81538234 22.87768296 31.81538234 22.87768296 32.5625 24.875 C33.24366225 28.18350237 32.02924404 30.85172412 31 34 C30.67 34 30.34 34 30 34 C30 27.73 30 21.46 30 15 C28.22625 15.020625 26.4525 15.04125 24.625 15.0625 C16.408122 15.0528217 8.84290551 14.50305495 1 12 C0.67 12 0.34 12 0 12 C-1.28571429 3.42857143 -1.28571429 3.42857143 0 0 Z M13 12 C17 13 17 13 17 13 Z ",
  fill: "#D1D2D2",
  transform: "translate(494,173)"
});
var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.81435814 5.40343405 1.62103302 8.03739882 -0.25 10.9375 C-2.64400485 12.39100294 -4.2500075 12.35256314 -7 12 C-9 10 -9 10 -9.375 6.0625 C-9.29434554 3.10516989 -9.23854038 2.29154935 -7.3125 -0.0625 C-4.3979332 -1.24408113 -2.95034182 -1.00932746 0 0 Z ",
  fill: "#0B0A0B",
  transform: "translate(586,315)"
});
var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.84167725 0.16226074 1.68335449 0.32452148 2.55053711 0.49169922 C6.14968257 1.0220567 9.55440281 1.12949212 13.19140625 1.1328125 C13.85913559 1.13376923 14.52686493 1.13472595 15.21482849 1.13571167 C16.61742243 1.1363882 18.0200196 1.13457094 19.42260742 1.13037109 C21.55980497 1.12500676 23.6967932 1.13033834 25.83398438 1.13671875 C27.20312546 1.13605804 28.57226642 1.13477703 29.94140625 1.1328125 C31.17576416 1.13168457 32.41012207 1.13055664 33.68188477 1.12939453 C36.59338812 1.0158564 39.16177823 0.59615188 42 0 C43.67364871 0.29629188 45.34074128 0.63155817 47 1 C48.93651019 1.06533435 50.87502861 1.08584303 52.8125 1.0625 C54.27623047 1.04896484 54.27623047 1.04896484 55.76953125 1.03515625 C56.50558594 1.02355469 57.24164062 1.01195312 58 1 C58 1.33 58 1.66 58 2 C50.57371968 2.98928258 43.27970435 3.16095463 35.79296875 3.16796875 C34.55001541 3.17129715 33.30706207 3.17462555 32.02644348 3.17805481 C29.41354745 3.18309515 26.80064503 3.18546403 24.18774414 3.18530273 C21.511895 3.18522089 18.83621495 3.19225945 16.16040039 3.20581055 C12.28786999 3.22407161 8.41553781 3.22903559 4.54296875 3.23046875 C2.74607857 3.24124702 2.74607857 3.24124702 0.91288757 3.25224304 C-0.7548597 3.2476281 -0.7548597 3.2476281 -2.45629883 3.24291992 C-3.43286942 3.24434494 -4.40944 3.24576996 -5.41560364 3.24723816 C-8.07937944 2.99240611 -9.71841275 2.35888823 -12 1 C-10.37509046 0.97301811 -8.75005367 0.95361243 -7.125 0.9375 C-6.22007812 0.92589844 -5.31515625 0.91429687 -4.3828125 0.90234375 C-2 1 -2 1 0 2 C0 1.34 0 0.68 0 0 Z ",
  fill: "#D1D2D3",
  transform: "translate(520,672)"
});
var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.33 0.33 0.66 0.66 1 1 C0.96777152 3.03039402 0.93188381 5.06128092 0.83984375 7.08984375 C0.81348256 9.24385229 0.81348256 9.24385229 3 11 C-0.61717404 11.94735511 -2.69698387 12.09147657 -6.3125 11 C-9 9 -9 9 -10.0625 5.5 C-10 2 -10 2 -9 0 C-5.85440657 -1.57279672 -3.33684358 -0.7415208 0 0 Z ",
  fill: "#F1F1F1",
  transform: "translate(394,209)"
});
var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C1.875 1.625 1.875 1.625 3 4 C2.875 7.125 2.875 7.125 2 10 C-1 12 -1 12 -4.0625 11.8125 C-7 11 -7 11 -9 8 C-8.8125 4.9375 -8.8125 4.9375 -8 2 C-4.77856724 -0.14762184 -3.7404533 -0.561068 0 0 Z ",
  fill: "#EEEEEE",
  transform: "translate(637,222)"
});
var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 2 2 2 2 5 C2.66 5 3.32 5 4 5 C3 8 3 8 0.3125 9.75 C-3.37430684 11.14124787 -5.24250465 10.98410592 -9 10 C-10 7 -10 7 -8.6875 3.375 C-6.27634755 -1.44730489 -4.9286206 -1.35537066 0 0 Z ",
  fill: "#F3F3F3",
  transform: "translate(610,187)"
});
var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3.32613726 0.29565665 5.41109347 0.50311011 8 2.6875 C9 5 9 5 8.1875 8.25 C7.795625 9.1575 7.40375 10.065 7 11 C6.21625 11.144375 5.4325 11.28875 4.625 11.4375 C2.03578982 11.87798925 2.03578982 11.87798925 0 13 C0 12.34 0 11.68 0 11 C-0.66 11 -1.32 11 -2 11 C-3.35384615 4.6 -3.35384615 4.6 -1.5625 1.5625 C-1.046875 1.046875 -0.53125 0.53125 0 0 Z ",
  fill: "#EDEDED",
  transform: "translate(397,195)"
});
var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3.5 0.1875 3.5 0.1875 7 1 C9 4 9 4 8.9375 6.5 C8 9 8 9 5.625 10.8125 C3 12 3 12 0 12 C-2.16268757 9.29664053 -3.05625689 7.8063488 -2.8125 4.3125 C-2 2 -2 2 0 0 Z ",
  fill: "#EEEEEE",
  transform: "translate(617,195)"
});
var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C1.98 0.99 3.96 1.98 6 3 C6.36190476 8.42857143 6.36190476 8.42857143 4.8125 10.875 C2.25411357 12.46296399 0.96648169 12.56504413 -2 12 C-4.8125 9.5 -4.8125 9.5 -7 7 C-6.34 7 -5.68 7 -5 7 C-4.9175 6.401875 -4.835 5.80375 -4.75 5.1875 C-3.79544128 2.4033704 -2.42867729 1.56688858 0 0 Z ",
  fill: "#EEEEEE",
  transform: "translate(591,180)"
});
var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3.1875 0.875 3.1875 0.875 6 2 C6.75 4.75 6.75 4.75 7 8 C5.375 10.4375 5.375 10.4375 3 12 C0.4375 12.0625 0.4375 12.0625 -2 11 C-3.9375 8.6875 -3.9375 8.6875 -5 6 C-4.03969728 2.63894049 -2.98299429 1.98866286 0 0 Z ",
  fill: "#EFEFEF",
  transform: "translate(426,180)"
});
var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.97373062 0.02361099 1.94746124 0.04722198 2.95069885 0.07154846 C6.05193031 0.1478094 9.15289048 0.23186594 12.25390625 0.31640625 C15.35137505 0.39569258 18.44887974 0.47338449 21.54640198 0.55055237 C23.46973196 0.59903133 25.39302437 0.64903275 27.31626892 0.70079041 C36.19452441 1.29295176 36.19452441 1.29295176 44.81640625 -0.12109375 C44.81640625 0.53890625 44.81640625 1.19890625 44.81640625 1.87890625 C50.09640625 1.87890625 55.37640625 1.87890625 60.81640625 1.87890625 C60.81640625 2.20890625 60.81640625 2.53890625 60.81640625 2.87890625 C36.79635783 3.02407623 12.82401532 2.6546097 -11.18359375 1.87890625 C-10.85359375 2.86890625 -10.52359375 3.85890625 -10.18359375 4.87890625 C-11.50359375 4.87890625 -12.82359375 4.87890625 -14.18359375 4.87890625 C-14.84359375 3.55890625 -15.50359375 2.23890625 -16.18359375 0.87890625 C-10.73364972 -0.29147219 -5.53343245 -0.1606161 0 0 Z ",
  fill: "#CCCCCD",
  transform: "translate(555.18359375,344.12109375)"
});
var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2.375 0.8125 2.375 0.8125 4.375 2.8125 C4.625 5.8125 4.625 5.8125 4.375 8.8125 C2.375 10.8125 2.375 10.8125 -0.25 10.9375 C-1.03375 10.89625 -1.8175 10.855 -2.625 10.8125 C-2.955 11.4725 -3.285 12.1325 -3.625 12.8125 C-3.625 11.8225 -3.625 10.8325 -3.625 9.8125 C-4.285 9.8125 -4.945 9.8125 -5.625 9.8125 C-5.955 7.5025 -6.285 5.1925 -6.625 2.8125 C-4.2650337 0.62734602 -3.28118881 -0.23437063 0 0 Z ",
  fill: "#ECECED",
  transform: "translate(386.625,223.1875)"
});
var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2.45352447 0.99674432 3.56825675 1.55185276 5 3.8125 C4.6875 7.5 4.6875 7.5 4 10.8125 C1.25 11.5625 1.25 11.5625 -2 11.8125 C-4.4375 10.25 -4.4375 10.25 -6 7.8125 C-5.9375 4.6875 -5.9375 4.6875 -5 1.8125 C-2 -0.1875 -2 -0.1875 0 0 Z ",
  fill: "#EBEBEB",
  transform: "translate(635,237.1875)"
});
var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3 0.5625 3 0.5625 4.9375 2.25 C6 4.5625 6 4.5625 6.0625 7.125 C5 9.5625 5 9.5625 2.0625 11.4375 C1.051875 11.80875 0.04125 12.18 -1 12.5625 C-4.16370678 10.98064661 -4.81624835 8.80224136 -6 5.5625 C-4.75032719 1.73017004 -4.00057764 0.75010831 0 0 Z ",
  fill: "#EDEDEE",
  transform: "translate(412,185.4375)"
});
var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 3 2 3 1.75 5.5625 C1 8 1 8 -1 10 C-2.98821313 10.39764263 -4.98944339 10.73775349 -7 11 C-10.18333333 4.63333333 -10.18333333 4.63333333 -9.3125 1.625 C-6.53030889 -1.81961756 -4.00684659 -1.00171165 0 0 Z ",
  fill: "#EEEEEE",
  transform: "translate(580,180)"
});
var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 3 2 3 1.8125 5.5 C0.92812648 8.2211493 0.40982297 9.45082809 -2 11 C-5.34192692 10.75546876 -6.60543557 10.39456443 -9 8 C-9.33333333 2.66666667 -9.33333333 2.66666667 -8 0 C-4.67212881 -1.1092904 -3.3006216 -1.01557588 0 0 Z ",
  fill: "#EFEFEF",
  transform: "translate(446,180)"
});
var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 2 2 2 2.25 4.4375 C2 7 2 7 0 10 C-3.5 10.375 -3.5 10.375 -7 10 C-9.14762184 6.77856724 -9.561068 5.7404533 -9 2 C-6.07557433 -1.24936186 -4.04996841 -1.38551551 0 0 Z ",
  fill: "#EBEBEB",
  transform: "translate(389,239)"
});
var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.7425 0.185625 1.485 0.37125 2.25 0.5625 C5.07739369 1.01231263 6.29414959 0.68015222 9 0 C10.58773306 -0.08428482 12.17859182 -0.11779948 13.76855469 -0.11352539 C15.17956451 -0.11341209 15.17956451 -0.11341209 16.61907959 -0.11329651 C17.62650208 -0.10813522 18.63392456 -0.10297394 19.671875 -0.09765625 C20.70942932 -0.0962413 21.74698364 -0.09482635 22.815979 -0.09336853 C26.12734876 -0.08777447 29.43865071 -0.07522303 32.75 -0.0625 C34.99609277 -0.05748423 37.24218661 -0.05292146 39.48828125 -0.04882812 C44.9922106 -0.03780699 50.49610046 -0.02107474 56 0 C56 1.32 56 2.64 56 4 C55.01 3.505 55.01 3.505 54 3 C51.69212126 2.90785369 49.3814915 2.88250603 47.07177734 2.88647461 C46.35947464 2.88632858 45.64717194 2.88618256 44.9132843 2.8860321 C42.55413794 2.88672989 40.19507011 2.89451603 37.8359375 2.90234375 C36.20211836 2.9042084 34.56829866 2.90563208 32.93447876 2.90663147 C28.6305182 2.91045291 24.32659129 2.92028002 20.02264404 2.93133545 C15.63228816 2.94155758 11.24192685 2.94613081 6.8515625 2.95117188 C-1.76564046 2.96190261 -10.38281604 2.97897457 -19 3 C-19 2.67 -19 2.34 -19 2 C-16.20865148 1.80574127 -13.41716313 1.61930483 -10.625 1.4375 C-9.8309375 1.38142578 -9.036875 1.32535156 -8.21875 1.26757812 C-2.2265625 0.88671875 -2.2265625 0.88671875 0 2 C0 1.34 0 0.68 0 0 Z ",
  fill: "#C9C9CA",
  transform: "translate(424,344)"
});
var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3.08089673 2.77280706 4.68775452 5.06326356 6 9 C3.83842041 10.92140408 2.45140831 11.93055257 -0.4375 12.375 C-3.52555054 11.92309016 -5.44564719 10.75155621 -8 9 C-7.67 8.01 -7.34 7.02 -7 6 C-6.34 6 -5.68 6 -5 6 C-4.34 4.68 -3.68 3.36 -3 2 C-2.01 2 -1.02 2 0 2 C0 1.34 0 0.68 0 0 Z ",
  fill: "#ECEDED",
  transform: "translate(472,185)"
});
var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2.4375 0.8125 2.4375 0.8125 4.4375 3.8125 C4.1133631 7.13490324 3.82973697 8.42026303 1.4375 10.8125 C-1.39636167 11.1758156 -2.96772151 11.1693671 -5.4375 9.6875 C-6.5625 7.8125 -6.5625 7.8125 -6.4375 4.75 C-5.31063606 0.96695678 -4.03725591 -0.29540897 0 0 Z ",
  fill: "#EEEEEE",
  transform: "translate(458.5625,182.1875)"
});
var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C20.79 0 41.58 0 63 0 C63 0.33 63 0.66 63 1 C62.06824951 1.0154612 62.06824951 1.0154612 61.11767578 1.03123474 C54.62832088 1.13976366 48.13909191 1.25432121 41.64990234 1.37231445 C39.23098394 1.4155152 36.81203796 1.4572002 34.39306641 1.49731445 C30.90779321 1.55537845 27.42265695 1.61896739 23.9375 1.68359375 C22.86322754 1.70030624 21.78895508 1.71701874 20.68212891 1.73423767 C15.03768745 1.84456074 9.59094411 2.23373836 4 3 C2.68 3 1.36 3 0 3 C0 2.01 0 1.02 0 0 Z ",
  fill: "#ECECED",
  transform: "translate(417,529)"
});
var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C1.125 2.8125 1.125 2.8125 2 6 C1.01 7.485 1.01 7.485 0 9 C-0.66 9 -1.32 9 -2 9 C-2.33 9.99 -2.66 10.98 -3 12 C-3.99 11.67 -4.98 11.34 -6 11 C-6 10.34 -6 9.68 -6 9 C-6.99 8.67 -7.98 8.34 -9 8 C-9 6.02 -9 4.04 -9 2 C-5.86501708 0.14223235 -3.62528568 -0.20140476 0 0 Z ",
  fill: "#E1E1E2",
  transform: "translate(393,252)"
});
var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2.75 1.5 2.75 1.5 3.875 3.3125 C3.75 5.5 3.75 5.5 2.25 8.3125 C-0.25 10.5 -0.25 10.5 -4 10.3125 C-5.0725 10.044375 -6.145 9.77625 -7.25 9.5 C-7.58 7.52 -7.91 5.54 -8.25 3.5 C-4.11666667 -0.63333333 -4.11666667 -0.63333333 0 0 Z ",
  fill: "#ECECEC",
  transform: "translate(535.25,190.5)"
});
var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2.5625 0.3125 2.5625 0.3125 4.4375 1.5 C5.5625 3.3125 5.5625 3.3125 5.3125 5.875 C4.5625 8.3125 4.5625 8.3125 3.5625 10.3125 C0.1875 10.5 0.1875 10.5 -3.4375 10.3125 C-5.4375 7.3125 -5.4375 7.3125 -5.1875 4.75 C-4.19253762 1.51637226 -3.41216263 0.43745675 0 0 Z ",
  fill: "#151515",
  transform: "translate(509.4375,231.6875)"
});
var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C1 1 1 1 1.1875 3.9375 C1 7 1 7 -1 9 C-3.9375 9.375 -3.9375 9.375 -7 9 C-9 7.3125 -9 7.3125 -10 5 C-9.375 2.3125 -9.375 2.3125 -8 0 C-4.69676014 -1.10107995 -3.29495231 -0.86709271 0 0 Z ",
  fill: "#EFEFEF",
  transform: "translate(565,183)"
});
var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3.0625 0.4375 3.0625 0.4375 5.0625 2.6875 C6.0625 5.4375 6.0625 5.4375 5.6875 7.6875 C3.20155419 10.36467241 0.58472195 10.17659467 -2.9375 10.4375 C-2.9375 9.7775 -2.9375 9.1175 -2.9375 8.4375 C-3.5975 8.4375 -4.2575 8.4375 -4.9375 8.4375 C-5.0625 5.5625 -5.0625 5.5625 -4.9375 2.4375 C-2.9375 0.4375 -2.9375 0.4375 0 0 Z ",
  fill: "#EFEFF0",
  transform: "translate(484.9375,190.5625)"
});
var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2.4375 0.75 2.4375 0.75 4.4375 2.75 C4.875 5.1875 4.875 5.1875 4.4375 7.75 C1.9375 9.5625 1.9375 9.5625 -0.5625 10.75 C-3.0625 9.625 -3.0625 9.625 -5.5625 7.75 C-6.0625 4.6875 -6.0625 4.6875 -5.5625 1.75 C-2.5625 -0.25 -2.5625 -0.25 0 0 Z ",
  fill: "#EFEFF0",
  transform: "translate(547.5625,186.25)"
});
var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.67028521 5.29714793 1.3773161 6.6226839 -1 9 C-3.625 9.125 -3.625 9.125 -6 9 C-7.57035335 6.50590939 -8.0274945 5.29556584 -7.75 2.3125 C-7.5025 1.549375 -7.255 0.78625 -7 0 C-4.29393021 -1.35303489 -2.8671629 -0.7884698 0 0 Z ",
  fill: "#E6E6E6",
  transform: "translate(634,253)"
});
var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.125 2.875 0.125 2.875 0 6 C-2 8 -2 8 -4.5 8.25 C-7 8 -7 8 -9 6 C-9.125 2.875 -9.125 2.875 -9 0 C-5.93109813 -1.53445094 -3.29905734 -0.54984289 0 0 Z ",
  fill: "#100E0F",
  transform: "translate(514,208)"
});
var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C5.75 -0.125 5.75 -0.125 8 1 C8.1875 3.875 8.1875 3.875 8 7 C5 9 5 9 2.375 8.6875 C0 8 0 8 -1 7 C-0.71269945 4.66055264 -0.38063221 2.3260857 0 0 Z ",
  fill: "#070707",
  transform: "translate(506,220)"
});
var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2.375 0.75 2.375 0.75 3.375 1.75 C3.5 4.75 3.5 4.75 3.375 7.75 C2.375 8.75 2.375 8.75 -1.125 8.875 C-4.625 8.75 -4.625 8.75 -5.625 7.75 C-5.9232732 4.91640458 -5.98102594 3.31214622 -4.4375 0.875 C-2.625 -0.25 -2.625 -0.25 0 0 Z ",
  fill: "#0D0C0C",
  transform: "translate(510.625,193.25)"
});
var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0 3 0 3 -1.65234375 4.99291992 C-2.78349609 6.10050659 -2.78349609 6.10050659 -3.9375 7.23046875 C-4.74960937 8.03291016 -5.56171875 8.83535156 -6.3984375 9.66210938 C-7.25695312 10.49548828 -8.11546875 11.32886719 -9 12.1875 C-10.28777344 13.4549707 -10.28777344 13.4549707 -11.6015625 14.74804688 C-13.7278365 16.83888298 -15.86078464 18.92241983 -18 21 C-18.66 20.67 -19.32 20.34 -20 20 C-13.6688763 12.89967436 -7.30341903 6.13126536 0 0 Z ",
  fill: "#E0E0E0",
  transform: "translate(367,381)"
});
var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2.6058889 -0.13494246 5.20482111 -0.23402299 7.8125 -0.3125 C8.55048828 -0.35439453 9.28847656 -0.39628906 10.04882812 -0.43945312 C12.20703125 -0.48828125 12.20703125 -0.48828125 16 0 C18.33044889 2.73099479 18.94955318 4.24329776 19.1875 7.8125 C19.0946875 8.8953125 19.0946875 8.8953125 19 10 C18.34 8.68 17.68 7.36 17 6 C16.01 6.495 16.01 6.495 15 7 C14.34 6.34 13.68 5.68 13 5 C13.33 3.68 13.66 2.36 14 1 C11.03 1 8.06 1 5 1 C5 1.66 5 2.32 5 3 C4.01 3 3.02 3 2 3 C1.67 3.99 1.34 4.98 1 6 C0.67 4.02 0.34 2.04 0 0 Z ",
  fill: "#CECECF",
  transform: "translate(291,570)"
});
var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C4.06248489 -0.02909769 8.12494286 -0.04683174 12.1875 -0.0625 C13.91323242 -0.07506836 13.91323242 -0.07506836 15.67382812 -0.08789062 C16.78564453 -0.09111328 17.89746094 -0.09433594 19.04296875 -0.09765625 C20.06414795 -0.10289307 21.08532715 -0.10812988 22.13745117 -0.11352539 C24.86901616 -0.00519467 27.34169374 0.38293132 30 1 C30 1.33 30 1.66 30 2 C19.96724089 2.79692838 10.06354218 3.12847075 0 3 C0 2.01 0 1.02 0 0 Z ",
  fill: "#D4D4D4",
  transform: "translate(465,557)"
});
var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C12.54 0 25.08 0 38 0 C36.68 0.99 35.36 1.98 34 3 C32.15283203 2.68920898 32.15283203 2.68920898 30 2 C27.85234504 1.94130654 25.70287728 1.93878223 23.5546875 1.97265625 C21.69263672 1.99102539 21.69263672 1.99102539 19.79296875 2.00976562 C17.17312317 2.04502775 14.55332637 2.0841131 11.93359375 2.12695312 C10.07541016 2.14338867 10.07541016 2.14338867 8.1796875 2.16015625 C7.04257324 2.17699463 5.90545898 2.19383301 4.73388672 2.21118164 C2 2 2 2 0 0 Z ",
  fill: "#BFBFC0",
  transform: "translate(444,530)"
});
var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C13.2 0 26.4 0 40 0 C40 0.66 40 1.32 40 2 C36.98968256 2.93423645 36.13349732 3.04449911 33 2 C30.48945095 1.8470353 28.00111475 1.74304822 25.48828125 1.68359375 C24.76005661 1.66281265 24.03183197 1.64203156 23.28153992 1.62062073 C20.95862125 1.55531254 18.63559094 1.49632763 16.3125 1.4375 C14.73631665 1.39429695 13.16014452 1.35068208 11.58398438 1.30664062 C7.72277025 1.1996504 3.86144397 1.09833039 0 1 C0 0.67 0 0.34 0 0 Z ",
  fill: "#EBECEC",
  transform: "translate(560,668)"
});
var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C1.65 0.33 3.3 0.66 5 1 C4.67 1.66 4.34 2.32 4 3 C3.67 2.67 3.34 2.34 3 2 C2.67 6.29 2.34 10.58 2 15 C2.99 15.33 3.98 15.66 5 16 C3.35 16.66 1.7 17.32 0 18 C-0.87460154 14.50159382 -0.85970794 12.43883174 0 9 C0.06548492 7.41788427 0.08578381 5.83329919 0.0625 4.25 C0.05347656 3.45078125 0.04445313 2.6515625 0.03515625 1.828125 C0.02355469 1.22484375 0.01195312 0.6215625 0 0 Z ",
  fill: "#D7D7D7",
  transform: "translate(493,143)"
});
var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C8.74507107 -0.10621544 17.30019136 -0.01286753 26 1 C26 1.33 26 1.66 26 2 C24.12054688 1.98259766 24.12054688 1.98259766 22.203125 1.96484375 C20.55208483 1.95546284 18.90104304 1.94636296 17.25 1.9375 C16.425 1.92912109 15.6 1.92074219 14.75 1.91210938 C13.95078125 1.90888672 13.1515625 1.90566406 12.328125 1.90234375 C11.5949707 1.89710693 10.86181641 1.89187012 10.10644531 1.88647461 C7.99439575 1.93325584 7.99439575 1.93325584 5.97949219 2.50610352 C4 3 4 3 0 3 C0 2.01 0 1.02 0 0 Z ",
  fill: "#CFCFCF",
  transform: "translate(417,529)"
});
var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2.31 0.66 4.62 1.32 7 2 C7 2.33 7 2.66 7 3 C-1.58 3 -10.16 3 -19 3 C-19 2.67 -19 2.34 -19 2 C-16.20865148 1.80574127 -13.41716313 1.61930483 -10.625 1.4375 C-9.8309375 1.38142578 -9.036875 1.32535156 -8.21875 1.26757812 C-2.2265625 0.88671875 -2.2265625 0.88671875 0 2 C0 1.34 0 0.68 0 0 Z ",
  fill: "#D6D7D7",
  transform: "translate(424,344)"
});
var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C1.96066406 0.00966797 1.96066406 0.00966797 3.9609375 0.01953125 C6.99117548 0.15844408 9.68684619 0.47848605 12.625 1.1875 C6.29288664 5.40890891 -3.10664896 3.05351629 -10.375 2.1875 C-6.60154443 -0.32813705 -4.49765107 -0.04859937 0 0 Z ",
  fill: "#D4D4D4",
  transform: "translate(450.375,556.8125)"
});
var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.33 0 0.66 0 1 0 C2.32594359 5.96674616 2.0884587 11.92583615 2 18 C1.01 18.33 0.02 18.66 -1 19 C-0.7215625 18.195625 -0.7215625 18.195625 -0.4375 17.375 C0.11222311 14.39078884 -0.4833859 11.97053109 -1 9 C-0.67 8.34 -0.34 7.68 0 7 C0.04022391 4.6670134 0.04320247 2.33293334 0 0 Z ",
  fill: "#DADADA",
  transform: "translate(537,392)"
});
var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C5.94 0 11.88 0 18 0 C17.01 1.32 16.02 2.64 15 4 C13.68 4 12.36 4 11 4 C11 3.34 11 2.68 11 2 C7.37 1.67 3.74 1.34 0 1 C0 0.67 0 0.34 0 0 Z ",
  fill: "#DDDDDE",
  transform: "translate(472,668)"
});
var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.54625 2.886875 0.0925 3.77375 -0.375 4.6875 C-2.10260562 8.20915762 -2.61211192 11.12111921 -3 15 C-3.33 15 -3.66 15 -4 15 C-5.09444355 9.22929766 -5.37313783 6.12217225 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
  fill: "#5A595A",
  transform: "translate(606,288)"
});
var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C-1.38188453 3.21043882 -2.92421903 5.04936365 -5.625 7.25 C-6.57246094 8.03117187 -6.57246094 8.03117187 -7.5390625 8.828125 C-8.02117187 9.21484375 -8.50328125 9.6015625 -9 10 C-7.6834994 5.81113445 -4.97532335 0 0 0 Z ",
  fill: "#E2E2E3",
  transform: "translate(464,388)"
});
var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C5.28 0 10.56 0 16 0 C16 0.66 16 1.32 16 2 C12.98968256 2.93423645 12.13349732 3.04449911 9 2 C7.44146733 1.78196693 5.87817349 1.59633644 4.3125 1.4375 C3.10013672 1.31181641 3.10013672 1.31181641 1.86328125 1.18359375 C1.24839844 1.12300781 0.63351562 1.06242188 0 1 C0 0.67 0 0.34 0 0 Z ",
  fill: "#DDDEDE",
  transform: "translate(584,668)"
});
var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C-1.2065625 0.5878125 -1.2065625 0.5878125 -2.4375 1.1875 C-5.22545321 2.75009582 -5.22545321 2.75009582 -5.6875 5.5625 C-5.790625 6.366875 -5.89375 7.17125 -6 8 C-6.66 8.66 -7.32 9.32 -8 10 C-9 7 -9 7 -7.6875 3.375 C-5.44439095 -1.1112181 -4.52957551 -1.35887265 0 0 Z ",
  fill: "#D2D2D3",
  transform: "translate(609,187)"
});
var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0 2.97 0 5.94 0 9 C-1.32 9.33 -2.64 9.66 -4 10 C-3.67 8.68 -3.34 7.36 -3 6 C-2.34 6 -1.68 6 -1 6 C-1.26676204 4.01508358 -1.26676204 4.01508358 -2 2 C-2.99 1.67 -3.98 1.34 -5 1 C-2 0 -2 0 0 0 Z ",
  fill: "#DDDCDC",
  transform: "translate(507,154)"
});
var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C1.17949219 0.10183594 2.35898437 0.20367188 3.57421875 0.30859375 C4.47785156 0.39238281 5.38148438 0.47617187 6.3125 0.5625 C6.3125 0.8925 6.3125 1.2225 6.3125 1.5625 C4.20972877 1.78447585 2.10517698 1.98963637 0 2.1875 C-1.17175781 2.30351563 -2.34351563 2.41953125 -3.55078125 2.5390625 C-6.6875 2.5625 -6.6875 2.5625 -9.6875 0.5625 C-6.14075997 -0.61974668 -3.71227005 -0.33079634 0 0 Z ",
  fill: "#D4D4D4",
  transform: "translate(472.6875,621.4375)"
});
var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3.875 4.75 3.875 4.75 5 7 C3.68 6.34 2.36 5.68 1 5 C0.34 5.99 -0.32 6.98 -1 8 C-1.33 5.69 -1.66 3.38 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
  fill: "#C3C4C4",
  transform: "translate(700,372)"
});
var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.99773437 0.02320313 1.99546875 0.04640625 3.0234375 0.0703125 C4.52777344 0.09738281 4.52777344 0.09738281 6.0625 0.125 C6.83335937 0.14820313 7.60421875 0.17140625 8.3984375 0.1953125 C7.1025276 1.24335606 5.76512346 2.24140094 4.3984375 3.1953125 C2.4609375 2.8828125 2.4609375 2.8828125 0.3984375 2.1953125 C-1.26779889 2.15744349 -2.93553847 2.14903405 -4.6015625 2.1953125 C-2.6015625 0.1953125 -2.6015625 0.1953125 0 0 Z ",
  fill: "#C7C7C8",
  transform: "translate(473.6015625,529.8046875)"
});
var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C-0.763125 0.5775 -1.52625 1.155 -2.3125 1.75 C-4.66200917 3.71703093 -6.29323505 5.48476744 -8 8 C-8.36075949 3.55063291 -8.36075949 3.55063291 -6.8125 1.1875 C-4.44017475 -0.36678206 -2.77958655 -0.22537188 0 0 Z ",
  fill: "#D5D5D7",
  transform: "translate(392,208)"
});
var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.33 0 0.66 0 1 0 C1.24954005 1.43410368 1.47392642 2.87260072 1.6875 4.3125 C1.81511719 5.11300781 1.94273437 5.91351563 2.07421875 6.73828125 C2 9 2 9 0.51953125 10.79296875 C0.01808594 11.19128906 -0.48335938 11.58960938 -1 12 C-1.66 11.67 -2.32 11.34 -3 11 C-2.690625 10.484375 -2.38125 9.96875 -2.0625 9.4375 C-0.70940713 6.33334577 -0.38640576 3.34884993 0 0 Z ",
  fill: "#C6C6C7",
  transform: "translate(416,459)"
});
var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C1.2077558 3.62326739 0.54311128 4.64146369 -1 8 C-1.66 8 -2.32 8 -3 8 C-3.75 6.25 -3.75 6.25 -4 4 C-2.0625 1.75 -2.0625 1.75 0 0 Z ",
  fill: "#6C6B6B",
  transform: "translate(610,280)"
});
var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3 1 3 1 4.1875 3.0625 C4.455625 3.701875 4.72375 4.34125 5 5 C4.34 5 3.68 5 3 5 C2.67 5.99 2.34 6.98 2 8 C1.34 5.36 0.68 2.72 0 0 Z ",
  fill: "#252324",
  transform: "translate(413,286)"
});
var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3.63 0 7.26 0 11 0 C11 0.33 11 0.66 11 1 C7.37 1 3.74 1 0 1 C0 0.67 0 0.34 0 0 Z ",
  fill: "#D4D4D5",
  transform: "translate(517,531)"
});
var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C2.68 2 1.36 2 0 2 C0 1.34 0 0.68 0 0 Z ",
  fill: "#D7D6D7",
  transform: "translate(632,648)"
});
var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.64 1 5.28 1 8 C0.67 8 0.34 8 0 8 C0 5.36 0 2.72 0 0 Z ",
  fill: "#959394",
  transform: "translate(416,302)"
});
var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.33 7 0.66 7 1 C4.69 1 2.38 1 0 1 C0 0.67 0 0.34 0 0 Z ",
  fill: "#CECECE",
  transform: "translate(472,671)"
});
var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C1.98 0.99 1.98 0.99 4 2 C3.01 2.495 3.01 2.495 2 3 C1.34 2.67 0.68 2.34 0 2 C0 1.34 0 0.68 0 0 Z ",
  fill: "#CBCAC9",
  transform: "translate(626,244)"
});
var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
  fill: "#D2D3D3",
  transform: "translate(490,548)"
});
var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C1.98 0.99 1.98 0.99 4 2 C2.68 2 1.36 2 0 2 C0 1.34 0 0.68 0 0 Z ",
  fill: "#D2D2D3",
  transform: "translate(520,520)"
});
var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
  fill: "#D7D6D5",
  transform: "translate(503,399)"
});
var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
  fill: "#CECFCE",
  transform: "translate(508,671)"
});
var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2.66 0.68 3.32 0 4 C0 2.68 0 1.36 0 0 Z ",
  fill: "#D7D7D8",
  transform: "translate(416,664)"
});
var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.99 0 1.98 0 3 0 C3 0.66 3 1.32 3 2 C2.01 1.67 1.02 1.34 0 1 C0 0.67 0 0.34 0 0 Z ",
  fill: "#D4D5D5",
  transform: "translate(560,582)"
});
var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C1.98 0.99 1.98 0.99 4 2 C2.68 1.67 1.36 1.34 0 1 C0 0.67 0 0.34 0 0 Z ",
  fill: "#D7D8D7",
  transform: "translate(724,534)"
});
var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.99 0 1.98 0 3 0 C3 0.66 3 1.32 3 2 C2.01 1.67 1.02 1.34 0 1 C0 0.67 0 0.34 0 0 Z ",
  fill: "#D8D9D9",
  transform: "translate(293,534)"
});
var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C1.01 1.67 0.02 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
  fill: "#D1D1D2",
  transform: "translate(528,520)"
});
var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.66 1.32 1.32 2.64 2 4 C1.34 4 0.68 4 0 4 C0 2.68 0 1.36 0 0 Z ",
  fill: "#D1D0D1",
  transform: "translate(400,480)"
});
var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.99 0 1.98 0 3 0 C2.67 0.66 2.34 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
  fill: "#D0CDCE",
  transform: "translate(400,352)"
});
var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
  fill: "#D2D2D1",
  transform: "translate(527,146)"
});
var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
  fill: "#D6D7D7",
  transform: "translate(544,776)"
});
var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C4 1 4 1 4 1 Z ",
  fill: "#D5D5D5",
  transform: "translate(580,671)"
});
var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C4 1 4 1 4 1 Z ",
  fill: "#CED0CF",
  transform: "translate(543,671)"
});
var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C4 1 4 1 4 1 Z ",
  fill: "#CFCFCF",
  transform: "translate(458,671)"
});
var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C4 1 4 1 4 1 Z ",
  fill: "#D4D4D2",
  transform: "translate(450,671)"
});
var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C4 1 4 1 4 1 Z ",
  fill: "#D0D2D2",
  transform: "translate(508,647)"
});
var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C4 1 4 1 4 1 Z ",
  fill: "#D0D2D2",
  transform: "translate(498,583)"
});
var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1.33 1.02 1.66 0 2 C0 1.34 0 0.68 0 0 Z ",
  fill: "#D7D7D6",
  transform: "translate(600,567)"
});
var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C4 1 4 1 4 1 Z ",
  fill: "#D5D6D6",
  transform: "translate(513,558)"
});
var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C4 1 4 1 4 1 Z ",
  fill: "#D2D2D4",
  transform: "translate(498,548)"
});
var _ref105 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
  fill: "#D8D8D9",
  transform: "translate(288,534)"
});
var _ref106 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C4 1 4 1 4 1 Z ",
  fill: "#D3D4D3",
  transform: "translate(584,517)"
});
var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
  fill: "#D2D3D4",
  transform: "translate(544,499)"
});
var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.99 1.34 1.98 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
  fill: "#D7D8D8",
  transform: "translate(730,483)"
});
var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C1 4 1 4 1 4 Z ",
  fill: "#D5D5D4",
  transform: "translate(503,408)"
});
var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C4 1 4 1 4 1 Z ",
  fill: "#D0D1D1",
  transform: "translate(577,340)"
});
var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C1 4 1 4 1 4 Z ",
  fill: "#D4D4D4",
  transform: "translate(527,176)"
});
var _ref112 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
  fill: "#D4D3D5",
  transform: "translate(542,763)"
});
var _ref113 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3 1 3 1 3 1 Z ",
  fill: "#D4D4D5",
  transform: "translate(501,763)"
});
var _ref114 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3 1 3 1 3 1 Z ",
  fill: "#D1D1D1",
  transform: "translate(628,759)"
});
var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
  fill: "#D7D7D9",
  transform: "translate(640,688)"
});
var _ref116 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3 1 3 1 3 1 Z ",
  fill: "#D0D2D3",
  transform: "translate(466,647)"
});
var _ref117 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D3D4",
  transform: "translate(0,0)"
});
var _ref118 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
  fill: "#D8D9D8",
  transform: "translate(314,598)"
});
var _ref119 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3 1 3 1 3 1 Z ",
  fill: "#CED0D1",
  transform: "translate(464,583)"
});
var _ref120 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3 1 3 1 3 1 Z ",
  fill: "#D0D0D1",
  transform: "translate(506,573)"
});
var _ref121 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
  fill: "#D6D6D6",
  transform: "translate(718,572)"
});
var _ref122 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3 1 3 1 3 1 Z ",
  fill: "#D6D6D8",
  transform: "translate(298,572)"
});
var _ref123 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
  fill: "#DAD9D9",
  transform: "translate(551,552)"
});
var _ref124 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3 1 3 1 3 1 Z ",
  fill: "#D3D2D4",
  transform: "translate(457,548)"
});
var _ref125 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D5D6",
  transform: "translate(0,0)"
});
var _ref126 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
  fill: "#D7D8D8",
  transform: "translate(577,541)"
});
var _ref127 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3 1 3 1 3 1 Z ",
  fill: "#D3D3D4",
  transform: "translate(541,531)"
});
var _ref128 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3 1 3 1 3 1 Z ",
  fill: "#D4D3D5",
  transform: "translate(533,531)"
});
var _ref129 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3 1 3 1 3 1 Z ",
  fill: "#D3D1D1",
  transform: "translate(547,521)"
});
var _ref130 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
  fill: "#D4D3D2",
  transform: "translate(545,520)"
});
var _ref131 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3 1 3 1 3 1 Z ",
  fill: "#D3D2D3",
  transform: "translate(504,518)"
});
var _ref132 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFD0CF",
  transform: "translate(0,0)"
});
var _ref133 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D4D5",
  transform: "translate(0,0)"
});
var _ref134 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D9DA",
  transform: "translate(0,0)"
});
var _ref135 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D4D3",
  transform: "translate(0,0)"
});
var _ref136 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3 1 3 1 3 1 Z ",
  fill: "#D3D4D4",
  transform: "translate(548,450)"
});
var _ref137 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D6D7",
  transform: "translate(0,0)"
});
var _ref138 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D5",
  transform: "translate(0,0)"
});
var _ref139 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D6D4",
  transform: "translate(0,0)"
});
var _ref140 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
  fill: "#D2D0D2",
  transform: "translate(410,424)"
});
var _ref141 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
  fill: "#D0CFCF",
  transform: "translate(272,417)"
});
var _ref142 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D5",
  transform: "translate(0,0)"
});
var _ref143 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D5",
  transform: "translate(0,0)"
});
var _ref144 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3 1 3 1 3 1 Z ",
  fill: "#D2D2D1",
  transform: "translate(570,383)"
});
var _ref145 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
  fill: "#D3D4D5",
  transform: "translate(590,382)"
});
var _ref146 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
  fill: "#D7D7D9",
  transform: "translate(418,382)"
});
var _ref147 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCFCF",
  transform: "translate(0,0)"
});
var _ref148 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
  fill: "#D7D8D8",
  transform: "translate(556,358)"
});
var _ref149 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3 1 3 1 3 1 Z ",
  fill: "#D0D1D1",
  transform: "translate(594,342)"
});
var _ref150 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
  fill: "#A2A0A0",
  transform: "translate(416,311)"
});
var _ref151 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
  fill: "#CAC9CA",
  transform: "translate(396,216)"
});
var _ref152 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3 1 3 1 3 1 Z ",
  fill: "#D2D2D3",
  transform: "translate(488,204)"
});
var _ref153 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CCCBCC",
  transform: "translate(0,0)"
});
var _ref154 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
  fill: "#CFCDCC",
  transform: "translate(614,194)"
});
var _ref155 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3 1 3 1 3 1 Z ",
  fill: "#CFCECF",
  transform: "translate(576,192)"
});
var _ref156 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C3 1 3 1 3 1 Z ",
  fill: "#D0D0CF",
  transform: "translate(441,192)"
});
var _ref157 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D0D2D2",
  transform: "translate(521,815)"
});
var _ref158 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D2D2D1",
  transform: "translate(481,805)"
});
var _ref159 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D0D2D1",
  transform: "translate(466,797)"
});
var _ref160 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D7D8",
  transform: "translate(0,0)"
});
var _ref161 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D6D7",
  transform: "translate(0,0)"
});
var _ref162 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D7D6",
  transform: "translate(0,0)"
});
var _ref163 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D5D5D6",
  transform: "translate(560,769)"
});
var _ref164 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D3D4D5",
  transform: "translate(558,763)"
});
var _ref165 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D4D4D4",
  transform: "translate(534,763)"
});
var _ref166 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D4D4D5",
  transform: "translate(477,763)"
});
var _ref167 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D7",
  transform: "translate(0,0)"
});
var _ref168 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DDDFDD",
  transform: "translate(0,0)"
});
var _ref169 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D8D9",
  transform: "translate(0,0)"
});
var _ref170 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#DAD9D9",
  transform: "translate(596,691)"
});
var _ref171 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D8D9D8",
  transform: "translate(423,689)"
});
var _ref172 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9DAD8",
  transform: "translate(0,0)"
});
var _ref173 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#CFCFD0",
  transform: "translate(559,671)"
});
var _ref174 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#CECFCF",
  transform: "translate(469,671)"
});
var _ref175 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D2D2D1",
  transform: "translate(455,671)"
});
var _ref176 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9DADA",
  transform: "translate(0,0)"
});
var _ref177 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DBDADA",
  transform: "translate(0,0)"
});
var _ref178 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D6D6",
  transform: "translate(0,0)"
});
var _ref179 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D4D2D2",
  transform: "translate(541,647)"
});
var _ref180 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D2D4D4",
  transform: "translate(538,647)"
});
var _ref181 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D4",
  transform: "translate(0,0)"
});
var _ref182 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D4D3D5",
  transform: "translate(526,622)"
});
var _ref183 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D1D2",
  transform: "translate(0,0)"
});
var _ref184 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DCD9DB",
  transform: "translate(0,0)"
});
var _ref185 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D4D5D5",
  transform: "translate(587,592)"
});
var _ref186 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CED0CF",
  transform: "translate(0,0)"
});
var _ref187 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D4D4",
  transform: "translate(0,0)"
});
var _ref188 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D2D2D2",
  transform: "translate(614,579)"
});
var _ref189 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D0D0",
  transform: "translate(0,0)"
});
var _ref190 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D4D5",
  transform: "translate(0,0)"
});
var _ref191 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DCDBDA",
  transform: "translate(0,0)"
});
var _ref192 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D6D8",
  transform: "translate(0,0)"
});
var _ref193 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D7D7D8",
  transform: "translate(294,574)"
});
var _ref194 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CECECE",
  transform: "translate(0,0)"
});
var _ref195 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D0CFD0",
  transform: "translate(434,573)"
});
var _ref196 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D6D5",
  transform: "translate(0,0)"
});
var _ref197 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D5D5D5",
  transform: "translate(608,552)"
});
var _ref198 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CECECE",
  transform: "translate(0,0)"
});
var _ref199 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D2D1D2",
  transform: "translate(479,548)"
});
var _ref200 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D3D2D4",
  transform: "translate(476,548)"
});
var _ref201 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DDDDDD",
  transform: "translate(0,0)"
});
var _ref202 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D8D8D8",
  transform: "translate(731,534)"
});
var _ref203 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D8D9D9",
  transform: "translate(728,534)"
});
var _ref204 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D3D3D4",
  transform: "translate(549,531)"
});
var _ref205 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D2D1D4",
  transform: "translate(502,531)"
});
var _ref206 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D4",
  transform: "translate(0,0)"
});
var _ref207 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D1D2D1",
  transform: "translate(536,521)"
});
var _ref208 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D2D2D2",
  transform: "translate(531,521)"
});
var _ref209 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D0D3",
  transform: "translate(0,0)"
});
var _ref210 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D0CFCF",
  transform: "translate(505,521)"
});
var _ref211 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D5D6",
  transform: "translate(0,0)"
});
var _ref212 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D1D2D3",
  transform: "translate(603,517)"
});
var _ref213 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DCDADB",
  transform: "translate(0,0)"
});
var _ref214 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DADCD9",
  transform: "translate(0,0)"
});
var _ref215 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D5D5",
  transform: "translate(0,0)"
});
var _ref216 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D3D4D5",
  transform: "translate(427,495)"
});
var _ref217 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D8D7",
  transform: "translate(0,0)"
});
var _ref218 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D6D5",
  transform: "translate(0,0)"
});
var _ref219 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D7D7",
  transform: "translate(0,0)"
});
var _ref220 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D1D2",
  transform: "translate(0,0)"
});
var _ref221 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D4",
  transform: "translate(0,0)"
});
var _ref222 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D2D0D1",
  transform: "translate(420,481)"
});
var _ref223 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DADBD9",
  transform: "translate(0,0)"
});
var _ref224 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D7D8",
  transform: "translate(0,0)"
});
var _ref225 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D4D5",
  transform: "translate(0,0)"
});
var _ref226 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D7D7",
  transform: "translate(0,0)"
});
var _ref227 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D8DA",
  transform: "translate(0,0)"
});
var _ref228 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DADCD9",
  transform: "translate(0,0)"
});
var _ref229 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D4D5",
  transform: "translate(0,0)"
});
var _ref230 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D3D3D3",
  transform: "translate(622,456)"
});
var _ref231 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D8D9",
  transform: "translate(0,0)"
});
var _ref232 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D3D3",
  transform: "translate(0,0)"
});
var _ref233 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D5",
  transform: "translate(0,0)"
});
var _ref234 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D7D7",
  transform: "translate(0,0)"
});
var _ref235 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D2D2",
  transform: "translate(0,0)"
});
var _ref236 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D7D8",
  transform: "translate(0,0)"
});
var _ref237 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D4D5",
  transform: "translate(0,0)"
});
var _ref238 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D4D4",
  transform: "translate(0,0)"
});
var _ref239 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D3D3",
  transform: "translate(0,0)"
});
var _ref240 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D2D3D4",
  transform: "translate(274,429)"
});
var _ref241 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D7D8",
  transform: "translate(0,0)"
});
var _ref242 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D0D0D0",
  transform: "translate(273,419)"
});
var _ref243 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D4",
  transform: "translate(0,0)"
});
var _ref244 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D1D2",
  transform: "translate(0,0)"
});
var _ref245 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D6D7",
  transform: "translate(0,0)"
});
var _ref246 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D7D8",
  transform: "translate(0,0)"
});
var _ref247 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D6D7",
  transform: "translate(0,0)"
});
var _ref248 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D4",
  transform: "translate(0,0)"
});
var _ref249 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D7D7D9",
  transform: "translate(416,381)"
});
var _ref250 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D6D6D7",
  transform: "translate(561,380)"
});
var _ref251 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D0D1D1",
  transform: "translate(381,368)"
});
var _ref252 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#CFD0CE",
  transform: "translate(605,344)"
});
var _ref253 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D0D2D2",
  transform: "translate(586,341)"
});
var _ref254 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D2D2D3",
  transform: "translate(454,339)"
});
var _ref255 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#797879",
  transform: "translate(413,295)"
});
var _ref256 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#BDBDBE",
  transform: "translate(0,0)"
});
var _ref257 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#CECFCD",
  transform: "translate(417,248)"
});
var _ref258 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#C8C6C6",
  transform: "translate(0,0)"
});
var _ref259 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D1D2",
  transform: "translate(0,0)"
});
var _ref260 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D4D7D6",
  transform: "translate(540,227)"
});
var _ref261 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D2D1D2",
  transform: "translate(478,227)"
});
var _ref262 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D2D1D1",
  transform: "translate(467,226)"
});
var _ref263 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#CDCCCD",
  transform: "translate(390,224)"
});
var _ref264 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#C7C8C8",
  transform: "translate(0,0)"
});
var _ref265 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCECF",
  transform: "translate(0,0)"
});
var _ref266 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#CFCFCF",
  transform: "translate(572,206)"
});
var _ref267 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D0D1D2",
  transform: "translate(409,200)"
});
var _ref268 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0CFCF",
  transform: "translate(0,0)"
});
var _ref269 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#CECECE",
  transform: "translate(422,195)"
});
var _ref270 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#D1D2D2",
  transform: "translate(567,193)"
});
var _ref271 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#CFD0CF",
  transform: "translate(447,193)"
});
var _ref272 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C2 1 2 1 2 1 Z ",
  fill: "#CECDCE",
  transform: "translate(568,189)"
});
var _ref273 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCCD0",
  transform: "translate(0,0)"
});
var _ref274 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D3D4",
  transform: "translate(0,0)"
});
var _ref275 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#9A9999",
  transform: "translate(0,0)"
});
var _ref276 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CDCECD",
  transform: "translate(0,0)"
});
var _ref277 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D0D0",
  transform: "translate(0,0)"
});
var _ref278 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D1D1",
  transform: "translate(0,0)"
});
var _ref279 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCFCF",
  transform: "translate(0,0)"
});
var _ref280 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CECFCE",
  transform: "translate(0,0)"
});
var _ref281 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCECD",
  transform: "translate(0,0)"
});
var _ref282 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D2D2",
  transform: "translate(0,0)"
});
var _ref283 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCFCE",
  transform: "translate(0,0)"
});
var _ref284 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D3D2",
  transform: "translate(0,0)"
});
var _ref285 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D2D4",
  transform: "translate(0,0)"
});
var _ref286 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D4D1",
  transform: "translate(0,0)"
});
var _ref287 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D4D7",
  transform: "translate(0,0)"
});
var _ref288 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D4D6",
  transform: "translate(0,0)"
});
var _ref289 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D1",
  transform: "translate(0,0)"
});
var _ref290 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D3D2",
  transform: "translate(0,0)"
});
var _ref291 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D7D7",
  transform: "translate(0,0)"
});
var _ref292 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D8D9",
  transform: "translate(0,0)"
});
var _ref293 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D7D6",
  transform: "translate(0,0)"
});
var _ref294 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D6D5",
  transform: "translate(0,0)"
});
var _ref295 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D2D0",
  transform: "translate(0,0)"
});
var _ref296 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D5",
  transform: "translate(0,0)"
});
var _ref297 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D5D6",
  transform: "translate(0,0)"
});
var _ref298 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D8D8",
  transform: "translate(0,0)"
});
var _ref299 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D4D4",
  transform: "translate(0,0)"
});
var _ref300 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D6D4",
  transform: "translate(0,0)"
});
var _ref301 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D4D5",
  transform: "translate(0,0)"
});
var _ref302 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D6D9",
  transform: "translate(0,0)"
});
var _ref303 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D9D9",
  transform: "translate(0,0)"
});
var _ref304 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D2",
  transform: "translate(0,0)"
});
var _ref305 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D2D2",
  transform: "translate(0,0)"
});
var _ref306 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D8D7",
  transform: "translate(0,0)"
});
var _ref307 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D6D6",
  transform: "translate(0,0)"
});
var _ref308 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D5",
  transform: "translate(0,0)"
});
var _ref309 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D4",
  transform: "translate(0,0)"
});
var _ref310 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D9D9",
  transform: "translate(0,0)"
});
var _ref311 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D3D3",
  transform: "translate(0,0)"
});
var _ref312 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D4D6",
  transform: "translate(0,0)"
});
var _ref313 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D7DB",
  transform: "translate(0,0)"
});
var _ref314 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D7D6",
  transform: "translate(0,0)"
});
var _ref315 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D4D6",
  transform: "translate(0,0)"
});
var _ref316 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D6",
  transform: "translate(0,0)"
});
var _ref317 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D6D5",
  transform: "translate(0,0)"
});
var _ref318 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D4D5",
  transform: "translate(0,0)"
});
var _ref319 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D4",
  transform: "translate(0,0)"
});
var _ref320 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D7D6",
  transform: "translate(0,0)"
});
var _ref321 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D4D5",
  transform: "translate(0,0)"
});
var _ref322 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D4D3",
  transform: "translate(0,0)"
});
var _ref323 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D2D3",
  transform: "translate(0,0)"
});
var _ref324 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D3",
  transform: "translate(0,0)"
});
var _ref325 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D4D3",
  transform: "translate(0,0)"
});
var _ref326 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CCCDCD",
  transform: "translate(0,0)"
});
var _ref327 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCFCE",
  transform: "translate(0,0)"
});
var _ref328 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D4",
  transform: "translate(0,0)"
});
var _ref329 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D3D5",
  transform: "translate(0,0)"
});
var _ref330 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFD0D2",
  transform: "translate(0,0)"
});
var _ref331 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D0CF",
  transform: "translate(0,0)"
});
var _ref332 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CED2D2",
  transform: "translate(0,0)"
});
var _ref333 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CDD0CF",
  transform: "translate(0,0)"
});
var _ref334 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFD2D0",
  transform: "translate(0,0)"
});
var _ref335 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D1D1",
  transform: "translate(0,0)"
});
var _ref336 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D2",
  transform: "translate(0,0)"
});
var _ref337 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D4D4",
  transform: "translate(0,0)"
});
var _ref338 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DADAD9",
  transform: "translate(0,0)"
});
var _ref339 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D4D6",
  transform: "translate(0,0)"
});
var _ref340 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D3D6",
  transform: "translate(0,0)"
});
var _ref341 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D1CF",
  transform: "translate(0,0)"
});
var _ref342 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D5D8",
  transform: "translate(0,0)"
});
var _ref343 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D4",
  transform: "translate(0,0)"
});
var _ref344 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D9D6",
  transform: "translate(0,0)"
});
var _ref345 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DBDADA",
  transform: "translate(0,0)"
});
var _ref346 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D8D7",
  transform: "translate(0,0)"
});
var _ref347 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D8D8",
  transform: "translate(0,0)"
});
var _ref348 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D6D8",
  transform: "translate(0,0)"
});
var _ref349 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D5D3",
  transform: "translate(0,0)"
});
var _ref350 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D7D6",
  transform: "translate(0,0)"
});
var _ref351 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D6D6",
  transform: "translate(0,0)"
});
var _ref352 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D7D6",
  transform: "translate(0,0)"
});
var _ref353 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D4",
  transform: "translate(0,0)"
});
var _ref354 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DBDCDC",
  transform: "translate(0,0)"
});
var _ref355 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DBDBDA",
  transform: "translate(0,0)"
});
var _ref356 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D8D8",
  transform: "translate(0,0)"
});
var _ref357 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D7D8",
  transform: "translate(0,0)"
});
var _ref358 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D7D7",
  transform: "translate(0,0)"
});
var _ref359 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D5D4",
  transform: "translate(0,0)"
});
var _ref360 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DFDEDE",
  transform: "translate(0,0)"
});
var _ref361 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8DADB",
  transform: "translate(0,0)"
});
var _ref362 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DDDADB",
  transform: "translate(0,0)"
});
var _ref363 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D4D5",
  transform: "translate(0,0)"
});
var _ref364 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9DAD9",
  transform: "translate(0,0)"
});
var _ref365 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D5D6",
  transform: "translate(0,0)"
});
var _ref366 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D4D5",
  transform: "translate(0,0)"
});
var _ref367 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D8D8",
  transform: "translate(0,0)"
});
var _ref368 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D9D7",
  transform: "translate(0,0)"
});
var _ref369 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DCDBDC",
  transform: "translate(0,0)"
});
var _ref370 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9DBDB",
  transform: "translate(0,0)"
});
var _ref371 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D6",
  transform: "translate(0,0)"
});
var _ref372 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DCE0E0",
  transform: "translate(0,0)"
});
var _ref373 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DAD9D9",
  transform: "translate(0,0)"
});
var _ref374 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D6D8",
  transform: "translate(0,0)"
});
var _ref375 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D7D7",
  transform: "translate(0,0)"
});
var _ref376 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DADADA",
  transform: "translate(0,0)"
});
var _ref377 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7DADA",
  transform: "translate(0,0)"
});
var _ref378 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D1D3",
  transform: "translate(0,0)"
});
var _ref379 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D9D9",
  transform: "translate(0,0)"
});
var _ref380 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D7D8",
  transform: "translate(0,0)"
});
var _ref381 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D6D8",
  transform: "translate(0,0)"
});
var _ref382 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D9DA",
  transform: "translate(0,0)"
});
var _ref383 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D4",
  transform: "translate(0,0)"
});
var _ref384 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D1D3",
  transform: "translate(0,0)"
});
var _ref385 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D7D8",
  transform: "translate(0,0)"
});
var _ref386 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D6",
  transform: "translate(0,0)"
});
var _ref387 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D2",
  transform: "translate(0,0)"
});
var _ref388 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D8D8",
  transform: "translate(0,0)"
});
var _ref389 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D8D8",
  transform: "translate(0,0)"
});
var _ref390 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D2",
  transform: "translate(0,0)"
});
var _ref391 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D5",
  transform: "translate(0,0)"
});
var _ref392 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D0D4",
  transform: "translate(0,0)"
});
var _ref393 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D9DB",
  transform: "translate(0,0)"
});
var _ref394 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D8D6",
  transform: "translate(0,0)"
});
var _ref395 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D3D1",
  transform: "translate(0,0)"
});
var _ref396 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D8D7",
  transform: "translate(0,0)"
});
var _ref397 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D6D7",
  transform: "translate(0,0)"
});
var _ref398 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D2D3",
  transform: "translate(0,0)"
});
var _ref399 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D6D7",
  transform: "translate(0,0)"
});
var _ref400 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CCCED2",
  transform: "translate(0,0)"
});
var _ref401 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D9D8",
  transform: "translate(0,0)"
});
var _ref402 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DADAD8",
  transform: "translate(0,0)"
});
var _ref403 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D9D8",
  transform: "translate(0,0)"
});
var _ref404 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D6D5",
  transform: "translate(0,0)"
});
var _ref405 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D4D5",
  transform: "translate(0,0)"
});
var _ref406 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D4D3",
  transform: "translate(0,0)"
});
var _ref407 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D2D4",
  transform: "translate(0,0)"
});
var _ref408 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D2D0",
  transform: "translate(0,0)"
});
var _ref409 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFD1D0",
  transform: "translate(0,0)"
});
var _ref410 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CECED0",
  transform: "translate(0,0)"
});
var _ref411 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCFD0",
  transform: "translate(0,0)"
});
var _ref412 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFD0CF",
  transform: "translate(0,0)"
});
var _ref413 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CDCFCF",
  transform: "translate(0,0)"
});
var _ref414 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D0CE",
  transform: "translate(0,0)"
});
var _ref415 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFD0CE",
  transform: "translate(0,0)"
});
var _ref416 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CECFD0",
  transform: "translate(0,0)"
});
var _ref417 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CED0CF",
  transform: "translate(0,0)"
});
var _ref418 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CED0CF",
  transform: "translate(0,0)"
});
var _ref419 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D7D8",
  transform: "translate(0,0)"
});
var _ref420 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D6D7",
  transform: "translate(0,0)"
});
var _ref421 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D7D4",
  transform: "translate(0,0)"
});
var _ref422 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D9DA",
  transform: "translate(0,0)"
});
var _ref423 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D8D9",
  transform: "translate(0,0)"
});
var _ref424 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D9D9",
  transform: "translate(0,0)"
});
var _ref425 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D6D7",
  transform: "translate(0,0)"
});
var _ref426 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D7D9",
  transform: "translate(0,0)"
});
var _ref427 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D6D8",
  transform: "translate(0,0)"
});
var _ref428 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DADADA",
  transform: "translate(0,0)"
});
var _ref429 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D6D7",
  transform: "translate(0,0)"
});
var _ref430 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D8DA",
  transform: "translate(0,0)"
});
var _ref431 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D8D8",
  transform: "translate(0,0)"
});
var _ref432 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D8D7",
  transform: "translate(0,0)"
});
var _ref433 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D6D8",
  transform: "translate(0,0)"
});
var _ref434 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D9D9",
  transform: "translate(0,0)"
});
var _ref435 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9DADB",
  transform: "translate(0,0)"
});
var _ref436 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D7D7",
  transform: "translate(0,0)"
});
var _ref437 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D0D2",
  transform: "translate(0,0)"
});
var _ref438 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D1D2",
  transform: "translate(0,0)"
});
var _ref439 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D1D5",
  transform: "translate(0,0)"
});
var _ref440 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D9D8",
  transform: "translate(0,0)"
});
var _ref441 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D3D3",
  transform: "translate(0,0)"
});
var _ref442 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D5D5",
  transform: "translate(0,0)"
});
var _ref443 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D9DB",
  transform: "translate(0,0)"
});
var _ref444 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D7D9",
  transform: "translate(0,0)"
});
var _ref445 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8DADB",
  transform: "translate(0,0)"
});
var _ref446 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D3D3",
  transform: "translate(0,0)"
});
var _ref447 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DADCDB",
  transform: "translate(0,0)"
});
var _ref448 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D3D4",
  transform: "translate(0,0)"
});
var _ref449 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D6",
  transform: "translate(0,0)"
});
var _ref450 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D8D8",
  transform: "translate(0,0)"
});
var _ref451 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D3D7",
  transform: "translate(0,0)"
});
var _ref452 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D6D4",
  transform: "translate(0,0)"
});
var _ref453 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D4D5",
  transform: "translate(0,0)"
});
var _ref454 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D0D0",
  transform: "translate(0,0)"
});
var _ref455 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DADBDB",
  transform: "translate(0,0)"
});
var _ref456 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D2D2",
  transform: "translate(0,0)"
});
var _ref457 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D2D2",
  transform: "translate(0,0)"
});
var _ref458 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D2D1",
  transform: "translate(0,0)"
});
var _ref459 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D2D1",
  transform: "translate(0,0)"
});
var _ref460 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFD0D1",
  transform: "translate(0,0)"
});
var _ref461 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D3D3",
  transform: "translate(0,0)"
});
var _ref462 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D1D1",
  transform: "translate(0,0)"
});
var _ref463 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D3D2",
  transform: "translate(0,0)"
});
var _ref464 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D4D7",
  transform: "translate(0,0)"
});
var _ref465 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D5D5",
  transform: "translate(0,0)"
});
var _ref466 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D4D4",
  transform: "translate(0,0)"
});
var _ref467 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D5D7",
  transform: "translate(0,0)"
});
var _ref468 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D7D8",
  transform: "translate(0,0)"
});
var _ref469 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D8D7",
  transform: "translate(0,0)"
});
var _ref470 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D9DB",
  transform: "translate(0,0)"
});
var _ref471 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D7D6",
  transform: "translate(0,0)"
});
var _ref472 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D8D8",
  transform: "translate(0,0)"
});
var _ref473 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D4D6",
  transform: "translate(0,0)"
});
var _ref474 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DADBD9",
  transform: "translate(0,0)"
});
var _ref475 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D7D9",
  transform: "translate(0,0)"
});
var _ref476 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D7D8",
  transform: "translate(0,0)"
});
var _ref477 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D6D7",
  transform: "translate(0,0)"
});
var _ref478 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D2",
  transform: "translate(0,0)"
});
var _ref479 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D1D2",
  transform: "translate(0,0)"
});
var _ref480 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D2",
  transform: "translate(0,0)"
});
var _ref481 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D7D7",
  transform: "translate(0,0)"
});
var _ref482 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6DBD9",
  transform: "translate(0,0)"
});
var _ref483 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D4D8",
  transform: "translate(0,0)"
});
var _ref484 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D7D6",
  transform: "translate(0,0)"
});
var _ref485 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2CFD2",
  transform: "translate(0,0)"
});
var _ref486 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D3D4",
  transform: "translate(0,0)"
});
var _ref487 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DADADA",
  transform: "translate(0,0)"
});
var _ref488 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D2D2",
  transform: "translate(0,0)"
});
var _ref489 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D0D1",
  transform: "translate(0,0)"
});
var _ref490 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D8D9",
  transform: "translate(0,0)"
});
var _ref491 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D7D8",
  transform: "translate(0,0)"
});
var _ref492 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D4D5",
  transform: "translate(0,0)"
});
var _ref493 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DADADB",
  transform: "translate(0,0)"
});
var _ref494 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8DBDA",
  transform: "translate(0,0)"
});
var _ref495 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D8D8",
  transform: "translate(0,0)"
});
var _ref496 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D5",
  transform: "translate(0,0)"
});
var _ref497 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D2D2",
  transform: "translate(0,0)"
});
var _ref498 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DBDBDB",
  transform: "translate(0,0)"
});
var _ref499 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D1D2",
  transform: "translate(0,0)"
});
var _ref500 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D8D8",
  transform: "translate(0,0)"
});
var _ref501 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D2D2",
  transform: "translate(0,0)"
});
var _ref502 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D9D5",
  transform: "translate(0,0)"
});
var _ref503 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D6",
  transform: "translate(0,0)"
});
var _ref504 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D3D2",
  transform: "translate(0,0)"
});
var _ref505 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D2D3",
  transform: "translate(0,0)"
});
var _ref506 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D1D4",
  transform: "translate(0,0)"
});
var _ref507 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D5D7",
  transform: "translate(0,0)"
});
var _ref508 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7DAD9",
  transform: "translate(0,0)"
});
var _ref509 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D9D7",
  transform: "translate(0,0)"
});
var _ref510 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D2D3",
  transform: "translate(0,0)"
});
var _ref511 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D8DA",
  transform: "translate(0,0)"
});
var _ref512 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D6DA",
  transform: "translate(0,0)"
});
var _ref513 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D6D7",
  transform: "translate(0,0)"
});
var _ref514 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D2D4",
  transform: "translate(0,0)"
});
var _ref515 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D3D1",
  transform: "translate(0,0)"
});
var _ref516 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D0D2",
  transform: "translate(0,0)"
});
var _ref517 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D9DA",
  transform: "translate(0,0)"
});
var _ref518 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9DADB",
  transform: "translate(0,0)"
});
var _ref519 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D7D7",
  transform: "translate(0,0)"
});
var _ref520 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DBDCDC",
  transform: "translate(0,0)"
});
var _ref521 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D4D6",
  transform: "translate(0,0)"
});
var _ref522 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D8DA",
  transform: "translate(0,0)"
});
var _ref523 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DADBDB",
  transform: "translate(0,0)"
});
var _ref524 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DADADA",
  transform: "translate(0,0)"
});
var _ref525 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D5",
  transform: "translate(0,0)"
});
var _ref526 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D1D1",
  transform: "translate(0,0)"
});
var _ref527 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D4",
  transform: "translate(0,0)"
});
var _ref528 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1CFD1",
  transform: "translate(0,0)"
});
var _ref529 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D4D4",
  transform: "translate(0,0)"
});
var _ref530 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D4",
  transform: "translate(0,0)"
});
var _ref531 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D2D2",
  transform: "translate(0,0)"
});
var _ref532 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D1D0",
  transform: "translate(0,0)"
});
var _ref533 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D4D5",
  transform: "translate(0,0)"
});
var _ref534 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DADBDA",
  transform: "translate(0,0)"
});
var _ref535 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D9D8",
  transform: "translate(0,0)"
});
var _ref536 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D3D1",
  transform: "translate(0,0)"
});
var _ref537 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DEDDDC",
  transform: "translate(0,0)"
});
var _ref538 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D0",
  transform: "translate(0,0)"
});
var _ref539 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D2D1",
  transform: "translate(0,0)"
});
var _ref540 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D3D5",
  transform: "translate(0,0)"
});
var _ref541 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D6D7",
  transform: "translate(0,0)"
});
var _ref542 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D4D4",
  transform: "translate(0,0)"
});
var _ref543 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D5",
  transform: "translate(0,0)"
});
var _ref544 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9DAD8",
  transform: "translate(0,0)"
});
var _ref545 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D4D5",
  transform: "translate(0,0)"
});
var _ref546 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D4D4",
  transform: "translate(0,0)"
});
var _ref547 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D1D0",
  transform: "translate(0,0)"
});
var _ref548 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D2D3",
  transform: "translate(0,0)"
});
var _ref549 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFD1D2",
  transform: "translate(0,0)"
});
var _ref550 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D2D5",
  transform: "translate(0,0)"
});
var _ref551 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D0D3",
  transform: "translate(0,0)"
});
var _ref552 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D4D5",
  transform: "translate(0,0)"
});
var _ref553 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D3",
  transform: "translate(0,0)"
});
var _ref554 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D1D4",
  transform: "translate(0,0)"
});
var _ref555 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D5D4",
  transform: "translate(0,0)"
});
var _ref556 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D7",
  transform: "translate(0,0)"
});
var _ref557 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D3",
  transform: "translate(0,0)"
});
var _ref558 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CECECE",
  transform: "translate(0,0)"
});
var _ref559 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D9D7",
  transform: "translate(0,0)"
});
var _ref560 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D1D2",
  transform: "translate(0,0)"
});
var _ref561 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D4D2",
  transform: "translate(0,0)"
});
var _ref562 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D0D3",
  transform: "translate(0,0)"
});
var _ref563 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D2D2",
  transform: "translate(0,0)"
});
var _ref564 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D1D2",
  transform: "translate(0,0)"
});
var _ref565 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D0D1",
  transform: "translate(0,0)"
});
var _ref566 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0CFD1",
  transform: "translate(0,0)"
});
var _ref567 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D0D1",
  transform: "translate(0,0)"
});
var _ref568 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0CED0",
  transform: "translate(0,0)"
});
var _ref569 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D9D9",
  transform: "translate(0,0)"
});
var _ref570 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D7D9",
  transform: "translate(0,0)"
});
var _ref571 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D7D8",
  transform: "translate(0,0)"
});
var _ref572 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCECE",
  transform: "translate(0,0)"
});
var _ref573 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D6D4",
  transform: "translate(0,0)"
});
var _ref574 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CECFD1",
  transform: "translate(0,0)"
});
var _ref575 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D7D7",
  transform: "translate(0,0)"
});
var _ref576 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D5",
  transform: "translate(0,0)"
});
var _ref577 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D7D8",
  transform: "translate(0,0)"
});
var _ref578 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D8D9",
  transform: "translate(0,0)"
});
var _ref579 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D7",
  transform: "translate(0,0)"
});
var _ref580 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D4D6",
  transform: "translate(0,0)"
});
var _ref581 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CDCECE",
  transform: "translate(0,0)"
});
var _ref582 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D7D9",
  transform: "translate(0,0)"
});
var _ref583 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D3D7",
  transform: "translate(0,0)"
});
var _ref584 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D6D6",
  transform: "translate(0,0)"
});
var _ref585 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D6",
  transform: "translate(0,0)"
});
var _ref586 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D4D4",
  transform: "translate(0,0)"
});
var _ref587 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D4D1",
  transform: "translate(0,0)"
});
var _ref588 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D4D4",
  transform: "translate(0,0)"
});
var _ref589 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CECFCF",
  transform: "translate(0,0)"
});
var _ref590 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D4",
  transform: "translate(0,0)"
});
var _ref591 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D4D4",
  transform: "translate(0,0)"
});
var _ref592 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D1D2",
  transform: "translate(0,0)"
});
var _ref593 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D7D7",
  transform: "translate(0,0)"
});
var _ref594 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D7D6",
  transform: "translate(0,0)"
});
var _ref595 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D7D7",
  transform: "translate(0,0)"
});
var _ref596 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D6D6",
  transform: "translate(0,0)"
});
var _ref597 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D8D7",
  transform: "translate(0,0)"
});
var _ref598 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D9D9",
  transform: "translate(0,0)"
});
var _ref599 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D5D3",
  transform: "translate(0,0)"
});
var _ref600 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D6D7",
  transform: "translate(0,0)"
});
var _ref601 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CCCCCB",
  transform: "translate(0,0)"
});
var _ref602 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D5D7",
  transform: "translate(0,0)"
});
var _ref603 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D6D6",
  transform: "translate(0,0)"
});
var _ref604 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D6D8",
  transform: "translate(0,0)"
});
var _ref605 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D4D4",
  transform: "translate(0,0)"
});
var _ref606 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D6D7",
  transform: "translate(0,0)"
});
var _ref607 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D5",
  transform: "translate(0,0)"
});
var _ref608 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D1D2",
  transform: "translate(0,0)"
});
var _ref609 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D6D7",
  transform: "translate(0,0)"
});
var _ref610 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D7D6",
  transform: "translate(0,0)"
});
var _ref611 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D6",
  transform: "translate(0,0)"
});
var _ref612 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D7D9",
  transform: "translate(0,0)"
});
var _ref613 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D6D3",
  transform: "translate(0,0)"
});
var _ref614 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D4D4",
  transform: "translate(0,0)"
});
var _ref615 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D3",
  transform: "translate(0,0)"
});
var _ref616 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D0D4",
  transform: "translate(0,0)"
});
var _ref617 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0CFD2",
  transform: "translate(0,0)"
});
var _ref618 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D2",
  transform: "translate(0,0)"
});
var _ref619 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D5",
  transform: "translate(0,0)"
});
var _ref620 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D4",
  transform: "translate(0,0)"
});
var _ref621 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D3",
  transform: "translate(0,0)"
});
var _ref622 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D4D3",
  transform: "translate(0,0)"
});
var _ref623 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D3",
  transform: "translate(0,0)"
});
var _ref624 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2CFD1",
  transform: "translate(0,0)"
});
var _ref625 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCFD0",
  transform: "translate(0,0)"
});
var _ref626 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D7DB",
  transform: "translate(0,0)"
});
var _ref627 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DBD8D8",
  transform: "translate(0,0)"
});
var _ref628 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D2D3",
  transform: "translate(0,0)"
});
var _ref629 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D7D6",
  transform: "translate(0,0)"
});
var _ref630 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D7D7",
  transform: "translate(0,0)"
});
var _ref631 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D3D2",
  transform: "translate(0,0)"
});
var _ref632 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0CFD0",
  transform: "translate(0,0)"
});
var _ref633 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFD1D2",
  transform: "translate(0,0)"
});
var _ref634 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFD0D0",
  transform: "translate(0,0)"
});
var _ref635 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9DAD8",
  transform: "translate(0,0)"
});
var _ref636 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D4D6",
  transform: "translate(0,0)"
});
var _ref637 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D4D5",
  transform: "translate(0,0)"
});
var _ref638 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D6",
  transform: "translate(0,0)"
});
var _ref639 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D3D2",
  transform: "translate(0,0)"
});
var _ref640 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DBDCD8",
  transform: "translate(0,0)"
});
var _ref641 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D3D1",
  transform: "translate(0,0)"
});
var _ref642 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D4",
  transform: "translate(0,0)"
});
var _ref643 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D4D3",
  transform: "translate(0,0)"
});
var _ref644 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D2",
  transform: "translate(0,0)"
});
var _ref645 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D3",
  transform: "translate(0,0)"
});
var _ref646 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D1D2",
  transform: "translate(0,0)"
});
var _ref647 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCFCF",
  transform: "translate(0,0)"
});
var _ref648 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D3",
  transform: "translate(0,0)"
});
var _ref649 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D7DB",
  transform: "translate(0,0)"
});
var _ref650 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D0D1",
  transform: "translate(0,0)"
});
var _ref651 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D4",
  transform: "translate(0,0)"
});
var _ref652 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D2D5",
  transform: "translate(0,0)"
});
var _ref653 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D4D5",
  transform: "translate(0,0)"
});
var _ref654 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D4D4",
  transform: "translate(0,0)"
});
var _ref655 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D2D5",
  transform: "translate(0,0)"
});
var _ref656 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D2D4",
  transform: "translate(0,0)"
});
var _ref657 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D3D4",
  transform: "translate(0,0)"
});
var _ref658 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D4D6",
  transform: "translate(0,0)"
});
var _ref659 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D7D5",
  transform: "translate(0,0)"
});
var _ref660 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0CED1",
  transform: "translate(0,0)"
});
var _ref661 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D8D9",
  transform: "translate(0,0)"
});
var _ref662 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CECFCF",
  transform: "translate(0,0)"
});
var _ref663 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0CFD0",
  transform: "translate(0,0)"
});
var _ref664 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D2D1",
  transform: "translate(0,0)"
});
var _ref665 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D7D7",
  transform: "translate(0,0)"
});
var _ref666 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D6",
  transform: "translate(0,0)"
});
var _ref667 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D6D5",
  transform: "translate(0,0)"
});
var _ref668 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D6D5",
  transform: "translate(0,0)"
});
var _ref669 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D1D2",
  transform: "translate(0,0)"
});
var _ref670 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D1D6",
  transform: "translate(0,0)"
});
var _ref671 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D3D4",
  transform: "translate(0,0)"
});
var _ref672 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D0D3",
  transform: "translate(0,0)"
});
var _ref673 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D3D3",
  transform: "translate(0,0)"
});
var _ref674 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D5D0",
  transform: "translate(0,0)"
});
var _ref675 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2CDD1",
  transform: "translate(0,0)"
});
var _ref676 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D2D2",
  transform: "translate(0,0)"
});
var _ref677 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D1D3",
  transform: "translate(0,0)"
});
var _ref678 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D0D3",
  transform: "translate(0,0)"
});
var _ref679 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D3D3",
  transform: "translate(0,0)"
});
var _ref680 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D3D3",
  transform: "translate(0,0)"
});
var _ref681 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D0D0",
  transform: "translate(0,0)"
});
var _ref682 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1CED0",
  transform: "translate(0,0)"
});
var _ref683 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCFCF",
  transform: "translate(0,0)"
});
var _ref684 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D4D3",
  transform: "translate(0,0)"
});
var _ref685 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D2D3",
  transform: "translate(0,0)"
});
var _ref686 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D3",
  transform: "translate(0,0)"
});
var _ref687 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D1D2",
  transform: "translate(0,0)"
});
var _ref688 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D3",
  transform: "translate(0,0)"
});
var _ref689 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D4D5",
  transform: "translate(0,0)"
});
var _ref690 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D6",
  transform: "translate(0,0)"
});
var _ref691 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D3",
  transform: "translate(0,0)"
});
var _ref692 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D3D4",
  transform: "translate(0,0)"
});
var _ref693 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D7D7",
  transform: "translate(0,0)"
});
var _ref694 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D6D7",
  transform: "translate(0,0)"
});
var _ref695 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D2",
  transform: "translate(0,0)"
});
var _ref696 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D1D2",
  transform: "translate(0,0)"
});
var _ref697 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D3D4",
  transform: "translate(0,0)"
});
var _ref698 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D4",
  transform: "translate(0,0)"
});
var _ref699 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D4",
  transform: "translate(0,0)"
});
var _ref700 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D6D7",
  transform: "translate(0,0)"
});
var _ref701 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D7D9",
  transform: "translate(0,0)"
});
var _ref702 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D5",
  transform: "translate(0,0)"
});
var _ref703 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D4D4",
  transform: "translate(0,0)"
});
var _ref704 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D4D5",
  transform: "translate(0,0)"
});
var _ref705 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#E0DFE0",
  transform: "translate(0,0)"
});
var _ref706 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CCCECB",
  transform: "translate(0,0)"
});
var _ref707 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D6D7",
  transform: "translate(0,0)"
});
var _ref708 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DAD9DB",
  transform: "translate(0,0)"
});
var _ref709 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D4D2",
  transform: "translate(0,0)"
});
var _ref710 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D3D3",
  transform: "translate(0,0)"
});
var _ref711 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D4D5",
  transform: "translate(0,0)"
});
var _ref712 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D3D4",
  transform: "translate(0,0)"
});
var _ref713 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D7",
  transform: "translate(0,0)"
});
var _ref714 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D4",
  transform: "translate(0,0)"
});
var _ref715 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D4D4",
  transform: "translate(0,0)"
});
var _ref716 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D1D2",
  transform: "translate(0,0)"
});
var _ref717 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DBD9D9",
  transform: "translate(0,0)"
});
var _ref718 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D1D2",
  transform: "translate(0,0)"
});
var _ref719 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D2D4",
  transform: "translate(0,0)"
});
var _ref720 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D3D1",
  transform: "translate(0,0)"
});
var _ref721 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D4D3",
  transform: "translate(0,0)"
});
var _ref722 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D3",
  transform: "translate(0,0)"
});
var _ref723 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1CFD1",
  transform: "translate(0,0)"
});
var _ref724 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D7D6",
  transform: "translate(0,0)"
});
var _ref725 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D4D4",
  transform: "translate(0,0)"
});
var _ref726 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D1D4",
  transform: "translate(0,0)"
});
var _ref727 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D3D1",
  transform: "translate(0,0)"
});
var _ref728 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D2D3",
  transform: "translate(0,0)"
});
var _ref729 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D8D7",
  transform: "translate(0,0)"
});
var _ref730 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D8D9",
  transform: "translate(0,0)"
});
var _ref731 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D1D2",
  transform: "translate(0,0)"
});
var _ref732 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D5D4",
  transform: "translate(0,0)"
});
var _ref733 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D4D2",
  transform: "translate(0,0)"
});
var _ref734 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DAD9DA",
  transform: "translate(0,0)"
});
var _ref735 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D5",
  transform: "translate(0,0)"
});
var _ref736 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8DAD9",
  transform: "translate(0,0)"
});
var _ref737 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D5",
  transform: "translate(0,0)"
});
var _ref738 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D2D4",
  transform: "translate(0,0)"
});
var _ref739 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D9DB",
  transform: "translate(0,0)"
});
var _ref740 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D3D5",
  transform: "translate(0,0)"
});
var _ref741 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D3",
  transform: "translate(0,0)"
});
var _ref742 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D3D4",
  transform: "translate(0,0)"
});
var _ref743 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D2",
  transform: "translate(0,0)"
});
var _ref744 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D8D5",
  transform: "translate(0,0)"
});
var _ref745 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D4D4",
  transform: "translate(0,0)"
});
var _ref746 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D4",
  transform: "translate(0,0)"
});
var _ref747 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DADADA",
  transform: "translate(0,0)"
});
var _ref748 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D6D6",
  transform: "translate(0,0)"
});
var _ref749 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D3",
  transform: "translate(0,0)"
});
var _ref750 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D8D7",
  transform: "translate(0,0)"
});
var _ref751 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D2D2",
  transform: "translate(0,0)"
});
var _ref752 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D3D6",
  transform: "translate(0,0)"
});
var _ref753 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D7",
  transform: "translate(0,0)"
});
var _ref754 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D4D3",
  transform: "translate(0,0)"
});
var _ref755 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D1D2",
  transform: "translate(0,0)"
});
var _ref756 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D4D5",
  transform: "translate(0,0)"
});
var _ref757 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D3D3",
  transform: "translate(0,0)"
});
var _ref758 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D4D7",
  transform: "translate(0,0)"
});
var _ref759 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D6D7",
  transform: "translate(0,0)"
});
var _ref760 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D4D5",
  transform: "translate(0,0)"
});
var _ref761 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D7D6",
  transform: "translate(0,0)"
});
var _ref762 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D4D7",
  transform: "translate(0,0)"
});
var _ref763 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D4D7",
  transform: "translate(0,0)"
});
var _ref764 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D6D8",
  transform: "translate(0,0)"
});
var _ref765 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D4D4",
  transform: "translate(0,0)"
});
var _ref766 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D5D6",
  transform: "translate(0,0)"
});
var _ref767 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D8D7",
  transform: "translate(0,0)"
});
var _ref768 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D4D6",
  transform: "translate(0,0)"
});
var _ref769 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D9D7",
  transform: "translate(0,0)"
});
var _ref770 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D7",
  transform: "translate(0,0)"
});
var _ref771 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D5D5",
  transform: "translate(0,0)"
});
var _ref772 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D9D8",
  transform: "translate(0,0)"
});
var _ref773 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D5D6",
  transform: "translate(0,0)"
});
var _ref774 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D4",
  transform: "translate(0,0)"
});
var _ref775 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D5D7",
  transform: "translate(0,0)"
});
var _ref776 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D7D6",
  transform: "translate(0,0)"
});
var _ref777 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D5",
  transform: "translate(0,0)"
});
var _ref778 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D0",
  transform: "translate(0,0)"
});
var _ref779 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D6D6",
  transform: "translate(0,0)"
});
var _ref780 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D6D7",
  transform: "translate(0,0)"
});
var _ref781 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D4D4",
  transform: "translate(0,0)"
});
var _ref782 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D4D5",
  transform: "translate(0,0)"
});
var _ref783 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D1D2",
  transform: "translate(0,0)"
});
var _ref784 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0CFD1",
  transform: "translate(0,0)"
});
var _ref785 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D6",
  transform: "translate(0,0)"
});
var _ref786 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D4D5",
  transform: "translate(0,0)"
});
var _ref787 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D4D4",
  transform: "translate(0,0)"
});
var _ref788 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D4D4",
  transform: "translate(0,0)"
});
var _ref789 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DADBDD",
  transform: "translate(0,0)"
});
var _ref790 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D3D5",
  transform: "translate(0,0)"
});
var _ref791 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D6D4",
  transform: "translate(0,0)"
});
var _ref792 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0CFD0",
  transform: "translate(0,0)"
});
var _ref793 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D6D5",
  transform: "translate(0,0)"
});
var _ref794 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D3D4",
  transform: "translate(0,0)"
});
var _ref795 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D5D5",
  transform: "translate(0,0)"
});
var _ref796 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D1",
  transform: "translate(0,0)"
});
var _ref797 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D5D8",
  transform: "translate(0,0)"
});
var _ref798 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D2D2",
  transform: "translate(0,0)"
});
var _ref799 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D2D4",
  transform: "translate(0,0)"
});
var _ref800 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D7D7",
  transform: "translate(0,0)"
});
var _ref801 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D1D4",
  transform: "translate(0,0)"
});
var _ref802 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D1D1",
  transform: "translate(0,0)"
});
var _ref803 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D1D1",
  transform: "translate(0,0)"
});
var _ref804 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D9D7",
  transform: "translate(0,0)"
});
var _ref805 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D6D7",
  transform: "translate(0,0)"
});
var _ref806 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D8D8",
  transform: "translate(0,0)"
});
var _ref807 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D3",
  transform: "translate(0,0)"
});
var _ref808 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DBD9D8",
  transform: "translate(0,0)"
});
var _ref809 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D8D7",
  transform: "translate(0,0)"
});
var _ref810 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D4D3",
  transform: "translate(0,0)"
});
var _ref811 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D8D8",
  transform: "translate(0,0)"
});
var _ref812 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D8D8",
  transform: "translate(0,0)"
});
var _ref813 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D4",
  transform: "translate(0,0)"
});
var _ref814 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D8D7",
  transform: "translate(0,0)"
});
var _ref815 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DBDCDC",
  transform: "translate(0,0)"
});
var _ref816 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D7D6",
  transform: "translate(0,0)"
});
var _ref817 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D4D6",
  transform: "translate(0,0)"
});
var _ref818 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DADADA",
  transform: "translate(0,0)"
});
var _ref819 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D8D6",
  transform: "translate(0,0)"
});
var _ref820 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D5D6",
  transform: "translate(0,0)"
});
var _ref821 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D5D5",
  transform: "translate(0,0)"
});
var _ref822 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D9D9",
  transform: "translate(0,0)"
});
var _ref823 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#E0DFE0",
  transform: "translate(0,0)"
});
var _ref824 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D8D6",
  transform: "translate(0,0)"
});
var _ref825 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9DADA",
  transform: "translate(0,0)"
});
var _ref826 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D7D3",
  transform: "translate(0,0)"
});
var _ref827 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D6",
  transform: "translate(0,0)"
});
var _ref828 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D6D7",
  transform: "translate(0,0)"
});
var _ref829 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D4",
  transform: "translate(0,0)"
});
var _ref830 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D3D4",
  transform: "translate(0,0)"
});
var _ref831 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D6D6",
  transform: "translate(0,0)"
});
var _ref832 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D4D3",
  transform: "translate(0,0)"
});
var _ref833 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D4D6",
  transform: "translate(0,0)"
});
var _ref834 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D2D2",
  transform: "translate(0,0)"
});
var _ref835 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D1D3",
  transform: "translate(0,0)"
});
var _ref836 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCFD0",
  transform: "translate(0,0)"
});
var _ref837 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CED0CF",
  transform: "translate(0,0)"
});
var _ref838 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D2",
  transform: "translate(0,0)"
});
var _ref839 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D3",
  transform: "translate(0,0)"
});
var _ref840 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D5D4",
  transform: "translate(0,0)"
});
var _ref841 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D2D3",
  transform: "translate(0,0)"
});
var _ref842 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D4D5",
  transform: "translate(0,0)"
});
var _ref843 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D5D5",
  transform: "translate(0,0)"
});
var _ref844 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D4D5",
  transform: "translate(0,0)"
});
var _ref845 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CBCBCC",
  transform: "translate(0,0)"
});
var _ref846 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D5D3",
  transform: "translate(0,0)"
});
var _ref847 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DCDCDD",
  transform: "translate(0,0)"
});
var _ref848 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D6D5",
  transform: "translate(0,0)"
});
var _ref849 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D4D5",
  transform: "translate(0,0)"
});
var _ref850 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3CFD3",
  transform: "translate(0,0)"
});
var _ref851 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D3D4",
  transform: "translate(0,0)"
});
var _ref852 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D2D2",
  transform: "translate(0,0)"
});
var _ref853 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D4D3",
  transform: "translate(0,0)"
});
var _ref854 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D3D3",
  transform: "translate(0,0)"
});
var _ref855 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D6D6",
  transform: "translate(0,0)"
});
var _ref856 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D4",
  transform: "translate(0,0)"
});
var _ref857 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D3D2",
  transform: "translate(0,0)"
});
var _ref858 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DCDCDC",
  transform: "translate(0,0)"
});
var _ref859 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D3D4",
  transform: "translate(0,0)"
});
var _ref860 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D6D6",
  transform: "translate(0,0)"
});
var _ref861 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D4D6",
  transform: "translate(0,0)"
});
var _ref862 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D6D7",
  transform: "translate(0,0)"
});
var _ref863 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D8D5",
  transform: "translate(0,0)"
});
var _ref864 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D5D7",
  transform: "translate(0,0)"
});
var _ref865 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D7D7",
  transform: "translate(0,0)"
});
var _ref866 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D5D4",
  transform: "translate(0,0)"
});
var _ref867 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D9D8",
  transform: "translate(0,0)"
});
var _ref868 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D7D7",
  transform: "translate(0,0)"
});
var _ref869 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D2D5",
  transform: "translate(0,0)"
});
var _ref870 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D8D9",
  transform: "translate(0,0)"
});
var _ref871 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D6D5",
  transform: "translate(0,0)"
});
var _ref872 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCFCF",
  transform: "translate(0,0)"
});
var _ref873 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D7D7",
  transform: "translate(0,0)"
});
var _ref874 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D6D6",
  transform: "translate(0,0)"
});
var _ref875 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D9D9",
  transform: "translate(0,0)"
});
var _ref876 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DADADB",
  transform: "translate(0,0)"
});
var _ref877 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DBD9D9",
  transform: "translate(0,0)"
});
var _ref878 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D9DA",
  transform: "translate(0,0)"
});
var _ref879 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D6DA",
  transform: "translate(0,0)"
});
var _ref880 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D6D9",
  transform: "translate(0,0)"
});
var _ref881 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D3D4",
  transform: "translate(0,0)"
});
var _ref882 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D6D5",
  transform: "translate(0,0)"
});
var _ref883 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D5D3",
  transform: "translate(0,0)"
});
var _ref884 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D9D7",
  transform: "translate(0,0)"
});
var _ref885 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D0D0",
  transform: "translate(0,0)"
});
var _ref886 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D4D6",
  transform: "translate(0,0)"
});
var _ref887 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D6D7",
  transform: "translate(0,0)"
});
var _ref888 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D5",
  transform: "translate(0,0)"
});
var _ref889 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D4D7",
  transform: "translate(0,0)"
});
var _ref890 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D8",
  transform: "translate(0,0)"
});
var _ref891 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D6D6",
  transform: "translate(0,0)"
});
var _ref892 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D0CF",
  transform: "translate(0,0)"
});
var _ref893 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D7D5",
  transform: "translate(0,0)"
});
var _ref894 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D9D7",
  transform: "translate(0,0)"
});
var _ref895 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D4D2",
  transform: "translate(0,0)"
});
var _ref896 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D7D7",
  transform: "translate(0,0)"
});
var _ref897 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D5D6",
  transform: "translate(0,0)"
});
var _ref898 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D6D5",
  transform: "translate(0,0)"
});
var _ref899 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D4D3",
  transform: "translate(0,0)"
});
var _ref900 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D6",
  transform: "translate(0,0)"
});
var _ref901 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D5D4",
  transform: "translate(0,0)"
});
var _ref902 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D6D7",
  transform: "translate(0,0)"
});
var _ref903 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D6D5",
  transform: "translate(0,0)"
});
var _ref904 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D9DB",
  transform: "translate(0,0)"
});
var _ref905 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D5D6",
  transform: "translate(0,0)"
});
var _ref906 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D6D6",
  transform: "translate(0,0)"
});
var _ref907 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D7D8",
  transform: "translate(0,0)"
});
var _ref908 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D1D0",
  transform: "translate(0,0)"
});
var _ref909 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D0D0",
  transform: "translate(0,0)"
});
var _ref910 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D5D6",
  transform: "translate(0,0)"
});
var _ref911 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D5D5",
  transform: "translate(0,0)"
});
var _ref912 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D4D5",
  transform: "translate(0,0)"
});
var _ref913 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D5D7",
  transform: "translate(0,0)"
});
var _ref914 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CCCECE",
  transform: "translate(0,0)"
});
var _ref915 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D3D2",
  transform: "translate(0,0)"
});
var _ref916 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D7",
  transform: "translate(0,0)"
});
var _ref917 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D7D8",
  transform: "translate(0,0)"
});
var _ref918 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D0D2",
  transform: "translate(0,0)"
});
var _ref919 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D8D6",
  transform: "translate(0,0)"
});
var _ref920 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D6D7",
  transform: "translate(0,0)"
});
var _ref921 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D3D5",
  transform: "translate(0,0)"
});
var _ref922 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D7D7",
  transform: "translate(0,0)"
});
var _ref923 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCFCE",
  transform: "translate(0,0)"
});
var _ref924 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D2D5",
  transform: "translate(0,0)"
});
var _ref925 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D8D8",
  transform: "translate(0,0)"
});
var _ref926 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D1CF",
  transform: "translate(0,0)"
});
var _ref927 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D1D3",
  transform: "translate(0,0)"
});
var _ref928 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D7D8",
  transform: "translate(0,0)"
});
var _ref929 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D6D5",
  transform: "translate(0,0)"
});
var _ref930 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D4D5",
  transform: "translate(0,0)"
});
var _ref931 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D5",
  transform: "translate(0,0)"
});
var _ref932 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D8D8",
  transform: "translate(0,0)"
});
var _ref933 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D6D5",
  transform: "translate(0,0)"
});
var _ref934 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D3",
  transform: "translate(0,0)"
});
var _ref935 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CCCCCA",
  transform: "translate(0,0)"
});
var _ref936 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFD1D1",
  transform: "translate(0,0)"
});
var _ref937 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D3",
  transform: "translate(0,0)"
});
var _ref938 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D2D3",
  transform: "translate(0,0)"
});
var _ref939 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D9D5",
  transform: "translate(0,0)"
});
var _ref940 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D8D9",
  transform: "translate(0,0)"
});
var _ref941 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D5D7",
  transform: "translate(0,0)"
});
var _ref942 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CBCCCB",
  transform: "translate(0,0)"
});
var _ref943 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D8D9",
  transform: "translate(0,0)"
});
var _ref944 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D6D7",
  transform: "translate(0,0)"
});
var _ref945 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D5D7",
  transform: "translate(0,0)"
});
var _ref946 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D5D6",
  transform: "translate(0,0)"
});
var _ref947 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#BFC3C0",
  transform: "translate(0,0)"
});
var _ref948 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D7DA",
  transform: "translate(0,0)"
});
var _ref949 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D2D5",
  transform: "translate(0,0)"
});
var _ref950 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D4D5",
  transform: "translate(0,0)"
});
var _ref951 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#BFC1BE",
  transform: "translate(0,0)"
});
var _ref952 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D6D6",
  transform: "translate(0,0)"
});
var _ref953 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D5D6",
  transform: "translate(0,0)"
});
var _ref954 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D4D6",
  transform: "translate(0,0)"
});
var _ref955 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D4D5",
  transform: "translate(0,0)"
});
var _ref956 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D6D6",
  transform: "translate(0,0)"
});
var _ref957 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D6D4",
  transform: "translate(0,0)"
});
var _ref958 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D2D3",
  transform: "translate(0,0)"
});
var _ref959 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CECFCF",
  transform: "translate(0,0)"
});
var _ref960 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CECECE",
  transform: "translate(0,0)"
});
var _ref961 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D1D2",
  transform: "translate(0,0)"
});
var _ref962 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D1",
  transform: "translate(0,0)"
});
var _ref963 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7D7D8",
  transform: "translate(0,0)"
});
var _ref964 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DAD8DA",
  transform: "translate(0,0)"
});
var _ref965 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D7DADB",
  transform: "translate(0,0)"
});
var _ref966 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D5",
  transform: "translate(0,0)"
});
var _ref967 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D1D1",
  transform: "translate(0,0)"
});
var _ref968 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CCCCC8",
  transform: "translate(0,0)"
});
var _ref969 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CBC8C7",
  transform: "translate(0,0)"
});
var _ref970 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D3D3",
  transform: "translate(0,0)"
});
var _ref971 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFD0D3",
  transform: "translate(0,0)"
});
var _ref972 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D2D3",
  transform: "translate(0,0)"
});
var _ref973 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D1D1",
  transform: "translate(0,0)"
});
var _ref974 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D1D5",
  transform: "translate(0,0)"
});
var _ref975 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D5",
  transform: "translate(0,0)"
});
var _ref976 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D2D4",
  transform: "translate(0,0)"
});
var _ref977 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D1D2",
  transform: "translate(0,0)"
});
var _ref978 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D2D3",
  transform: "translate(0,0)"
});
var _ref979 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D3",
  transform: "translate(0,0)"
});
var _ref980 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CDCDCF",
  transform: "translate(0,0)"
});
var _ref981 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D3D4",
  transform: "translate(0,0)"
});
var _ref982 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D5D3",
  transform: "translate(0,0)"
});
var _ref983 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D0D4",
  transform: "translate(0,0)"
});
var _ref984 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D1D3",
  transform: "translate(0,0)"
});
var _ref985 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D1D1",
  transform: "translate(0,0)"
});
var _ref986 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D1D3",
  transform: "translate(0,0)"
});
var _ref987 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D1D2",
  transform: "translate(0,0)"
});
var _ref988 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D5D6",
  transform: "translate(0,0)"
});
var _ref989 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D1D2",
  transform: "translate(0,0)"
});
var _ref990 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D1D2",
  transform: "translate(0,0)"
});
var _ref991 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D3D3",
  transform: "translate(0,0)"
});
var _ref992 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D4D4",
  transform: "translate(0,0)"
});
var _ref993 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#A7A7A7",
  transform: "translate(0,0)"
});
var _ref994 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#B7B7B7",
  transform: "translate(0,0)"
});
var _ref995 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#B7B7B7",
  transform: "translate(0,0)"
});
var _ref996 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#AEACB0",
  transform: "translate(0,0)"
});
var _ref997 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#ABADAD",
  transform: "translate(0,0)"
});
var _ref998 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#989797",
  transform: "translate(0,0)"
});
var _ref999 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#969495",
  transform: "translate(0,0)"
});
var _ref1000 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#8A898A",
  transform: "translate(0,0)"
});
var _ref1001 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#868586",
  transform: "translate(0,0)"
});
var _ref1002 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#7C7A7C",
  transform: "translate(0,0)"
});
var _ref1003 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#7C7A79",
  transform: "translate(0,0)"
});
var _ref1004 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#868482",
  transform: "translate(0,0)"
});
var _ref1005 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#878686",
  transform: "translate(0,0)"
});
var _ref1006 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#918E90",
  transform: "translate(0,0)"
});
var _ref1007 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#989798",
  transform: "translate(0,0)"
});
var _ref1008 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#A19E9E",
  transform: "translate(0,0)"
});
var _ref1009 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#A8A7A7",
  transform: "translate(0,0)"
});
var _ref1010 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#ACACAA",
  transform: "translate(0,0)"
});
var _ref1011 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#B7B7B6",
  transform: "translate(0,0)"
});
var _ref1012 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#B8B7B7",
  transform: "translate(0,0)"
});
var _ref1013 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#BBB9BA",
  transform: "translate(0,0)"
});
var _ref1014 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#BBBABB",
  transform: "translate(0,0)"
});
var _ref1015 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#B3B3B4",
  transform: "translate(0,0)"
});
var _ref1016 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#BAB9B8",
  transform: "translate(0,0)"
});
var _ref1017 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#BFC0BF",
  transform: "translate(0,0)"
});
var _ref1018 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#BBBBBC",
  transform: "translate(0,0)"
});
var _ref1019 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#BBBDBA",
  transform: "translate(0,0)"
});
var _ref1020 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#C5C6C7",
  transform: "translate(0,0)"
});
var _ref1021 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0CDD0",
  transform: "translate(0,0)"
});
var _ref1022 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#C1C0C3",
  transform: "translate(0,0)"
});
var _ref1023 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#C9C9C9",
  transform: "translate(0,0)"
});
var _ref1024 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#BEBDBE",
  transform: "translate(0,0)"
});
var _ref1025 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#C2C3C4",
  transform: "translate(0,0)"
});
var _ref1026 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#BEBDC1",
  transform: "translate(0,0)"
});
var _ref1027 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#C2C2C4",
  transform: "translate(0,0)"
});
var _ref1028 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCDCE",
  transform: "translate(0,0)"
});
var _ref1029 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CBCACB",
  transform: "translate(0,0)"
});
var _ref1030 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CACACA",
  transform: "translate(0,0)"
});
var _ref1031 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#C9C8C8",
  transform: "translate(0,0)"
});
var _ref1032 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CECDCF",
  transform: "translate(0,0)"
});
var _ref1033 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#C6C8C8",
  transform: "translate(0,0)"
});
var _ref1034 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#C6C4C6",
  transform: "translate(0,0)"
});
var _ref1035 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#C9CBCB",
  transform: "translate(0,0)"
});
var _ref1036 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0CECF",
  transform: "translate(0,0)"
});
var _ref1037 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFD1D1",
  transform: "translate(0,0)"
});
var _ref1038 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D5D6D6",
  transform: "translate(0,0)"
});
var _ref1039 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CACBCB",
  transform: "translate(0,0)"
});
var _ref1040 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D1",
  transform: "translate(0,0)"
});
var _ref1041 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D1D1",
  transform: "translate(0,0)"
});
var _ref1042 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#C5C3C5",
  transform: "translate(0,0)"
});
var _ref1043 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D6D7",
  transform: "translate(0,0)"
});
var _ref1044 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D2D2",
  transform: "translate(0,0)"
});
var _ref1045 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D0D1",
  transform: "translate(0,0)"
});
var _ref1046 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1CFD1",
  transform: "translate(0,0)"
});
var _ref1047 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#C5C3C6",
  transform: "translate(0,0)"
});
var _ref1048 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFD2D1",
  transform: "translate(0,0)"
});
var _ref1049 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCFD0",
  transform: "translate(0,0)"
});
var _ref1050 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#C7C4C4",
  transform: "translate(0,0)"
});
var _ref1051 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D0D3",
  transform: "translate(0,0)"
});
var _ref1052 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D3D3",
  transform: "translate(0,0)"
});
var _ref1053 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0CFCF",
  transform: "translate(0,0)"
});
var _ref1054 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CDCBCE",
  transform: "translate(0,0)"
});
var _ref1055 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#C9C9C9",
  transform: "translate(0,0)"
});
var _ref1056 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D1D0",
  transform: "translate(0,0)"
});
var _ref1057 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#C5C8C7",
  transform: "translate(0,0)"
});
var _ref1058 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CAC9CB",
  transform: "translate(0,0)"
});
var _ref1059 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#C8C9C7",
  transform: "translate(0,0)"
});
var _ref1060 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CBCACB",
  transform: "translate(0,0)"
});
var _ref1061 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D2",
  transform: "translate(0,0)"
});
var _ref1062 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CCCDCD",
  transform: "translate(0,0)"
});
var _ref1063 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CCCDCE",
  transform: "translate(0,0)"
});
var _ref1064 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCFD1",
  transform: "translate(0,0)"
});
var _ref1065 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D3D2",
  transform: "translate(0,0)"
});
var _ref1066 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CBCECD",
  transform: "translate(0,0)"
});
var _ref1067 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFD0D0",
  transform: "translate(0,0)"
});
var _ref1068 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFD2D3",
  transform: "translate(0,0)"
});
var _ref1069 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFD1D2",
  transform: "translate(0,0)"
});
var _ref1070 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CCCCCE",
  transform: "translate(0,0)"
});
var _ref1071 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CDCECF",
  transform: "translate(0,0)"
});
var _ref1072 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CDCDCE",
  transform: "translate(0,0)"
});
var _ref1073 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CBCECF",
  transform: "translate(0,0)"
});
var _ref1074 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CDCDCB",
  transform: "translate(0,0)"
});
var _ref1075 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#C6C7C8",
  transform: "translate(0,0)"
});
var _ref1076 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CBCCCC",
  transform: "translate(0,0)"
});
var _ref1077 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CCCCCD",
  transform: "translate(0,0)"
});
var _ref1078 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CBCCCC",
  transform: "translate(0,0)"
});
var _ref1079 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D2",
  transform: "translate(0,0)"
});
var _ref1080 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CECBCE",
  transform: "translate(0,0)"
});
var _ref1081 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D1D1",
  transform: "translate(0,0)"
});
var _ref1082 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2CED1",
  transform: "translate(0,0)"
});
var _ref1083 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CBCBCC",
  transform: "translate(0,0)"
});
var _ref1084 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0CECF",
  transform: "translate(0,0)"
});
var _ref1085 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CED1CF",
  transform: "translate(0,0)"
});
var _ref1086 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0CFD0",
  transform: "translate(0,0)"
});
var _ref1087 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCDCF",
  transform: "translate(0,0)"
});
var _ref1088 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1CECE",
  transform: "translate(0,0)"
});
var _ref1089 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D1",
  transform: "translate(0,0)"
});
var _ref1090 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D2D2",
  transform: "translate(0,0)"
});
var _ref1091 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#C9C8CA",
  transform: "translate(0,0)"
});
var _ref1092 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0CED1",
  transform: "translate(0,0)"
});
var _ref1093 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D3D0D0",
  transform: "translate(0,0)"
});
var _ref1094 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D3D4",
  transform: "translate(0,0)"
});
var _ref1095 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D2D2",
  transform: "translate(0,0)"
});
var _ref1096 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCFD0",
  transform: "translate(0,0)"
});
var _ref1097 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D0D1",
  transform: "translate(0,0)"
});
var _ref1098 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCDD0",
  transform: "translate(0,0)"
});
var _ref1099 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CDD0CE",
  transform: "translate(0,0)"
});
var _ref1100 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCED1",
  transform: "translate(0,0)"
});
var _ref1101 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D4D4",
  transform: "translate(0,0)"
});
var _ref1102 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1CECE",
  transform: "translate(0,0)"
});
var _ref1103 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CECFD1",
  transform: "translate(0,0)"
});
var _ref1104 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFD0D1",
  transform: "translate(0,0)"
});
var _ref1105 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCED0",
  transform: "translate(0,0)"
});
var _ref1106 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D3D2",
  transform: "translate(0,0)"
});
var _ref1107 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CECDCF",
  transform: "translate(0,0)"
});
var _ref1108 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1CFD0",
  transform: "translate(0,0)"
});
var _ref1109 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D2D3D1",
  transform: "translate(0,0)"
});
var _ref1110 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CDCECE",
  transform: "translate(0,0)"
});
var _ref1111 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CDCFCE",
  transform: "translate(0,0)"
});
var _ref1112 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D2D2",
  transform: "translate(0,0)"
});
var _ref1113 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFD0CF",
  transform: "translate(0,0)"
});
var _ref1114 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CECBCC",
  transform: "translate(0,0)"
});
var _ref1115 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CBCBCE",
  transform: "translate(0,0)"
});
var _ref1116 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#C8CAC8",
  transform: "translate(0,0)"
});
var _ref1117 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CCCBCA",
  transform: "translate(0,0)"
});
var _ref1118 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CDCECF",
  transform: "translate(0,0)"
});
var _ref1119 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CDCDCD",
  transform: "translate(0,0)"
});
var _ref1120 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#C9C8C9",
  transform: "translate(0,0)"
});
var _ref1121 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CED0CF",
  transform: "translate(0,0)"
});
var _ref1122 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D0D0",
  transform: "translate(0,0)"
});
var _ref1123 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D0D2",
  transform: "translate(0,0)"
});
var _ref1124 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D0CF",
  transform: "translate(0,0)"
});
var _ref1125 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFD0D2",
  transform: "translate(0,0)"
});
var _ref1126 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCED1",
  transform: "translate(0,0)"
});
var _ref1127 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CECFCD",
  transform: "translate(0,0)"
});
var _ref1128 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CDCBCC",
  transform: "translate(0,0)"
});
var _ref1129 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CCCECF",
  transform: "translate(0,0)"
});
var _ref1130 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CCCCCD",
  transform: "translate(0,0)"
});
var _ref1131 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CDCCCD",
  transform: "translate(0,0)"
});
var _ref1132 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1D4D1",
  transform: "translate(0,0)"
});
var _ref1133 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CECDCF",
  transform: "translate(0,0)"
});
var _ref1134 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D2D0",
  transform: "translate(0,0)"
});
var _ref1135 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFD0D0",
  transform: "translate(0,0)"
});
var _ref1136 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CACDCC",
  transform: "translate(0,0)"
});
var _ref1137 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CDCDCF",
  transform: "translate(0,0)"
});
var _ref1138 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCFD1",
  transform: "translate(0,0)"
});
var _ref1139 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CBCBCA",
  transform: "translate(0,0)"
});
var _ref1140 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D1CFD0",
  transform: "translate(0,0)"
});
var _ref1141 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CED0D0",
  transform: "translate(0,0)"
});
var _ref1142 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D0D1D0",
  transform: "translate(0,0)"
});
var _ref1143 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CFCFCE",
  transform: "translate(0,0)"
});
var _ref1144 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#C9C9CB",
  transform: "translate(0,0)"
});
var _ref1145 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#C7C7C7",
  transform: "translate(0,0)"
});
var _ref1146 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#C9CACC",
  transform: "translate(0,0)"
});
var _ref1147 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CAC8CA",
  transform: "translate(0,0)"
});
var _ref1148 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D5D7",
  transform: "translate(0,0)"
});
var _ref1149 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D7DB",
  transform: "translate(0,0)"
});
var _ref1150 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D6D5D6",
  transform: "translate(0,0)"
});
var _ref1151 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D7DA",
  transform: "translate(0,0)"
});
var _ref1152 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D8D6",
  transform: "translate(0,0)"
});
var _ref1153 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D8D8D8",
  transform: "translate(0,0)"
});
var _ref1154 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D9D8D8",
  transform: "translate(0,0)"
});
var _ref1155 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DADBDA",
  transform: "translate(0,0)"
});
var _ref1156 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DFDDDD",
  transform: "translate(0,0)"
});
var _ref1157 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#DAD9D8",
  transform: "translate(0,0)"
});
var _ref1158 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D1D3",
  transform: "translate(0,0)"
});
var _ref1159 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#969594",
  transform: "translate(0,0)"
});
var _ref1160 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#D4D4D3",
  transform: "translate(0,0)"
});
var _ref1161 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CBC9CA",
  transform: "translate(0,0)"
});
var _ref1162 = /*#__PURE__*/React.createElement("path", {
  d: "",
  fill: "#CCCBCC",
  transform: "translate(0,0)"
});
function SvgInfSimpleLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0, _ref1, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, _ref209, _ref210, _ref211, _ref212, _ref213, _ref214, _ref215, _ref216, _ref217, _ref218, _ref219, _ref220, _ref221, _ref222, _ref223, _ref224, _ref225, _ref226, _ref227, _ref228, _ref229, _ref230, _ref231, _ref232, _ref233, _ref234, _ref235, _ref236, _ref237, _ref238, _ref239, _ref240, _ref241, _ref242, _ref243, _ref244, _ref245, _ref246, _ref247, _ref248, _ref249, _ref250, _ref251, _ref252, _ref253, _ref254, _ref255, _ref256, _ref257, _ref258, _ref259, _ref260, _ref261, _ref262, _ref263, _ref264, _ref265, _ref266, _ref267, _ref268, _ref269, _ref270, _ref271, _ref272, _ref273, _ref274, _ref275, _ref276, _ref277, _ref278, _ref279, _ref280, _ref281, _ref282, _ref283, _ref284, _ref285, _ref286, _ref287, _ref288, _ref289, _ref290, _ref291, _ref292, _ref293, _ref294, _ref295, _ref296, _ref297, _ref298, _ref299, _ref300, _ref301, _ref302, _ref303, _ref304, _ref305, _ref306, _ref307, _ref308, _ref309, _ref310, _ref311, _ref312, _ref313, _ref314, _ref315, _ref316, _ref317, _ref318, _ref319, _ref320, _ref321, _ref322, _ref323, _ref324, _ref325, _ref326, _ref327, _ref328, _ref329, _ref330, _ref331, _ref332, _ref333, _ref334, _ref335, _ref336, _ref337, _ref338, _ref339, _ref340, _ref341, _ref342, _ref343, _ref344, _ref345, _ref346, _ref347, _ref348, _ref349, _ref350, _ref351, _ref352, _ref353, _ref354, _ref355, _ref356, _ref357, _ref358, _ref359, _ref360, _ref361, _ref362, _ref363, _ref364, _ref365, _ref366, _ref367, _ref368, _ref369, _ref370, _ref371, _ref372, _ref373, _ref374, _ref375, _ref376, _ref377, _ref378, _ref379, _ref380, _ref381, _ref382, _ref383, _ref384, _ref385, _ref386, _ref387, _ref388, _ref389, _ref390, _ref391, _ref392, _ref393, _ref394, _ref395, _ref396, _ref397, _ref398, _ref399, _ref400, _ref401, _ref402, _ref403, _ref404, _ref405, _ref406, _ref407, _ref408, _ref409, _ref410, _ref411, _ref412, _ref413, _ref414, _ref415, _ref416, _ref417, _ref418, _ref419, _ref420, _ref421, _ref422, _ref423, _ref424, _ref425, _ref426, _ref427, _ref428, _ref429, _ref430, _ref431, _ref432, _ref433, _ref434, _ref435, _ref436, _ref437, _ref438, _ref439, _ref440, _ref441, _ref442, _ref443, _ref444, _ref445, _ref446, _ref447, _ref448, _ref449, _ref450, _ref451, _ref452, _ref453, _ref454, _ref455, _ref456, _ref457, _ref458, _ref459, _ref460, _ref461, _ref462, _ref463, _ref464, _ref465, _ref466, _ref467, _ref468, _ref469, _ref470, _ref471, _ref472, _ref473, _ref474, _ref475, _ref476, _ref477, _ref478, _ref479, _ref480, _ref481, _ref482, _ref483, _ref484, _ref485, _ref486, _ref487, _ref488, _ref489, _ref490, _ref491, _ref492, _ref493, _ref494, _ref495, _ref496, _ref497, _ref498, _ref499, _ref500, _ref501, _ref502, _ref503, _ref504, _ref505, _ref506, _ref507, _ref508, _ref509, _ref510, _ref511, _ref512, _ref513, _ref514, _ref515, _ref516, _ref517, _ref518, _ref519, _ref520, _ref521, _ref522, _ref523, _ref524, _ref525, _ref526, _ref527, _ref528, _ref529, _ref530, _ref531, _ref532, _ref533, _ref534, _ref535, _ref536, _ref537, _ref538, _ref539, _ref540, _ref541, _ref542, _ref543, _ref544, _ref545, _ref546, _ref547, _ref548, _ref549, _ref550, _ref551, _ref552, _ref553, _ref554, _ref555, _ref556, _ref557, _ref558, _ref559, _ref560, _ref561, _ref562, _ref563, _ref564, _ref565, _ref566, _ref567, _ref568, _ref569, _ref570, _ref571, _ref572, _ref573, _ref574, _ref575, _ref576, _ref577, _ref578, _ref579, _ref580, _ref581, _ref582, _ref583, _ref584, _ref585, _ref586, _ref587, _ref588, _ref589, _ref590, _ref591, _ref592, _ref593, _ref594, _ref595, _ref596, _ref597, _ref598, _ref599, _ref600, _ref601, _ref602, _ref603, _ref604, _ref605, _ref606, _ref607, _ref608, _ref609, _ref610, _ref611, _ref612, _ref613, _ref614, _ref615, _ref616, _ref617, _ref618, _ref619, _ref620, _ref621, _ref622, _ref623, _ref624, _ref625, _ref626, _ref627, _ref628, _ref629, _ref630, _ref631, _ref632, _ref633, _ref634, _ref635, _ref636, _ref637, _ref638, _ref639, _ref640, _ref641, _ref642, _ref643, _ref644, _ref645, _ref646, _ref647, _ref648, _ref649, _ref650, _ref651, _ref652, _ref653, _ref654, _ref655, _ref656, _ref657, _ref658, _ref659, _ref660, _ref661, _ref662, _ref663, _ref664, _ref665, _ref666, _ref667, _ref668, _ref669, _ref670, _ref671, _ref672, _ref673, _ref674, _ref675, _ref676, _ref677, _ref678, _ref679, _ref680, _ref681, _ref682, _ref683, _ref684, _ref685, _ref686, _ref687, _ref688, _ref689, _ref690, _ref691, _ref692, _ref693, _ref694, _ref695, _ref696, _ref697, _ref698, _ref699, _ref700, _ref701, _ref702, _ref703, _ref704, _ref705, _ref706, _ref707, _ref708, _ref709, _ref710, _ref711, _ref712, _ref713, _ref714, _ref715, _ref716, _ref717, _ref718, _ref719, _ref720, _ref721, _ref722, _ref723, _ref724, _ref725, _ref726, _ref727, _ref728, _ref729, _ref730, _ref731, _ref732, _ref733, _ref734, _ref735, _ref736, _ref737, _ref738, _ref739, _ref740, _ref741, _ref742, _ref743, _ref744, _ref745, _ref746, _ref747, _ref748, _ref749, _ref750, _ref751, _ref752, _ref753, _ref754, _ref755, _ref756, _ref757, _ref758, _ref759, _ref760, _ref761, _ref762, _ref763, _ref764, _ref765, _ref766, _ref767, _ref768, _ref769, _ref770, _ref771, _ref772, _ref773, _ref774, _ref775, _ref776, _ref777, _ref778, _ref779, _ref780, _ref781, _ref782, _ref783, _ref784, _ref785, _ref786, _ref787, _ref788, _ref789, _ref790, _ref791, _ref792, _ref793, _ref794, _ref795, _ref796, _ref797, _ref798, _ref799, _ref800, _ref801, _ref802, _ref803, _ref804, _ref805, _ref806, _ref807, _ref808, _ref809, _ref810, _ref811, _ref812, _ref813, _ref814, _ref815, _ref816, _ref817, _ref818, _ref819, _ref820, _ref821, _ref822, _ref823, _ref824, _ref825, _ref826, _ref827, _ref828, _ref829, _ref830, _ref831, _ref832, _ref833, _ref834, _ref835, _ref836, _ref837, _ref838, _ref839, _ref840, _ref841, _ref842, _ref843, _ref844, _ref845, _ref846, _ref847, _ref848, _ref849, _ref850, _ref851, _ref852, _ref853, _ref854, _ref855, _ref856, _ref857, _ref858, _ref859, _ref860, _ref861, _ref862, _ref863, _ref864, _ref865, _ref866, _ref867, _ref868, _ref869, _ref870, _ref871, _ref872, _ref873, _ref874, _ref875, _ref876, _ref877, _ref878, _ref879, _ref880, _ref881, _ref882, _ref883, _ref884, _ref885, _ref886, _ref887, _ref888, _ref889, _ref890, _ref891, _ref892, _ref893, _ref894, _ref895, _ref896, _ref897, _ref898, _ref899, _ref900, _ref901, _ref902, _ref903, _ref904, _ref905, _ref906, _ref907, _ref908, _ref909, _ref910, _ref911, _ref912, _ref913, _ref914, _ref915, _ref916, _ref917, _ref918, _ref919, _ref920, _ref921, _ref922, _ref923, _ref924, _ref925, _ref926, _ref927, _ref928, _ref929, _ref930, _ref931, _ref932, _ref933, _ref934, _ref935, _ref936, _ref937, _ref938, _ref939, _ref940, _ref941, _ref942, _ref943, _ref944, _ref945, _ref946, _ref947, _ref948, _ref949, _ref950, _ref951, _ref952, _ref953, _ref954, _ref955, _ref956, _ref957, _ref958, _ref959, _ref960, _ref961, _ref962, _ref963, _ref964, _ref965, _ref966, _ref967, _ref968, _ref969, _ref970, _ref971, _ref972, _ref973, _ref974, _ref975, _ref976, _ref977, _ref978, _ref979, _ref980, _ref981, _ref982, _ref983, _ref984, _ref985, _ref986, _ref987, _ref988, _ref989, _ref990, _ref991, _ref992, _ref993, _ref994, _ref995, _ref996, _ref997, _ref998, _ref999, _ref1000, _ref1001, _ref1002, _ref1003, _ref1004, _ref1005, _ref1006, _ref1007, _ref1008, _ref1009, _ref1010, _ref1011, _ref1012, _ref1013, _ref1014, _ref1015, _ref1016, _ref1017, _ref1018, _ref1019, _ref1020, _ref1021, _ref1022, _ref1023, _ref1024, _ref1025, _ref1026, _ref1027, _ref1028, _ref1029, _ref1030, _ref1031, _ref1032, _ref1033, _ref1034, _ref1035, _ref1036, _ref1037, _ref1038, _ref1039, _ref1040, _ref1041, _ref1042, _ref1043, _ref1044, _ref1045, _ref1046, _ref1047, _ref1048, _ref1049, _ref1050, _ref1051, _ref1052, _ref1053, _ref1054, _ref1055, _ref1056, _ref1057, _ref1058, _ref1059, _ref1060, _ref1061, _ref1062, _ref1063, _ref1064, _ref1065, _ref1066, _ref1067, _ref1068, _ref1069, _ref1070, _ref1071, _ref1072, _ref1073, _ref1074, _ref1075, _ref1076, _ref1077, _ref1078, _ref1079, _ref1080, _ref1081, _ref1082, _ref1083, _ref1084, _ref1085, _ref1086, _ref1087, _ref1088, _ref1089, _ref1090, _ref1091, _ref1092, _ref1093, _ref1094, _ref1095, _ref1096, _ref1097, _ref1098, _ref1099, _ref1100, _ref1101, _ref1102, _ref1103, _ref1104, _ref1105, _ref1106, _ref1107, _ref1108, _ref1109, _ref1110, _ref1111, _ref1112, _ref1113, _ref1114, _ref1115, _ref1116, _ref1117, _ref1118, _ref1119, _ref1120, _ref1121, _ref1122, _ref1123, _ref1124, _ref1125, _ref1126, _ref1127, _ref1128, _ref1129, _ref1130, _ref1131, _ref1132, _ref1133, _ref1134, _ref1135, _ref1136, _ref1137, _ref1138, _ref1139, _ref1140, _ref1141, _ref1142, _ref1143, _ref1144, _ref1145, _ref1146, _ref1147, _ref1148, _ref1149, _ref1150, _ref1151, _ref1152, _ref1153, _ref1154, _ref1155, _ref1156, _ref1157, _ref1158, _ref1159, _ref1160, _ref1161, _ref1162);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfSimpleLogo2);
export default __webpack_public_path__ + "static/media/INF-simple-Logo2.ca1f8279dbef1886ebdc5a9e8b8b1c6e.svg";
export { ForwardRef as ReactComponent };